const areaList = [
    {"label": "北京市", "value": "110000", "parentId": "root"},
    {"label": "市辖区", "value": "110100", "parentId": "110000"},
    {"label": "东城区", "value": "110101", "parentId": "110100"},
    {"label": "西城区", "value": "110102", "parentId": "110100"},
    {"label": "崇文区", "value": "110103", "parentId": "110100"},
    {"label": "宣武区", "value": "110104", "parentId": "110100"},
    {"label": "朝阳区", "value": "110105", "parentId": "110100"},
    {"label": "丰台区", "value": "110106", "parentId": "110100"},
    {"label": "石景山区", "value": "110107", "parentId": "110100"},
    {"label": "海淀区", "value": "110108", "parentId": "110100"},
    {"label": "门头沟区", "value": "110109", "parentId": "110100"},
    {"label": "房山区", "value": "110111", "parentId": "110100"},
    {"label": "通州区", "value": "110112", "parentId": "110100"},
    {"label": "顺义区", "value": "110113", "parentId": "110100"},
    {"label": "昌平区", "value": "110114", "parentId": "110100"},
    {"label": "大兴区", "value": "110115", "parentId": "110100"},
    {"label": "怀柔区", "value": "110116", "parentId": "110100"},
    {"label": "平谷区", "value": "110117", "parentId": "110100"},
    {"label": "县", "value": "110200", "parentId": "110000"}, 
    {"label": "密云县", "value": "110228", "parentId": "110200"},
    {"label": "延庆县", "value": "110229", "parentId": "110200"},
    {"label": "天津市", "value": "120000", "parentId": "root"},
    {"label": "市辖区", "value": "120100", "parentId": "120000"},
    {"label": "和平区", "value": "120101", "parentId": "120100"},
    {"label": "河东区", "value": "120102", "parentId": "120100"},
    {"label": "河西区", "value": "120103", "parentId": "120100"},
    {"label": "南开区", "value": "120104", "parentId": "120100"},
    {"label": "河北区", "value": "120105", "parentId": "120100"},
    {"label": "红桥区", "value": "120106", "parentId": "120100"},
    {"label": "塘沽区", "value": "120107", "parentId": "120100"},
    {"label": "汉沽区", "value": "120108", "parentId": "120100"},
    {"label": "大港区", "value": "120109", "parentId": "120100"},
    {"label": "东丽区", "value": "120110", "parentId": "120100"},
    {"label": "西青区", "value": "120111", "parentId": "120100"},
    {"label": "津南区", "value": "120112", "parentId": "120100"},
    {"label": "北辰区", "value": "120113", "parentId": "120100"},
    {"label": "武清区", "value": "120114", "parentId": "120100"},
    {"label": "宝坻区", "value": "120115", "parentId": "120100"},
    {"label": "县", "value": "120200", "parentId": "120000"},
    {"label": "宁河县", "value": "120221", "parentId": "120200"},
    {"label": "静海县", "value": "120223", "parentId": "120200"},
    {"label": "蓟县", "value": "120225", "parentId": "120200"},
    {"label": "河北省", "value": "130000", "parentId": "root"},
    {"label": "石家庄市", "value": "130100", "parentId": "130000"},
    {"label": "市辖区", "value": "130101", "parentId": "130100"},
    {"label": "长安区", "value": "130102", "parentId": "130100"},
    {"label": "桥东区", "value": "130103", "parentId": "130100"},
    {"label": "桥西区", "value": "130104", "parentId": "130100"},
    {"label": "新华区", "value": "130105", "parentId": "130100"},
    {"label": "井陉矿区", "value": "130107", "parentId": "130100"},
    {"label": "裕华区", "value": "130108", "parentId": "130100"},
    {"label": "井陉县", "value": "130121", "parentId": "130100"},
    {"label": "正定县", "value": "130123", "parentId": "130100"},
    {"label": "栾城县", "value": "130124", "parentId": "130100"},
    {"label": "行唐县", "value": "130125", "parentId": "130100"},
    {"label": "灵寿县", "value": "130126", "parentId": "130100"},
    {"label": "高邑县", "value": "130127", "parentId": "130100"},
    {"label": "深泽县", "value": "130128", "parentId": "130100"},
    {"label": "赞皇县", "value": "130129", "parentId": "130100"},
    {"label": "无极县", "value": "130130", "parentId": "130100"},
    {"label": "平山县", "value": "130131", "parentId": "130100"},
    {"label": "元氏县", "value": "130132", "parentId": "130100"},
    {"label": "赵县", "value": "130133", "parentId": "130100"},
    {"label": "辛集市", "value": "130181", "parentId": "130100"},
    {"label": "藁城市", "value": "130182", "parentId": "130100"},
    {"label": "晋州市", "value": "130183", "parentId": "130100"},
    {"label": "新乐市", "value": "130184", "parentId": "130100"},
    {"label": "鹿泉市", "value": "130185", "parentId": "130100"},
    {"label": "唐山市", "value": "130200", "parentId": "130000"},
    {"label": "市辖区", "value": "130201", "parentId": "130200"},
    {"label": "路南区", "value": "130202", "parentId": "130200"},
    {"label": "路北区", "value": "130203", "parentId": "130200"},
    {"label": "古冶区", "value": "130204", "parentId": "130200"},
    {"label": "开平区", "value": "130205", "parentId": "130200"},
    {"label": "丰南区", "value": "130207", "parentId": "130200"},
    {"label": "丰润区", "value": "130208", "parentId": "130200"},
    {"label": "滦县", "value": "130223", "parentId": "130200"},
    {"label": "滦南县", "value": "130224", "parentId": "130200"},
    {"label": "乐亭县", "value": "130225", "parentId": "130200"},
    {"label": "迁西县", "value": "130227", "parentId": "130200"},
    {"label": "玉田县", "value": "130229", "parentId": "130200"},
    {"label": "唐海县", "value": "130230", "parentId": "130200"},
    {"label": "遵化市", "value": "130281", "parentId": "130200"},
    {"label": "迁安市", "value": "130283", "parentId": "130200"},
    {"label": "秦皇岛市", "value": "130300", "parentId": "130000"},
    {"label": "市辖区", "value": "130301", "parentId": "130300"},
    {"label": "海港区", "value": "130302", "parentId": "130300"},
    {"label": "山海关区", "value": "130303", "parentId": "130300"},
    {"label": "北戴河区", "value": "130304", "parentId": "130300"},
    {"label": "青龙满族自治县", "value": "130321", "parentId": "130300"},
    {"label": "昌黎县", "value": "130322", "parentId": "130300"},
    {"label": "抚宁县", "value": "130323", "parentId": "130300"},
    {"label": "卢龙县", "value": "130324", "parentId": "130300"},
    {"label": "邯郸市", "value": "130400", "parentId": "130000"},
    {"label": "市辖区", "value": "130401", "parentId": "130400"},
    {"label": "邯山区", "value": "130402", "parentId": "130400"},
    {"label": "丛台区", "value": "130403", "parentId": "130400"},
    {"label": "复兴区", "value": "130404", "parentId": "130400"},
    {"label": "峰峰矿区", "value": "130406", "parentId": "130400"},
    {"label": "邯郸县", "value": "130421", "parentId": "130400"},
    {"label": "临漳县", "value": "130423", "parentId": "130400"},
    {"label": "成安县", "value": "130424", "parentId": "130400"},
    {"label": "大名县", "value": "130425", "parentId": "130400"},
    {"label": "涉县", "value": "130426", "parentId": "130400"},
    {"label": "磁县", "value": "130427", "parentId": "130400"},
    {"label": "肥乡县", "value": "130428", "parentId": "130400"},
    {"label": "永年县", "value": "130429", "parentId": "130400"},
    {"label": "邱县", "value": "130430", "parentId": "130400"},
    {"label": "鸡泽县", "value": "130431", "parentId": "130400"},
    {"label": "广平县", "value": "130432", "parentId": "130400"},
    {"label": "馆陶县", "value": "130433", "parentId": "130400"},
    {"label": "魏县", "value": "130434", "parentId": "130400"},
    {"label": "曲周县", "value": "130435", "parentId": "130400"},
    {"label": "武安市", "value": "130481", "parentId": "130400"},
    {"label": "邢台市", "value": "130500", "parentId": "130000"},
    {"label": "市辖区", "value": "130501", "parentId": "130500"},
    {"label": "桥东区", "value": "130502", "parentId": "130500"},
    {"label": "桥西区", "value": "130503", "parentId": "130500"},
    {"label": "邢台县", "value": "130521", "parentId": "130500"},
    {"label": "临城县", "value": "130522", "parentId": "130500"},
    {"label": "内丘县", "value": "130523", "parentId": "130500"},
    {"label": "柏乡县", "value": "130524", "parentId": "130500"},
    {"label": "隆尧县", "value": "130525", "parentId": "130500"},
    {"label": "任县", "value": "130526", "parentId": "130500"},
    {"label": "南和县", "value": "130527", "parentId": "130500"},
    {"label": "宁晋县", "value": "130528", "parentId": "130500"},
    {"label": "巨鹿县", "value": "130529", "parentId": "130500"},
    {"label": "新河县", "value": "130530", "parentId": "130500"},
    {"label": "广宗县", "value": "130531", "parentId": "130500"},
    {"label": "平乡县", "value": "130532", "parentId": "130500"},
    {"label": "威县", "value": "130533", "parentId": "130500"},
    {"label": "清河县", "value": "130534", "parentId": "130500"},
    {"label": "临西县", "value": "130535", "parentId": "130500"},
    {"label": "南宫市", "value": "130581", "parentId": "130500"},
    {"label": "沙河市", "value": "130582", "parentId": "130500"},
    {"label": "保定市", "value": "130600", "parentId": "130000"},
    {"label": "市辖区", "value": "130601", "parentId": "130600"},
    {"label": "新市区", "value": "130602", "parentId": "130600"},
    {"label": "北市区", "value": "130603", "parentId": "130600"},
    {"label": "南市区", "value": "130604", "parentId": "130600"},
    {"label": "满城县", "value": "130621", "parentId": "130600"},
    {"label": "清苑县", "value": "130622", "parentId": "130600"},
    {"label": "涞水县", "value": "130623", "parentId": "130600"},
    {"label": "阜平县", "value": "130624", "parentId": "130600"},
    {"label": "徐水县", "value": "130625", "parentId": "130600"},
    {"label": "定兴县", "value": "130626", "parentId": "130600"},
    {"label": "唐县", "value": "130627", "parentId": "130600"},
    {"label": "高阳县", "value": "130628", "parentId": "130600"},
    {"label": "容城县", "value": "130629", "parentId": "130600"},
    {"label": "涞源县", "value": "130630", "parentId": "130600"},
    {"label": "望都县", "value": "130631", "parentId": "130600"},
    {"label": "安新县", "value": "130632", "parentId": "130600"},
    {"label": "易县", "value": "130633", "parentId": "130600"},
    {"label": "曲阳县", "value": "130634", "parentId": "130600"},
    {"label": "蠡县", "value": "130635", "parentId": "130600"},
    {"label": "顺平县", "value": "130636", "parentId": "130600"},
    {"label": "博野县", "value": "130637", "parentId": "130600"},
    {"label": "雄县", "value": "130638", "parentId": "130600"},
    {"label": "涿州市", "value": "130681", "parentId": "130600"},
    {"label": "定州市", "value": "130682", "parentId": "130600"},
    {"label": "安国市", "value": "130683", "parentId": "130600"},
    {"label": "高碑店市", "value": "130684", "parentId": "130600"},
    {"label": "张家口市", "value": "130700", "parentId": "130000"},
    {"label": "市辖区", "value": "130701", "parentId": "130700"},
    {"label": "桥东区", "value": "130702", "parentId": "130700"},
    {"label": "桥西区", "value": "130703", "parentId": "130700"},
    {"label": "宣化区", "value": "130705", "parentId": "130700"},
    {"label": "下花园区", "value": "130706", "parentId": "130700"},
    {"label": "宣化县", "value": "130721", "parentId": "130700"},
    {"label": "张北县", "value": "130722", "parentId": "130700"},
    {"label": "康保县", "value": "130723", "parentId": "130700"},
    {"label": "沽源县", "value": "130724", "parentId": "130700"},
    {"label": "尚义县", "value": "130725", "parentId": "130700"},
    {"label": "蔚县", "value": "130726", "parentId": "130700"},
    {"label": "阳原县", "value": "130727", "parentId": "130700"},
    {"label": "怀安县", "value": "130728", "parentId": "130700"},
    {"label": "万全县", "value": "130729", "parentId": "130700"},
    {"label": "怀来县", "value": "130730", "parentId": "130700"},
    {"label": "涿鹿县", "value": "130731", "parentId": "130700"},
    {"label": "赤城县", "value": "130732", "parentId": "130700"},
    {"label": "崇礼县", "value": "130733", "parentId": "130700"},
    {"label": "承德市", "value": "130800", "parentId": "130000"},
    {"label": "市辖区", "value": "130801", "parentId": "130800"},
    {"label": "双桥区", "value": "130802", "parentId": "130800"},
    {"label": "双滦区", "value": "130803", "parentId": "130800"},
    {"label": "鹰手营子矿区", "value": "130804", "parentId": "130800"},
    {"label": "承德县", "value": "130821", "parentId": "130800"},
    {"label": "兴隆县", "value": "130822", "parentId": "130800"},
    {"label": "平泉县", "value": "130823", "parentId": "130800"},
    {"label": "滦平县", "value": "130824", "parentId": "130800"},
    {"label": "隆化县", "value": "130825", "parentId": "130800"},
    {"label": "丰宁满族自治县", "value": "130826", "parentId": "130800"},
    {"label": "宽城满族自治县", "value": "130827", "parentId": "130800"},
    {"label": "围场满族蒙古族自治县", "value": "130828", "parentId": "130800"},
    {"label": "沧州市", "value": "130900", "parentId": "130000"},
    {"label": "市辖区", "value": "130901", "parentId": "130900"},
    {"label": "新华区", "value": "130902", "parentId": "130900"},
    {"label": "运河区", "value": "130903", "parentId": "130900"},
    {"label": "沧县", "value": "130921", "parentId": "130900"},
    {"label": "青县", "value": "130922", "parentId": "130900"},
    {"label": "东光县", "value": "130923", "parentId": "130900"},
    {"label": "海兴县", "value": "130924", "parentId": "130900"},
    {"label": "盐山县", "value": "130925", "parentId": "130900"},
    {"label": "肃宁县", "value": "130926", "parentId": "130900"},
    {"label": "南皮县", "value": "130927", "parentId": "130900"},
    {"label": "吴桥县", "value": "130928", "parentId": "130900"},
    {"label": "献县", "value": "130929", "parentId": "130900"},
    {"label": "孟村回族自治县", "value": "130930", "parentId": "130900"},
    {"label": "泊头市", "value": "130981", "parentId": "130900"},
    {"label": "任丘市", "value": "130982", "parentId": "130900"},
    {"label": "黄骅市", "value": "130983", "parentId": "130900"},
    {"label": "河间市", "value": "130984", "parentId": "130900"},
    {"label": "廊坊市", "value": "131000", "parentId": "130000"},
    {"label": "市辖区", "value": "131001", "parentId": "131000"},
    {"label": "安次区", "value": "131002", "parentId": "131000"},
    {"label": "广阳区", "value": "131003", "parentId": "131000"},
    {"label": "固安县", "value": "131022", "parentId": "131000"},
    {"label": "永清县", "value": "131023", "parentId": "131000"},
    {"label": "香河县", "value": "131024", "parentId": "131000"},
    {"label": "大城县", "value": "131025", "parentId": "131000"},
    {"label": "文安县", "value": "131026", "parentId": "131000"},
    {"label": "大厂回族自治县", "value": "131028", "parentId": "131000"},
    {"label": "霸州市", "value": "131081", "parentId": "131000"},
    {"label": "三河市", "value": "131082", "parentId": "131000"},
    {"label": "衡水市", "value": "131100", "parentId": "130000"},
    {"label": "市辖区", "value": "131101", "parentId": "131100"},
    {"label": "桃城区", "value": "131102", "parentId": "131100"},
    {"label": "枣强县", "value": "131121", "parentId": "131100"},
    {"label": "武邑县", "value": "131122", "parentId": "131100"},
    {"label": "武强县", "value": "131123", "parentId": "131100"},
    {"label": "饶阳县", "value": "131124", "parentId": "131100"},
    {"label": "安平县", "value": "131125", "parentId": "131100"},
    {"label": "故城县", "value": "131126", "parentId": "131100"},
    {"label": "景县", "value": "131127", "parentId": "131100"},
    {"label": "阜城县", "value": "131128", "parentId": "131100"},
    {"label": "冀州市", "value": "131181", "parentId": "131100"},
    {"label": "深州市", "value": "131182", "parentId": "131100"},
    {"label": "山西省", "value": "140000", "parentId": "root"},
    {"label": "太原市", "value": "140100", "parentId": "140000"},
    {"label": "市辖区", "value": "140101", "parentId": "140100"},
    {"label": "杏花岭区", "value": "140107", "parentId": "140100"},
    {"label": "迎泽区", "value": "140106", "parentId": "140100"},
    {"label": "尖草坪区", "value": "140108", "parentId": "140100"},
    {"label": "万柏林区", "value": "140109", "parentId": "140100"},
    {"label": "晋源区", "value": "140110", "parentId": "140100"},
    {"label": "小店区", "value": "140105", "parentId": "140100"},
    {"label": "古交市", "value": "140181", "parentId": "140100"},
    {"label": "清徐县", "value": "140121", "parentId": "140100"},
    {"label": "阳曲县", "value": "140122", "parentId": "140100"},
    {"label": "娄烦县", "value": "140123", "parentId": "140100"},
    {"label": "不锈钢园区", "value": "141191", "parentId": "140100"},
    {"label": "综改区", "value": "140103", "parentId": "140100"},
    {"label": "大同市", "value": "140200", "parentId": "140000"},
    {"label": "市辖区", "value": "140201", "parentId": "140200"},
    {"label": "城区", "value": "140202", "parentId": "140200"},
    {"label": "矿区", "value": "140203", "parentId": "140200"},
    {"label": "南郊区", "value": "140211", "parentId": "140200"},
    {"label": "新荣区", "value": "140212", "parentId": "140200"},
    {"label": "阳高县", "value": "140221", "parentId": "140200"},
    {"label": "天镇县", "value": "140222", "parentId": "140200"},
    {"label": "广灵县", "value": "140223", "parentId": "140200"},
    {"label": "灵丘县", "value": "140224", "parentId": "140200"},
    {"label": "浑源县", "value": "140225", "parentId": "140200"},
    {"label": "左云县", "value": "140226", "parentId": "140200"},
    {"label": "大同县", "value": "140227", "parentId": "140200"},
    {"label": "阳泉市", "value": "140300", "parentId": "140000"},
    {"label": "市辖区", "value": "140301", "parentId": "140300"},
    {"label": "城区", "value": "140302", "parentId": "140300"},
    {"label": "矿区", "value": "140303", "parentId": "140300"},
    {"label": "郊区", "value": "140311", "parentId": "140300"},
    {"label": "平定县", "value": "140321", "parentId": "140300"},
    {"label": "盂县", "value": "140322", "parentId": "140300"},
    {"label": "经济技术开发区", "value": "140304", "parentId": "140300"},
    {"label": "长治市", "value": "140400", "parentId": "140000"},
    {"label": "市辖区", "value": "140401", "parentId": "140400"},
    {"label": "城区", "value": "140402", "parentId": "140400"},
    {"label": "郊区", "value": "140411", "parentId": "140400"},
    {"label": "长治县", "value": "140421", "parentId": "140400"},
    {"label": "襄垣县", "value": "140423", "parentId": "140400"},
    {"label": "屯留县", "value": "140424", "parentId": "140400"},
    {"label": "平顺县", "value": "140425", "parentId": "140400"},
    {"label": "黎城县", "value": "140426", "parentId": "140400"},
    {"label": "壶关县", "value": "140427", "parentId": "140400"},
    {"label": "长子县", "value": "140428", "parentId": "140400"},
    {"label": "武乡县", "value": "140429", "parentId": "140400"},
    {"label": "沁县", "value": "140430", "parentId": "140400"},
    {"label": "沁源县", "value": "140431", "parentId": "140400"},
    {"label": "潞城市", "value": "140481", "parentId": "140400"},
    {"label": "晋城市", "value": "140500", "parentId": "140000"},
    {"label": "市辖区", "value": "140501", "parentId": "140500"},
    {"label": "城区", "value": "140502", "parentId": "140500"},
    {"label": "沁水县", "value": "140521", "parentId": "140500"},
    {"label": "阳城县", "value": "140522", "parentId": "140500"},
    {"label": "陵川县", "value": "140524", "parentId": "140500"},
    {"label": "泽州县", "value": "140525", "parentId": "140500"},
    {"label": "高平市", "value": "140581", "parentId": "140500"},
    {"label": "朔州市", "value": "140600", "parentId": "140000"},
    {"label": "市辖区", "value": "140601", "parentId": "140600"},
    {"label": "朔城区", "value": "140602", "parentId": "140600"},
    {"label": "平鲁区", "value": "140603", "parentId": "140600"},
    {"label": "山阴县", "value": "140621", "parentId": "140600"},
    {"label": "应县", "value": "140622", "parentId": "140600"},
    {"label": "右玉县", "value": "140623", "parentId": "140600"},
    {"label": "怀仁县", "value": "140624", "parentId": "140600"},
    {"label": "晋中市", "value": "140700", "parentId": "140000"},
    {"label": "市辖区", "value": "140701", "parentId": "140700"},
    {"label": "榆次区", "value": "140702", "parentId": "140700"},
    {"label": "榆社县", "value": "140721", "parentId": "140700"},
    {"label": "左权县", "value": "140722", "parentId": "140700"},
    {"label": "和顺县", "value": "140723", "parentId": "140700"},
    {"label": "昔阳县", "value": "140724", "parentId": "140700"},
    {"label": "寿阳县", "value": "140725", "parentId": "140700"},
    {"label": "太谷县", "value": "140726", "parentId": "140700"},
    {"label": "祁县", "value": "140727", "parentId": "140700"},
    {"label": "平遥县", "value": "140728", "parentId": "140700"},
    {"label": "灵石县", "value": "140729", "parentId": "140700"},
    {"label": "介休市", "value": "140781", "parentId": "140700"},
    {"label": "运城市", "value": "140800", "parentId": "140000"},
    {"label": "市辖区", "value": "140801", "parentId": "140800"},
    {"label": "盐湖区", "value": "140802", "parentId": "140800"},
    {"label": "临猗县", "value": "140821", "parentId": "140800"},
    {"label": "万荣县", "value": "140822", "parentId": "140800"},
    {"label": "闻喜县", "value": "140823", "parentId": "140800"},
    {"label": "稷山县", "value": "140824", "parentId": "140800"},
    {"label": "新绛县", "value": "140825", "parentId": "140800"},
    {"label": "绛县", "value": "140826", "parentId": "140800"},
    {"label": "垣曲县", "value": "140827", "parentId": "140800"},
    {"label": "夏县", "value": "140828", "parentId": "140800"},
    {"label": "平陆县", "value": "140829", "parentId": "140800"},
    {"label": "芮城县", "value": "140830", "parentId": "140800"},
    {"label": "永济市", "value": "140881", "parentId": "140800"},
    {"label": "河津市", "value": "140882", "parentId": "140800"},
    {"label": "忻州市", "value": "140900", "parentId": "140000"},
    {"label": "市辖区", "value": "140901", "parentId": "140900"},
    {"label": "忻府区", "value": "140902", "parentId": "140900"},
    {"label": "定襄县", "value": "140921", "parentId": "140900"},
    {"label": "五台县", "value": "140922", "parentId": "140900"},
    {"label": "代县", "value": "140923", "parentId": "140900"},
    {"label": "繁峙县", "value": "140924", "parentId": "140900"},
    {"label": "宁武县", "value": "140925", "parentId": "140900"},
    {"label": "静乐县", "value": "140926", "parentId": "140900"},
    {"label": "神池县", "value": "140927", "parentId": "140900"},
    {"label": "五寨县", "value": "140928", "parentId": "140900"},
    {"label": "岢岚县", "value": "140929", "parentId": "140900"},
    {"label": "河曲县", "value": "140930", "parentId": "140900"},
    {"label": "保德县", "value": "140931", "parentId": "140900"},
    {"label": "偏关县", "value": "140932", "parentId": "140900"},
    {"label": "原平市", "value": "140981", "parentId": "140900"},
    {"label": "临汾市", "value": "141000", "parentId": "140000"},
    {"label": "市辖区", "value": "141001", "parentId": "141000"},
    {"label": "尧都区", "value": "141002", "parentId": "141000"},
    {"label": "曲沃县", "value": "141021", "parentId": "141000"},
    {"label": "翼城县", "value": "141022", "parentId": "141000"},
    {"label": "襄汾县", "value": "141023", "parentId": "141000"},
    {"label": "洪洞县", "value": "141024", "parentId": "141000"},
    {"label": "古县", "value": "141025", "parentId": "141000"},
    {"label": "安泽县", "value": "141026", "parentId": "141000"},
    {"label": "浮山县", "value": "141027", "parentId": "141000"},
    {"label": "吉县", "value": "141028", "parentId": "141000"},
    {"label": "乡宁县", "value": "141029", "parentId": "141000"},
    {"label": "大宁县", "value": "141030", "parentId": "141000"},
    {"label": "隰县", "value": "141031", "parentId": "141000"},
    {"label": "永和县", "value": "141032", "parentId": "141000"},
    {"label": "蒲县", "value": "141033", "parentId": "141000"},
    {"label": "汾西县", "value": "141034", "parentId": "141000"},
    {"label": "侯马市", "value": "141081", "parentId": "141000"},
    {"label": "霍州市", "value": "141082", "parentId": "141000"},
    {"label": "吕梁市", "value": "141100", "parentId": "140000"},
    {"label": "市辖区", "value": "141101", "parentId": "141100"},
    {"label": "离石区", "value": "141102", "parentId": "141100"},
    {"label": "文水县", "value": "141121", "parentId": "141100"},
    {"label": "交城县", "value": "141122", "parentId": "141100"},
    {"label": "兴县", "value": "141123", "parentId": "141100"},
    {"label": "临县", "value": "141124", "parentId": "141100"},
    {"label": "柳林县", "value": "141125", "parentId": "141100"},
    {"label": "石楼县", "value": "141126", "parentId": "141100"},
    {"label": "岚县", "value": "141127", "parentId": "141100"},
    {"label": "方山县", "value": "141128", "parentId": "141100"},
    {"label": "中阳县", "value": "141129", "parentId": "141100"},
    {"label": "交口县", "value": "141130", "parentId": "141100"},
    {"label": "孝义市", "value": "141181", "parentId": "141100"},
    {"label": "汾阳市", "value": "141182", "parentId": "141100"},
    {"label": "内蒙古自治区", "value": "150000", "parentId": "root"},
    {"label": "呼和浩特市", "value": "150100", "parentId": "150000"},
    {"label": "市辖区", "value": "150101", "parentId": "150100"},
    {"label": "新城区", "value": "150102", "parentId": "150100"},
    {"label": "回民区", "value": "150103", "parentId": "150100"},
    {"label": "玉泉区", "value": "150104", "parentId": "150100"},
    {"label": "赛罕区", "value": "150105", "parentId": "150100"},
    {"label": "土默特左旗", "value": "150121", "parentId": "150100"},
    {"label": "托克托县", "value": "150122", "parentId": "150100"},
    {"label": "和林格尔县", "value": "150123", "parentId": "150100"},
    {"label": "清水河县", "value": "150124", "parentId": "150100"},
    {"label": "武川县", "value": "150125", "parentId": "150100"},
    {"label": "包头市", "value": "150200", "parentId": "150000"},
    {"label": "市辖区", "value": "150201", "parentId": "150200"},
    {"label": "东河区", "value": "150202", "parentId": "150200"},
    {"label": "昆都仑区", "value": "150203", "parentId": "150200"},
    {"label": "青山区", "value": "150204", "parentId": "150200"},
    {"label": "石拐区", "value": "150205", "parentId": "150200"},
    {"label": "白云矿区", "value": "150206", "parentId": "150200"},
    {"label": "九原区", "value": "150207", "parentId": "150200"},
    {"label": "土默特右旗", "value": "150221", "parentId": "150200"},
    {"label": "固阳县", "value": "150222", "parentId": "150200"},
    {"label": "达尔罕茂明安联合旗", "value": "150223", "parentId": "150200"},
    {"label": "乌海市", "value": "150300", "parentId": "150000"},
    {"label": "市辖区", "value": "150301", "parentId": "150300"},
    {"label": "海勃湾区", "value": "150302", "parentId": "150300"},
    {"label": "海南区", "value": "150303", "parentId": "150300"},
    {"label": "乌达区", "value": "150304", "parentId": "150300"},
    {"label": "赤峰市", "value": "150400", "parentId": "150000"},
    {"label": "市辖区", "value": "150401", "parentId": "150400"},
    {"label": "红山区", "value": "150402", "parentId": "150400"},
    {"label": "元宝山区", "value": "150403", "parentId": "150400"},
    {"label": "松山区", "value": "150404", "parentId": "150400"},
    {"label": "阿鲁科尔沁旗", "value": "150421", "parentId": "150400"},
    {"label": "巴林左旗", "value": "150422", "parentId": "150400"},
    {"label": "巴林右旗", "value": "150423", "parentId": "150400"},
    {"label": "林西县", "value": "150424", "parentId": "150400"},
    {"label": "克什克腾旗", "value": "150425", "parentId": "150400"},
    {"label": "翁牛特旗", "value": "150426", "parentId": "150400"},
    {"label": "喀喇沁旗", "value": "150428", "parentId": "150400"},
    {"label": "宁城县", "value": "150429", "parentId": "150400"},
    {"label": "敖汉旗", "value": "150430", "parentId": "150400"},
    {"label": "通辽市", "value": "150500", "parentId": "150000"},
    {"label": "市辖区", "value": "150501", "parentId": "150500"},
    {"label": "科尔沁区", "value": "150502", "parentId": "150500"},
    {"label": "科尔沁左翼中旗", "value": "150521", "parentId": "150500"},
    {"label": "科尔沁左翼后旗", "value": "150522", "parentId": "150500"},
    {"label": "开鲁县", "value": "150523", "parentId": "150500"},
    {"label": "库伦旗", "value": "150524", "parentId": "150500"},
    {"label": "奈曼旗", "value": "150525", "parentId": "150500"},
    {"label": "扎鲁特旗", "value": "150526", "parentId": "150500"},
    {"label": "霍林郭勒市", "value": "150581", "parentId": "150500"},
    {"label": "鄂尔多斯市", "value": "150600", "parentId": "150000"},
    {"label": "东胜区", "value": "150602", "parentId": "150600"},
    {"label": "达拉特旗", "value": "150621", "parentId": "150600"},
    {"label": "准格尔旗", "value": "150622", "parentId": "150600"},
    {"label": "鄂托克前旗", "value": "150623", "parentId": "150600"},
    {"label": "鄂托克旗", "value": "150624", "parentId": "150600"},
    {"label": "杭锦旗", "value": "150625", "parentId": "150600"},
    {"label": "乌审旗", "value": "150626", "parentId": "150600"},
    {"label": "伊金霍洛旗", "value": "150627", "parentId": "150600"},
    {"label": "呼伦贝尔市", "value": "150700", "parentId": "150000"},
    {"label": "市辖区", "value": "150701", "parentId": "150700"},
    {"label": "海拉尔区", "value": "150702", "parentId": "150700"},
    {"label": "阿荣旗", "value": "150721", "parentId": "150700"},
    {"label": "莫力达瓦达斡尔族自治旗", "value": "150722", "parentId": "150700"},
    {"label": "鄂伦春自治旗", "value": "150723", "parentId": "150700"},
    {"label": "鄂温克族自治旗", "value": "150724", "parentId": "150700"},
    {"label": "陈巴尔虎旗", "value": "150725", "parentId": "150700"},
    {"label": "新巴尔虎左旗", "value": "150726", "parentId": "150700"},
    {"label": "新巴尔虎右旗", "value": "150727", "parentId": "150700"},
    {"label": "满洲里市", "value": "150781", "parentId": "150700"},
    {"label": "牙克石市", "value": "150782", "parentId": "150700"},
    {"label": "扎兰屯市", "value": "150783", "parentId": "150700"},
    {"label": "额尔古纳市", "value": "150784", "parentId": "150700"},
    {"label": "根河市", "value": "150785", "parentId": "150700"},
    {"label": "巴彦淖尔市", "value": "150800", "parentId": "150000"},
    {"label": "市辖区", "value": "150801", "parentId": "150800"},
    {"label": "临河区", "value": "150802", "parentId": "150800"},
    {"label": "五原县", "value": "150821", "parentId": "150800"},
    {"label": "磴口县", "value": "150822", "parentId": "150800"},
    {"label": "乌拉特前旗", "value": "150823", "parentId": "150800"},
    {"label": "乌拉特中旗", "value": "150824", "parentId": "150800"},
    {"label": "乌拉特后旗", "value": "150825", "parentId": "150800"},
    {"label": "杭锦后旗", "value": "150826", "parentId": "150800"},
    {"label": "乌兰察布市", "value": "150900", "parentId": "150000"},
    {"label": "市辖区", "value": "150901", "parentId": "150900"},
    {"label": "集宁区", "value": "150902", "parentId": "150900"},
    {"label": "卓资县", "value": "150921", "parentId": "150900"},
    {"label": "化德县", "value": "150922", "parentId": "150900"},
    {"label": "商都县", "value": "150923", "parentId": "150900"},
    {"label": "兴和县", "value": "150924", "parentId": "150900"},
    {"label": "凉城县", "value": "150925", "parentId": "150900"},
    {"label": "察哈尔右翼前旗", "value": "150926", "parentId": "150900"},
    {"label": "察哈尔右翼中旗", "value": "150927", "parentId": "150900"},
    {"label": "察哈尔右翼后旗", "value": "150928", "parentId": "150900"},
    {"label": "四子王旗", "value": "150929", "parentId": "150900"},
    {"label": "丰镇市", "value": "150981", "parentId": "150900"},
    {"label": "兴安盟", "value": "152200", "parentId": "150000"},
    {"label": "乌兰浩特市", "value": "152201", "parentId": "152200"},
    {"label": "阿尔山市", "value": "152202", "parentId": "152200"},
    {"label": "科尔沁右翼前旗", "value": "152221", "parentId": "152200"},
    {"label": "科尔沁右翼中旗", "value": "152222", "parentId": "152200"},
    {"label": "扎赉特旗", "value": "152223", "parentId": "152200"},
    {"label": "突泉县", "value": "152224", "parentId": "152200"},
    {"label": "锡林郭勒盟", "value": "152500", "parentId": "150000"},
    {"label": "二连浩特市", "value": "152501", "parentId": "152500"},
    {"label": "锡林浩特市", "value": "152502", "parentId": "152500"},
    {"label": "阿巴嘎旗", "value": "152522", "parentId": "152500"},
    {"label": "苏尼特左旗", "value": "152523", "parentId": "152500"},
    {"label": "苏尼特右旗", "value": "152524", "parentId": "152500"},
    {"label": "东乌珠穆沁旗", "value": "152525", "parentId": "152500"},
    {"label": "西乌珠穆沁旗", "value": "152526", "parentId": "152500"},
    {"label": "太仆寺旗", "value": "152527", "parentId": "152500"},
    {"label": "镶黄旗", "value": "152528", "parentId": "152500"},
    {"label": "正镶白旗", "value": "152529", "parentId": "152500"},
    {"label": "正蓝旗", "value": "152530", "parentId": "152500"},
    {"label": "多伦县", "value": "152531", "parentId": "152500"},
    {"label": "阿拉善盟", "value": "152900", "parentId": "150000"},
    {"label": "阿拉善左旗", "value": "152921", "parentId": "152900"},
    {"label": "阿拉善右旗", "value": "152922", "parentId": "152900"},
    {"label": "额济纳旗", "value": "152923", "parentId": "152900"},
    {"label": "辽宁省", "value": "210000", "parentId": "root"},
    {"label": "沈阳市", "value": "210100", "parentId": "210000"},
    {"label": "市辖区", "value": "210101", "parentId": "210100"},
    {"label": "和平区", "value": "210102", "parentId": "210100"},
    {"label": "沈河区", "value": "210103", "parentId": "210100"},
    {"label": "大东区", "value": "210104", "parentId": "210100"},
    {"label": "皇姑区", "value": "210105", "parentId": "210100"},
    {"label": "铁西区", "value": "210106", "parentId": "210100"},
    {"label": "苏家屯区", "value": "210111", "parentId": "210100"},
    {"label": "东陵区", "value": "210112", "parentId": "210100"},
    {"label": "新城子区", "value": "210113", "parentId": "210100"},
    {"label": "于洪区", "value": "210114", "parentId": "210100"},
    {"label": "辽中县", "value": "210122", "parentId": "210100"},
    {"label": "康平县", "value": "210123", "parentId": "210100"},
    {"label": "法库县", "value": "210124", "parentId": "210100"},
    {"label": "新民市", "value": "210181", "parentId": "210100"},
    {"label": "大连市", "value": "210200", "parentId": "210000"},
    {"label": "市辖区", "value": "210201", "parentId": "210200"},
    {"label": "中山区", "value": "210202", "parentId": "210200"},
    {"label": "西岗区", "value": "210203", "parentId": "210200"},
    {"label": "沙河口区", "value": "210204", "parentId": "210200"},
    {"label": "甘井子区", "value": "210211", "parentId": "210200"},
    {"label": "旅顺口区", "value": "210212", "parentId": "210200"},
    {"label": "金州区", "value": "210213", "parentId": "210200"},
    {"label": "长海县", "value": "210224", "parentId": "210200"},
    {"label": "瓦房店市", "value": "210281", "parentId": "210200"},
    {"label": "普兰店市", "value": "210282", "parentId": "210200"},
    {"label": "庄河市", "value": "210283", "parentId": "210200"},
    {"label": "鞍山市", "value": "210300", "parentId": "210000"},
    {"label": "市辖区", "value": "210301", "parentId": "210300"},
    {"label": "铁东区", "value": "210302", "parentId": "210300"},
    {"label": "铁西区", "value": "210303", "parentId": "210300"},
    {"label": "立山区", "value": "210304", "parentId": "210300"},
    {"label": "千山区", "value": "210311", "parentId": "210300"},
    {"label": "台安县", "value": "210321", "parentId": "210300"},
    {"label": "岫岩满族自治县", "value": "210323", "parentId": "210300"},
    {"label": "海城市", "value": "210381", "parentId": "210300"},
    {"label": "抚顺市", "value": "210400", "parentId": "210000"},
    {"label": "市辖区", "value": "210401", "parentId": "210400"},
    {"label": "新抚区", "value": "210402", "parentId": "210400"},
    {"label": "东洲区", "value": "210403", "parentId": "210400"},
    {"label": "望花区", "value": "210404", "parentId": "210400"},
    {"label": "顺城区", "value": "210411", "parentId": "210400"},
    {"label": "抚顺县", "value": "210421", "parentId": "210400"},
    {"label": "新宾满族自治县", "value": "210422", "parentId": "210400"},
    {"label": "清原满族自治县", "value": "210423", "parentId": "210400"},
    {"label": "本溪市", "value": "210500", "parentId": "210000"},
    {"label": "市辖区", "value": "210501", "parentId": "210500"},
    {"label": "平山区", "value": "210502", "parentId": "210500"},
    {"label": "溪湖区", "value": "210503", "parentId": "210500"},
    {"label": "明山区", "value": "210504", "parentId": "210500"},
    {"label": "南芬区", "value": "210505", "parentId": "210500"},
    {"label": "本溪满族自治县", "value": "210521", "parentId": "210500"},
    {"label": "桓仁满族自治县", "value": "210522", "parentId": "210500"},
    {"label": "丹东市", "value": "210600", "parentId": "210000"},
    {"label": "市辖区", "value": "210601", "parentId": "210600"},
    {"label": "元宝区", "value": "210602", "parentId": "210600"},
    {"label": "振兴区", "value": "210603", "parentId": "210600"},
    {"label": "振安区", "value": "210604", "parentId": "210600"},
    {"label": "宽甸满族自治县", "value": "210624", "parentId": "210600"},
    {"label": "东港市", "value": "210681", "parentId": "210600"},
    {"label": "凤城市", "value": "210682", "parentId": "210600"},
    {"label": "锦州市", "value": "210700", "parentId": "210000"},
    {"label": "市辖区", "value": "210701", "parentId": "210700"},
    {"label": "古塔区", "value": "210702", "parentId": "210700"},
    {"label": "凌河区", "value": "210703", "parentId": "210700"},
    {"label": "太和区", "value": "210711", "parentId": "210700"},
    {"label": "黑山县", "value": "210726", "parentId": "210700"},
    {"label": "义县", "value": "210727", "parentId": "210700"},
    {"label": "凌海市", "value": "210781", "parentId": "210700"},
    {"label": "北宁市", "value": "210782", "parentId": "210700"},
    {"label": "营口市", "value": "210800", "parentId": "210000"},
    {"label": "市辖区", "value": "210801", "parentId": "210800"},
    {"label": "站前区", "value": "210802", "parentId": "210800"},
    {"label": "西市区", "value": "210803", "parentId": "210800"},
    {"label": "鲅鱼圈区", "value": "210804", "parentId": "210800"},
    {"label": "老边区", "value": "210811", "parentId": "210800"},
    {"label": "盖州市", "value": "210881", "parentId": "210800"},
    {"label": "大石桥市", "value": "210882", "parentId": "210800"},
    {"label": "阜新市", "value": "210900", "parentId": "210000"},
    {"label": "市辖区", "value": "210901", "parentId": "210900"},
    {"label": "海州区", "value": "210902", "parentId": "210900"},
    {"label": "新邱区", "value": "210903", "parentId": "210900"},
    {"label": "太平区", "value": "210904", "parentId": "210900"},
    {"label": "清河门区", "value": "210905", "parentId": "210900"},
    {"label": "细河区", "value": "210911", "parentId": "210900"},
    {"label": "阜新蒙古族自治县", "value": "210921", "parentId": "210900"},
    {"label": "彰武县", "value": "210922", "parentId": "210900"},
    {"label": "辽阳市", "value": "211000", "parentId": "210000"},
    {"label": "市辖区", "value": "211001", "parentId": "211000"},
    {"label": "白塔区", "value": "211002", "parentId": "211000"},
    {"label": "文圣区", "value": "211003", "parentId": "211000"},
    {"label": "宏伟区", "value": "211004", "parentId": "211000"},
    {"label": "弓长岭区", "value": "211005", "parentId": "211000"},
    {"label": "太子河区", "value": "211011", "parentId": "211000"},
    {"label": "辽阳县", "value": "211021", "parentId": "211000"},
    {"label": "灯塔市", "value": "211081", "parentId": "211000"},
    {"label": "盘锦市", "value": "211100", "parentId": "210000"},
    {"label": "市辖区", "value": "211101", "parentId": "211100"},
    {"label": "双台子区", "value": "211102", "parentId": "211100"},
    {"label": "兴隆台区", "value": "211103", "parentId": "211100"},
    {"label": "大洼县", "value": "211121", "parentId": "211100"},
    {"label": "盘山县", "value": "211122", "parentId": "211100"},
    {"label": "铁岭市", "value": "211200", "parentId": "210000"},
    {"label": "市辖区", "value": "211201", "parentId": "211200"},
    {"label": "银州区", "value": "211202", "parentId": "211200"},
    {"label": "清河区", "value": "211204", "parentId": "211200"},
    {"label": "铁岭县", "value": "211221", "parentId": "211200"},
    {"label": "西丰县", "value": "211223", "parentId": "211200"},
    {"label": "昌图县", "value": "211224", "parentId": "211200"},
    {"label": "调兵山市", "value": "211281", "parentId": "211200"},
    {"label": "开原市", "value": "211282", "parentId": "211200"},
    {"label": "朝阳市", "value": "211300", "parentId": "210000"},
    {"label": "市辖区", "value": "211301", "parentId": "211300"},
    {"label": "双塔区", "value": "211302", "parentId": "211300"},
    {"label": "龙城区", "value": "211303", "parentId": "211300"},
    {"label": "朝阳县", "value": "211321", "parentId": "211300"},
    {"label": "建平县", "value": "211322", "parentId": "211300"},
    {"label": "喀喇沁左翼蒙古族自治县", "value": "211324", "parentId": "211300"},
    {"label": "北票市", "value": "211381", "parentId": "211300"},
    {"label": "凌源市", "value": "211382", "parentId": "211300"},
    {"label": "葫芦岛市", "value": "211400", "parentId": "210000"},
    {"label": "市辖区", "value": "211401", "parentId": "211400"},
    {"label": "连山区", "value": "211402", "parentId": "211400"},
    {"label": "龙港区", "value": "211403", "parentId": "211400"},
    {"label": "南票区", "value": "211404", "parentId": "211400"},
    {"label": "绥中县", "value": "211421", "parentId": "211400"},
    {"label": "建昌县", "value": "211422", "parentId": "211400"},
    {"label": "兴城市", "value": "211481", "parentId": "211400"},
    {"label": "吉林省", "value": "220000", "parentId": "root"},
    {"label": "长春市", "value": "220100", "parentId": "220000"},
    {"label": "市辖区", "value": "220101", "parentId": "220100"},
    {"label": "南关区", "value": "220102", "parentId": "220100"},
    {"label": "宽城区", "value": "220103", "parentId": "220100"},
    {"label": "朝阳区", "value": "220104", "parentId": "220100"},
    {"label": "二道区", "value": "220105", "parentId": "220100"},
    {"label": "绿园区", "value": "220106", "parentId": "220100"},
    {"label": "双阳区", "value": "220112", "parentId": "220100"},
    {"label": "农安县", "value": "220122", "parentId": "220100"},
    {"label": "九台市", "value": "220181", "parentId": "220100"},
    {"label": "榆树市", "value": "220182", "parentId": "220100"},
    {"label": "德惠市", "value": "220183", "parentId": "220100"},
    {"label": "吉林市", "value": "220200", "parentId": "220000"},
    {"label": "市辖区", "value": "220201", "parentId": "220200"},
    {"label": "昌邑区", "value": "220202", "parentId": "220200"},
    {"label": "龙潭区", "value": "220203", "parentId": "220200"},
    {"label": "船营区", "value": "220204", "parentId": "220200"},
    {"label": "丰满区", "value": "220211", "parentId": "220200"},
    {"label": "永吉县", "value": "220221", "parentId": "220200"},
    {"label": "蛟河市", "value": "220281", "parentId": "220200"},
    {"label": "桦甸市", "value": "220282", "parentId": "220200"},
    {"label": "舒兰市", "value": "220283", "parentId": "220200"},
    {"label": "磐石市", "value": "220284", "parentId": "220200"},
    {"label": "四平市", "value": "220300", "parentId": "220000"},
    {"label": "市辖区", "value": "220301", "parentId": "220300"},
    {"label": "铁西区", "value": "220302", "parentId": "220300"},
    {"label": "铁东区", "value": "220303", "parentId": "220300"},
    {"label": "梨树县", "value": "220322", "parentId": "220300"},
    {"label": "伊通满族自治县", "value": "220323", "parentId": "220300"},
    {"label": "公主岭市", "value": "220381", "parentId": "220300"},
    {"label": "双辽市", "value": "220382", "parentId": "220300"},
    {"label": "辽源市", "value": "220400", "parentId": "220000"},
    {"label": "市辖区", "value": "220401", "parentId": "220400"},
    {"label": "龙山区", "value": "220402", "parentId": "220400"},
    {"label": "西安区", "value": "220403", "parentId": "220400"},
    {"label": "东丰县", "value": "220421", "parentId": "220400"},
    {"label": "东辽县", "value": "220422", "parentId": "220400"},
    {"label": "通化市", "value": "220500", "parentId": "220000"},
    {"label": "市辖区", "value": "220501", "parentId": "220500"},
    {"label": "东昌区", "value": "220502", "parentId": "220500"},
    {"label": "二道江区", "value": "220503", "parentId": "220500"},
    {"label": "通化县", "value": "220521", "parentId": "220500"},
    {"label": "辉南县", "value": "220523", "parentId": "220500"},
    {"label": "柳河县", "value": "220524", "parentId": "220500"},
    {"label": "梅河口市", "value": "220581", "parentId": "220500"},
    {"label": "集安市", "value": "220582", "parentId": "220500"},
    {"label": "白山市", "value": "220600", "parentId": "220000"},
    {"label": "市辖区", "value": "220601", "parentId": "220600"},
    {"label": "八道江区", "value": "220602", "parentId": "220600"},
    {"label": "抚松县", "value": "220621", "parentId": "220600"},
    {"label": "靖宇县", "value": "220622", "parentId": "220600"},
    {"label": "长白朝鲜族自治县", "value": "220623", "parentId": "220600"},
    {"label": "江源县", "value": "220625", "parentId": "220600"},
    {"label": "临江市", "value": "220681", "parentId": "220600"},
    {"label": "松原市", "value": "220700", "parentId": "220000"},
    {"label": "市辖区", "value": "220701", "parentId": "220700"},
    {"label": "宁江区", "value": "220702", "parentId": "220700"},
    {"label": "前郭尔罗斯蒙古族自治县", "value": "220721", "parentId": "220700"},
    {"label": "长岭县", "value": "220722", "parentId": "220700"},
    {"label": "乾安县", "value": "220723", "parentId": "220700"},
    {"label": "扶余县", "value": "220724", "parentId": "220700"},
    {"label": "白城市", "value": "220800", "parentId": "220000"},
    {"label": "市辖区", "value": "220801", "parentId": "220800"},
    {"label": "洮北区", "value": "220802", "parentId": "220800"},
    {"label": "镇赉县", "value": "220821", "parentId": "220800"},
    {"label": "通榆县", "value": "220822", "parentId": "220800"},
    {"label": "洮南市", "value": "220881", "parentId": "220800"},
    {"label": "大安市", "value": "220882", "parentId": "220800"},
    {"label": "延边朝鲜族自治州", "value": "222400", "parentId": "220000"},
    {"label": "延吉市", "value": "222401", "parentId": "222400"},
    {"label": "图们市", "value": "222402", "parentId": "222400"},
    {"label": "敦化市", "value": "222403", "parentId": "222400"},
    {"label": "珲春市", "value": "222404", "parentId": "222400"},
    {"label": "龙井市", "value": "222405", "parentId": "222400"},
    {"label": "和龙市", "value": "222406", "parentId": "222400"},
    {"label": "汪清县", "value": "222424", "parentId": "222400"},
    {"label": "安图县", "value": "222426", "parentId": "222400"},
    {"label": "黑龙江省", "value": "230000", "parentId": "root"},
    {"label": "哈尔滨市", "value": "230100", "parentId": "230000"},
    {"label": "市辖区", "value": "230101", "parentId": "230100"},
    {"label": "道里区", "value": "230102", "parentId": "230100"},
    {"label": "南岗区", "value": "230103", "parentId": "230100"},
    {"label": "道外区", "value": "230104", "parentId": "230100"},
    {"label": "香坊区", "value": "230106", "parentId": "230100"},
    {"label": "动力区", "value": "230107", "parentId": "230100"},
    {"label": "平房区", "value": "230108", "parentId": "230100"},
    {"label": "松北区", "value": "230109", "parentId": "230100"},
    {"label": "呼兰区", "value": "230111", "parentId": "230100"},
    {"label": "依兰县", "value": "230123", "parentId": "230100"},
    {"label": "方正县", "value": "230124", "parentId": "230100"},
    {"label": "宾县", "value": "230125", "parentId": "230100"},
    {"label": "巴彦县", "value": "230126", "parentId": "230100"},
    {"label": "木兰县", "value": "230127", "parentId": "230100"},
    {"label": "通河县", "value": "230128", "parentId": "230100"},
    {"label": "延寿县", "value": "230129", "parentId": "230100"},
    {"label": "阿城市", "value": "230181", "parentId": "230100"},
    {"label": "双城市", "value": "230182", "parentId": "230100"},
    {"label": "尚志市", "value": "230183", "parentId": "230100"},
    {"label": "五常市", "value": "230184", "parentId": "230100"},
    {"label": "齐齐哈尔市", "value": "230200", "parentId": "230000"},
    {"label": "市辖区", "value": "230201", "parentId": "230200"},
    {"label": "龙沙区", "value": "230202", "parentId": "230200"},
    {"label": "建华区", "value": "230203", "parentId": "230200"},
    {"label": "铁锋区", "value": "230204", "parentId": "230200"},
    {"label": "昂昂溪区", "value": "230205", "parentId": "230200"},
    {"label": "富拉尔基区", "value": "230206", "parentId": "230200"},
    {"label": "碾子山区", "value": "230207", "parentId": "230200"},
    {"label": "梅里斯达斡尔族区", "value": "230208", "parentId": "230200"},
    {"label": "龙江县", "value": "230221", "parentId": "230200"},
    {"label": "依安县", "value": "230223", "parentId": "230200"},
    {"label": "泰来县", "value": "230224", "parentId": "230200"},
    {"label": "甘南县", "value": "230225", "parentId": "230200"},
    {"label": "富裕县", "value": "230227", "parentId": "230200"},
    {"label": "克山县", "value": "230229", "parentId": "230200"},
    {"label": "克东县", "value": "230230", "parentId": "230200"},
    {"label": "拜泉县", "value": "230231", "parentId": "230200"},
    {"label": "讷河市", "value": "230281", "parentId": "230200"},
    {"label": "鸡西市", "value": "230300", "parentId": "230000"},
    {"label": "市辖区", "value": "230301", "parentId": "230300"},
    {"label": "鸡冠区", "value": "230302", "parentId": "230300"},
    {"label": "恒山区", "value": "230303", "parentId": "230300"},
    {"label": "滴道区", "value": "230304", "parentId": "230300"},
    {"label": "梨树区", "value": "230305", "parentId": "230300"},
    {"label": "城子河区", "value": "230306", "parentId": "230300"},
    {"label": "麻山区", "value": "230307", "parentId": "230300"},
    {"label": "鸡东县", "value": "230321", "parentId": "230300"},
    {"label": "虎林市", "value": "230381", "parentId": "230300"},
    {"label": "密山市", "value": "230382", "parentId": "230300"},
    {"label": "鹤岗市", "value": "230400", "parentId": "230000"},
    {"label": "市辖区", "value": "230401", "parentId": "230400"},
    {"label": "向阳区", "value": "230402", "parentId": "230400"},
    {"label": "工农区", "value": "230403", "parentId": "230400"},
    {"label": "南山区", "value": "230404", "parentId": "230400"},
    {"label": "兴安区", "value": "230405", "parentId": "230400"},
    {"label": "东山区", "value": "230406", "parentId": "230400"},
    {"label": "兴山区", "value": "230407", "parentId": "230400"},
    {"label": "萝北县", "value": "230421", "parentId": "230400"},
    {"label": "绥滨县", "value": "230422", "parentId": "230400"},
    {"label": "双鸭山市", "value": "230500", "parentId": "230000"},
    {"label": "市辖区", "value": "230501", "parentId": "230500"},
    {"label": "尖山区", "value": "230502", "parentId": "230500"},
    {"label": "岭东区", "value": "230503", "parentId": "230500"},
    {"label": "四方台区", "value": "230505", "parentId": "230500"},
    {"label": "宝山区", "value": "230506", "parentId": "230500"},
    {"label": "集贤县", "value": "230521", "parentId": "230500"},
    {"label": "友谊县", "value": "230522", "parentId": "230500"},
    {"label": "宝清县", "value": "230523", "parentId": "230500"},
    {"label": "饶河县", "value": "230524", "parentId": "230500"},
    {"label": "大庆市", "value": "230600", "parentId": "230000"},
    {"label": "市辖区", "value": "230601", "parentId": "230600"},
    {"label": "萨尔图区", "value": "230602", "parentId": "230600"},
    {"label": "龙凤区", "value": "230603", "parentId": "230600"},
    {"label": "让胡路区", "value": "230604", "parentId": "230600"},
    {"label": "红岗区", "value": "230605", "parentId": "230600"},
    {"label": "大同区", "value": "230606", "parentId": "230600"},
    {"label": "肇州县", "value": "230621", "parentId": "230600"},
    {"label": "肇源县", "value": "230622", "parentId": "230600"},
    {"label": "林甸县", "value": "230623", "parentId": "230600"},
    {"label": "杜尔伯特蒙古族自治县", "value": "230624", "parentId": "230600"},
    {"label": "伊春市", "value": "230700", "parentId": "230000"},
    {"label": "市辖区", "value": "230701", "parentId": "230700"},
    {"label": "伊春区", "value": "230702", "parentId": "230700"},
    {"label": "南岔区", "value": "230703", "parentId": "230700"},
    {"label": "友好区", "value": "230704", "parentId": "230700"},
    {"label": "西林区", "value": "230705", "parentId": "230700"},
    {"label": "翠峦区", "value": "230706", "parentId": "230700"},
    {"label": "新青区", "value": "230707", "parentId": "230700"},
    {"label": "美溪区", "value": "230708", "parentId": "230700"},
    {"label": "金山屯区", "value": "230709", "parentId": "230700"},
    {"label": "五营区", "value": "230710", "parentId": "230700"},
    {"label": "乌马河区", "value": "230711", "parentId": "230700"},
    {"label": "汤旺河区", "value": "230712", "parentId": "230700"},
    {"label": "带岭区", "value": "230713", "parentId": "230700"},
    {"label": "乌伊岭区", "value": "230714", "parentId": "230700"},
    {"label": "红星区", "value": "230715", "parentId": "230700"},
    {"label": "上甘岭区", "value": "230716", "parentId": "230700"},
    {"label": "嘉荫县", "value": "230722", "parentId": "230700"},
    {"label": "铁力市", "value": "230781", "parentId": "230700"},
    {"label": "佳木斯市", "value": "230800", "parentId": "230000"},
    {"label": "市辖区", "value": "230801", "parentId": "230800"},
    {"label": "永红区", "value": "230802", "parentId": "230800"},
    {"label": "向阳区", "value": "230803", "parentId": "230800"},
    {"label": "前进区", "value": "230804", "parentId": "230800"},
    {"label": "东风区", "value": "230805", "parentId": "230800"},
    {"label": "郊区", "value": "230811", "parentId": "230800"},
    {"label": "桦南县", "value": "230822", "parentId": "230800"},
    {"label": "桦川县", "value": "230826", "parentId": "230800"},
    {"label": "汤原县", "value": "230828", "parentId": "230800"},
    {"label": "抚远县", "value": "230833", "parentId": "230800"},
    {"label": "同江市", "value": "230881", "parentId": "230800"},
    {"label": "富锦市", "value": "230882", "parentId": "230800"},
    {"label": "七台河市", "value": "230900", "parentId": "230000"},
    {"label": "市辖区", "value": "230901", "parentId": "230900"},
    {"label": "新兴区", "value": "230902", "parentId": "230900"},
    {"label": "桃山区", "value": "230903", "parentId": "230900"},
    {"label": "茄子河区", "value": "230904", "parentId": "230900"},
    {"label": "勃利县", "value": "230921", "parentId": "230900"},
    {"label": "牡丹江市", "value": "231000", "parentId": "230000"},
    {"label": "市辖区", "value": "231001", "parentId": "231000"},
    {"label": "东安区", "value": "231002", "parentId": "231000"},
    {"label": "阳明区", "value": "231003", "parentId": "231000"},
    {"label": "爱民区", "value": "231004", "parentId": "231000"},
    {"label": "西安区", "value": "231005", "parentId": "231000"},
    {"label": "东宁县", "value": "231024", "parentId": "231000"},
    {"label": "林口县", "value": "231025", "parentId": "231000"},
    {"label": "绥芬河市", "value": "231081", "parentId": "231000"},
    {"label": "海林市", "value": "231083", "parentId": "231000"},
    {"label": "宁安市", "value": "231084", "parentId": "231000"},
    {"label": "穆棱市", "value": "231085", "parentId": "231000"},
    {"label": "黑河市", "value": "231100", "parentId": "230000"},
    {"label": "市辖区", "value": "231101", "parentId": "231100"},
    {"label": "爱辉区", "value": "231102", "parentId": "231100"},
    {"label": "嫩江县", "value": "231121", "parentId": "231100"},
    {"label": "逊克县", "value": "231123", "parentId": "231100"},
    {"label": "孙吴县", "value": "231124", "parentId": "231100"},
    {"label": "北安市", "value": "231181", "parentId": "231100"},
    {"label": "五大连池市", "value": "231182", "parentId": "231100"},
    {"label": "绥化市", "value": "231200", "parentId": "230000"},
    {"label": "市辖区", "value": "231201", "parentId": "231200"},
    {"label": "北林区", "value": "231202", "parentId": "231200"},
    {"label": "望奎县", "value": "231221", "parentId": "231200"},
    {"label": "兰西县", "value": "231222", "parentId": "231200"},
    {"label": "青冈县", "value": "231223", "parentId": "231200"},
    {"label": "庆安县", "value": "231224", "parentId": "231200"},
    {"label": "明水县", "value": "231225", "parentId": "231200"},
    {"label": "绥棱县", "value": "231226", "parentId": "231200"},
    {"label": "安达市", "value": "231281", "parentId": "231200"},
    {"label": "肇东市", "value": "231282", "parentId": "231200"},
    {"label": "海伦市", "value": "231283", "parentId": "231200"},
    {"label": "大兴安岭地区", "value": "232700", "parentId": "230000"},
    {"label": "呼玛县", "value": "232721", "parentId": "232700"},
    {"label": "塔河县", "value": "232722", "parentId": "232700"},
    {"label": "漠河县", "value": "232723", "parentId": "232700"},
    {"label": "上海市", "value": "310000", "parentId": "root"},
    {"label": "市辖区", "value": "310100", "parentId": "310000"},
    {"label": "黄浦区", "value": "310101", "parentId": "310100"},
    {"label": "卢湾区", "value": "310103", "parentId": "310100"},
    {"label": "徐汇区", "value": "310104", "parentId": "310100"},
    {"label": "长宁区", "value": "310105", "parentId": "310100"},
    {"label": "静安区", "value": "310106", "parentId": "310100"},
    {"label": "普陀区", "value": "310107", "parentId": "310100"},
    {"label": "闸北区", "value": "310108", "parentId": "310100"},
    {"label": "虹口区", "value": "310109", "parentId": "310100"},
    {"label": "杨浦区", "value": "310110", "parentId": "310100"},
    {"label": "闵行区", "value": "310112", "parentId": "310100"},
    {"label": "宝山区", "value": "310113", "parentId": "310100"},
    {"label": "嘉定区", "value": "310114", "parentId": "310100"},
    {"label": "浦东新区", "value": "310115", "parentId": "310100"},
    {"label": "金山区", "value": "310116", "parentId": "310100"},
    {"label": "松江区", "value": "310117", "parentId": "310100"},
    {"label": "青浦区", "value": "310118", "parentId": "310100"},
    {"label": "南汇区", "value": "310119", "parentId": "310100"},
    {"label": "奉贤区", "value": "310120", "parentId": "310100"},
    {"label": "县", "value": "310200", "parentId": "310000"},
    {"label": "崇明县", "value": "310230", "parentId": "310200"},
    {"label": "江苏省", "value": "320000", "parentId": "root"},
    {"label": "南京市", "value": "320100", "parentId": "320000"},
    {"label": "市辖区", "value": "320101", "parentId": "320100"},
    {"label": "玄武区", "value": "320102", "parentId": "320100"},
    {"label": "白下区", "value": "320103", "parentId": "320100"},
    {"label": "秦淮区", "value": "320104", "parentId": "320100"},
    {"label": "建邺区", "value": "320105", "parentId": "320100"},
    {"label": "鼓楼区", "value": "320106", "parentId": "320100"},
    {"label": "下关区", "value": "320107", "parentId": "320100"},
    {"label": "浦口区", "value": "320111", "parentId": "320100"},
    {"label": "栖霞区", "value": "320113", "parentId": "320100"},
    {"label": "雨花台区", "value": "320114", "parentId": "320100"},
    {"label": "江宁区", "value": "320115", "parentId": "320100"},
    {"label": "六合区", "value": "320116", "parentId": "320100"},
    {"label": "溧水县", "value": "320124", "parentId": "320100"},
    {"label": "高淳县", "value": "320125", "parentId": "320100"},
    {"label": "无锡市", "value": "320200", "parentId": "320000"},
    {"label": "市辖区", "value": "320201", "parentId": "320200"},
    {"label": "崇安区", "value": "320202", "parentId": "320200"},
    {"label": "南长区", "value": "320203", "parentId": "320200"},
    {"label": "北塘区", "value": "320204", "parentId": "320200"},
    {"label": "锡山区", "value": "320205", "parentId": "320200"},
    {"label": "惠山区", "value": "320206", "parentId": "320200"},
    {"label": "滨湖区", "value": "320211", "parentId": "320200"},
    {"label": "江阴市", "value": "320281", "parentId": "320200"},
    {"label": "宜兴市", "value": "320282", "parentId": "320200"},
    {"label": "徐州市", "value": "320300", "parentId": "320000"},
    {"label": "市辖区", "value": "320301", "parentId": "320300"},
    {"label": "鼓楼区", "value": "320302", "parentId": "320300"},
    {"label": "云龙区", "value": "320303", "parentId": "320300"},
    {"label": "九里区", "value": "320304", "parentId": "320300"},
    {"label": "贾汪区", "value": "320305", "parentId": "320300"},
    {"label": "泉山区", "value": "320311", "parentId": "320300"},
    {"label": "丰县", "value": "320321", "parentId": "320300"},
    {"label": "沛县", "value": "320322", "parentId": "320300"},
    {"label": "铜山县", "value": "320323", "parentId": "320300"},
    {"label": "睢宁县", "value": "320324", "parentId": "320300"},
    {"label": "新沂市", "value": "320381", "parentId": "320300"},
    {"label": "邳州市", "value": "320382", "parentId": "320300"},
    {"label": "常州市", "value": "320400", "parentId": "320000"},
    {"label": "市辖区", "value": "320401", "parentId": "320400"},
    {"label": "天宁区", "value": "320402", "parentId": "320400"},
    {"label": "钟楼区", "value": "320404", "parentId": "320400"},
    {"label": "戚墅堰区", "value": "320405", "parentId": "320400"},
    {"label": "新北区", "value": "320411", "parentId": "320400"},
    {"label": "武进区", "value": "320412", "parentId": "320400"},
    {"label": "溧阳市", "value": "320481", "parentId": "320400"},
    {"label": "金坛市", "value": "320482", "parentId": "320400"},
    {"label": "苏州市", "value": "320500", "parentId": "320000"},
    {"label": "市辖区", "value": "320501", "parentId": "320500"},
    {"label": "沧浪区", "value": "320502", "parentId": "320500"},
    {"label": "平江区", "value": "320503", "parentId": "320500"},
    {"label": "金阊区", "value": "320504", "parentId": "320500"},
    {"label": "虎丘区", "value": "320505", "parentId": "320500"},
    {"label": "吴中区", "value": "320506", "parentId": "320500"},
    {"label": "相城区", "value": "320507", "parentId": "320500"},
    {"label": "常熟市", "value": "320581", "parentId": "320500"},
    {"label": "张家港市", "value": "320582", "parentId": "320500"},
    {"label": "昆山市", "value": "320583", "parentId": "320500"},
    {"label": "吴江市", "value": "320584", "parentId": "320500"},
    {"label": "太仓市", "value": "320585", "parentId": "320500"},
    {"label": "南通市", "value": "320600", "parentId": "320000"},
    {"label": "市辖区", "value": "320601", "parentId": "320600"},
    {"label": "崇川区", "value": "320602", "parentId": "320600"},
    {"label": "港闸区", "value": "320611", "parentId": "320600"},
    {"label": "海安县", "value": "320621", "parentId": "320600"},
    {"label": "如东县", "value": "320623", "parentId": "320600"},
    {"label": "启东市", "value": "320681", "parentId": "320600"},
    {"label": "如皋市", "value": "320682", "parentId": "320600"},
    {"label": "通州市", "value": "320683", "parentId": "320600"},
    {"label": "海门市", "value": "320684", "parentId": "320600"},
    {"label": "连云港市", "value": "320700", "parentId": "320000"},
    {"label": "市辖区", "value": "320701", "parentId": "320700"},
    {"label": "连云区", "value": "320703", "parentId": "320700"},
    {"label": "新浦区", "value": "320705", "parentId": "320700"},
    {"label": "海州区", "value": "320706", "parentId": "320700"},
    {"label": "赣榆县", "value": "320721", "parentId": "320700"},
    {"label": "东海县", "value": "320722", "parentId": "320700"},
    {"label": "灌云县", "value": "320723", "parentId": "320700"},
    {"label": "灌南县", "value": "320724", "parentId": "320700"},
    {"label": "淮安市", "value": "320800", "parentId": "320000"},
    {"label": "市辖区", "value": "320801", "parentId": "320800"},
    {"label": "清河区", "value": "320802", "parentId": "320800"},
    {"label": "楚州区", "value": "320803", "parentId": "320800"},
    {"label": "淮阴区", "value": "320804", "parentId": "320800"},
    {"label": "清浦区", "value": "320811", "parentId": "320800"},
    {"label": "涟水县", "value": "320826", "parentId": "320800"},
    {"label": "洪泽县", "value": "320829", "parentId": "320800"},
    {"label": "盱眙县", "value": "320830", "parentId": "320800"},
    {"label": "金湖县", "value": "320831", "parentId": "320800"},
    {"label": "盐城市", "value": "320900", "parentId": "320000"},
    {"label": "市辖区", "value": "320901", "parentId": "320900"},
    {"label": "亭湖区", "value": "320902", "parentId": "320900"},
    {"label": "盐都区", "value": "320903", "parentId": "320900"},
    {"label": "响水县", "value": "320921", "parentId": "320900"},
    {"label": "滨海县", "value": "320922", "parentId": "320900"},
    {"label": "阜宁县", "value": "320923", "parentId": "320900"},
    {"label": "射阳县", "value": "320924", "parentId": "320900"},
    {"label": "建湖县", "value": "320925", "parentId": "320900"},
    {"label": "东台市", "value": "320981", "parentId": "320900"},
    {"label": "大丰市", "value": "320982", "parentId": "320900"},
    {"label": "扬州市", "value": "321000", "parentId": "320000"},
    {"label": "市辖区", "value": "321001", "parentId": "321000"},
    {"label": "广陵区", "value": "321002", "parentId": "321000"},
    {"label": "邗江区", "value": "321003", "parentId": "321000"},
    {"label": "郊区", "value": "321011", "parentId": "321000"},
    {"label": "宝应县", "value": "321023", "parentId": "321000"},
    {"label": "仪征市", "value": "321081", "parentId": "321000"},
    {"label": "高邮市", "value": "321084", "parentId": "321000"},
    {"label": "江都市", "value": "321088", "parentId": "321000"},
    {"label": "镇江市", "value": "321100", "parentId": "320000"},
    {"label": "市辖区", "value": "321101", "parentId": "321100"},
    {"label": "京口区", "value": "321102", "parentId": "321100"},
    {"label": "润州区", "value": "321111", "parentId": "321100"},
    {"label": "丹徒区", "value": "321112", "parentId": "321100"},
    {"label": "丹阳市", "value": "321181", "parentId": "321100"},
    {"label": "扬中市", "value": "321182", "parentId": "321100"},
    {"label": "句容市", "value": "321183", "parentId": "321100"},
    {"label": "泰州市", "value": "321200", "parentId": "320000"},
    {"label": "市辖区", "value": "321201", "parentId": "321200"},
    {"label": "海陵区", "value": "321202", "parentId": "321200"},
    {"label": "高港区", "value": "321203", "parentId": "321200"},
    {"label": "兴化市", "value": "321281", "parentId": "321200"},
    {"label": "靖江市", "value": "321282", "parentId": "321200"},
    {"label": "泰兴市", "value": "321283", "parentId": "321200"},
    {"label": "姜堰市", "value": "321284", "parentId": "321200"},
    {"label": "宿迁市", "value": "321300", "parentId": "320000"},
    {"label": "市辖区", "value": "321301", "parentId": "321300"},
    {"label": "宿城区", "value": "321302", "parentId": "321300"},
    {"label": "宿豫区", "value": "321311", "parentId": "321300"},
    {"label": "沭阳县", "value": "321322", "parentId": "321300"},
    {"label": "泗阳县", "value": "321323", "parentId": "321300"},
    {"label": "泗洪县", "value": "321324", "parentId": "321300"},
    {"label": "浙江省", "value": "330000", "parentId": "root"},
    {"label": "杭州市", "value": "330100", "parentId": "330000"},
    {"label": "市辖区", "value": "330101", "parentId": "330100"},
    {"label": "上城区", "value": "330102", "parentId": "330100"},
    {"label": "下城区", "value": "330103", "parentId": "330100"},
    {"label": "江干区", "value": "330104", "parentId": "330100"},
    {"label": "拱墅区", "value": "330105", "parentId": "330100"},
    {"label": "西湖区", "value": "330106", "parentId": "330100"},
    {"label": "滨江区", "value": "330108", "parentId": "330100"},
    {"label": "萧山区", "value": "330109", "parentId": "330100"},
    {"label": "余杭区", "value": "330110", "parentId": "330100"},
    {"label": "桐庐县", "value": "330122", "parentId": "330100"},
    {"label": "淳安县", "value": "330127", "parentId": "330100"},
    {"label": "建德市", "value": "330182", "parentId": "330100"},
    {"label": "富阳市", "value": "330183", "parentId": "330100"},
    {"label": "临安市", "value": "330185", "parentId": "330100"},
    {"label": "宁波市", "value": "330200", "parentId": "330000"},
    {"label": "市辖区", "value": "330201", "parentId": "330200"},
    {"label": "海曙区", "value": "330203", "parentId": "330200"},
    {"label": "江东区", "value": "330204", "parentId": "330200"},
    {"label": "江北区", "value": "330205", "parentId": "330200"},
    {"label": "北仑区", "value": "330206", "parentId": "330200"},
    {"label": "镇海区", "value": "330211", "parentId": "330200"},
    {"label": "鄞州区", "value": "330212", "parentId": "330200"},
    {"label": "象山县", "value": "330225", "parentId": "330200"},
    {"label": "宁海县", "value": "330226", "parentId": "330200"},
    {"label": "余姚市", "value": "330281", "parentId": "330200"},
    {"label": "慈溪市", "value": "330282", "parentId": "330200"},
    {"label": "奉化市", "value": "330283", "parentId": "330200"},
    {"label": "温州市", "value": "330300", "parentId": "330000"},
    {"label": "市辖区", "value": "330301", "parentId": "330300"},
    {"label": "鹿城区", "value": "330302", "parentId": "330300"},
    {"label": "龙湾区", "value": "330303", "parentId": "330300"},
    {"label": "瓯海区", "value": "330304", "parentId": "330300"},
    {"label": "洞头县", "value": "330322", "parentId": "330300"},
    {"label": "永嘉县", "value": "330324", "parentId": "330300"},
    {"label": "平阳县", "value": "330326", "parentId": "330300"},
    {"label": "苍南县", "value": "330327", "parentId": "330300"},
    {"label": "文成县", "value": "330328", "parentId": "330300"},
    {"label": "泰顺县", "value": "330329", "parentId": "330300"},
    {"label": "瑞安市", "value": "330381", "parentId": "330300"},
    {"label": "乐清市", "value": "330382", "parentId": "330300"},
    {"label": "嘉兴市", "value": "330400", "parentId": "330000"},
    {"label": "市辖区", "value": "330401", "parentId": "330400"},
    {"label": "秀城区", "value": "330402", "parentId": "330400"},
    {"label": "秀洲区", "value": "330411", "parentId": "330400"},
    {"label": "嘉善县", "value": "330421", "parentId": "330400"},
    {"label": "海盐县", "value": "330424", "parentId": "330400"},
    {"label": "海宁市", "value": "330481", "parentId": "330400"},
    {"label": "平湖市", "value": "330482", "parentId": "330400"},
    {"label": "桐乡市", "value": "330483", "parentId": "330400"},
    {"label": "湖州市", "value": "330500", "parentId": "330000"},
    {"label": "市辖区", "value": "330501", "parentId": "330500"},
    {"label": "吴兴区", "value": "330502", "parentId": "330500"},
    {"label": "南浔区", "value": "330503", "parentId": "330500"},
    {"label": "德清县", "value": "330521", "parentId": "330500"},
    {"label": "长兴县", "value": "330522", "parentId": "330500"},
    {"label": "安吉县", "value": "330523", "parentId": "330500"},
    {"label": "绍兴市", "value": "330600", "parentId": "330000"},
    {"label": "市辖区", "value": "330601", "parentId": "330600"},
    {"label": "越城区", "value": "330602", "parentId": "330600"},
    {"label": "绍兴县", "value": "330621", "parentId": "330600"},
    {"label": "新昌县", "value": "330624", "parentId": "330600"},
    {"label": "诸暨市", "value": "330681", "parentId": "330600"},
    {"label": "上虞市", "value": "330682", "parentId": "330600"},
    {"label": "嵊州市", "value": "330683", "parentId": "330600"},
    {"label": "金华市", "value": "330700", "parentId": "330000"},
    {"label": "市辖区", "value": "330701", "parentId": "330700"},
    {"label": "婺城区", "value": "330702", "parentId": "330700"},
    {"label": "金东区", "value": "330703", "parentId": "330700"},
    {"label": "武义县", "value": "330723", "parentId": "330700"},
    {"label": "浦江县", "value": "330726", "parentId": "330700"},
    {"label": "磐安县", "value": "330727", "parentId": "330700"},
    {"label": "兰溪市", "value": "330781", "parentId": "330700"},
    {"label": "义乌市", "value": "330782", "parentId": "330700"},
    {"label": "东阳市", "value": "330783", "parentId": "330700"},
    {"label": "永康市", "value": "330784", "parentId": "330700"},
    {"label": "衢州市", "value": "330800", "parentId": "330000"},
    {"label": "市辖区", "value": "330801", "parentId": "330800"},
    {"label": "柯城区", "value": "330802", "parentId": "330800"},
    {"label": "衢江区", "value": "330803", "parentId": "330800"},
    {"label": "常山县", "value": "330822", "parentId": "330800"},
    {"label": "开化县", "value": "330824", "parentId": "330800"},
    {"label": "龙游县", "value": "330825", "parentId": "330800"},
    {"label": "江山市", "value": "330881", "parentId": "330800"},
    {"label": "舟山市", "value": "330900", "parentId": "330000"},
    {"label": "市辖区", "value": "330901", "parentId": "330900"},
    {"label": "定海区", "value": "330902", "parentId": "330900"},
    {"label": "普陀区", "value": "330903", "parentId": "330900"},
    {"label": "岱山县", "value": "330921", "parentId": "330900"},
    {"label": "嵊泗县", "value": "330922", "parentId": "330900"},
    {"label": "台州市", "value": "331000", "parentId": "330000"},
    {"label": "市辖区", "value": "331001", "parentId": "331000"},
    {"label": "椒江区", "value": "331002", "parentId": "331000"},
    {"label": "黄岩区", "value": "331003", "parentId": "331000"},
    {"label": "路桥区", "value": "331004", "parentId": "331000"},
    {"label": "玉环县", "value": "331021", "parentId": "331000"},
    {"label": "三门县", "value": "331022", "parentId": "331000"},
    {"label": "天台县", "value": "331023", "parentId": "331000"},
    {"label": "仙居县", "value": "331024", "parentId": "331000"},
    {"label": "温岭市", "value": "331081", "parentId": "331000"},
    {"label": "临海市", "value": "331082", "parentId": "331000"},
    {"label": "丽水市", "value": "331100", "parentId": "330000"},
    {"label": "市辖区", "value": "331101", "parentId": "331100"},
    {"label": "莲都区", "value": "331102", "parentId": "331100"},
    {"label": "青田县", "value": "331121", "parentId": "331100"},
    {"label": "缙云县", "value": "331122", "parentId": "331100"},
    {"label": "遂昌县", "value": "331123", "parentId": "331100"},
    {"label": "松阳县", "value": "331124", "parentId": "331100"},
    {"label": "云和县", "value": "331125", "parentId": "331100"},
    {"label": "庆元县", "value": "331126", "parentId": "331100"},
    {"label": "景宁畲族自治县", "value": "331127", "parentId": "331100"},
    {"label": "龙泉市", "value": "331181", "parentId": "331100"},
    {"label": "安徽省", "value": "340000", "parentId": "root"},
    {"label": "合肥市", "value": "340100", "parentId": "340000"},
    {"label": "市辖区", "value": "340101", "parentId": "340100"},
    {"label": "瑶海区", "value": "340102", "parentId": "340100"},
    {"label": "庐阳区", "value": "340103", "parentId": "340100"},
    {"label": "蜀山区", "value": "340104", "parentId": "340100"},
    {"label": "包河区", "value": "340111", "parentId": "340100"},
    {"label": "长丰县", "value": "340121", "parentId": "340100"},
    {"label": "肥东县", "value": "340122", "parentId": "340100"},
    {"label": "肥西县", "value": "340123", "parentId": "340100"},
    {"label": "芜湖市", "value": "340200", "parentId": "340000"},
    {"label": "市辖区", "value": "340201", "parentId": "340200"},
    {"label": "镜湖区", "value": "340202", "parentId": "340200"},
    {"label": "马塘区", "value": "340203", "parentId": "340200"},
    {"label": "新芜区", "value": "340204", "parentId": "340200"},
    {"label": "鸠江区", "value": "340207", "parentId": "340200"},
    {"label": "芜湖县", "value": "340221", "parentId": "340200"},
    {"label": "繁昌县", "value": "340222", "parentId": "340200"},
    {"label": "南陵县", "value": "340223", "parentId": "340200"},
    {"label": "蚌埠市", "value": "340300", "parentId": "340000"},
    {"label": "市辖区", "value": "340301", "parentId": "340300"},
    {"label": "龙子湖区", "value": "340302", "parentId": "340300"},
    {"label": "蚌山区", "value": "340303", "parentId": "340300"},
    {"label": "禹会区", "value": "340304", "parentId": "340300"},
    {"label": "淮上区", "value": "340311", "parentId": "340300"},
    {"label": "怀远县", "value": "340321", "parentId": "340300"},
    {"label": "五河县", "value": "340322", "parentId": "340300"},
    {"label": "固镇县", "value": "340323", "parentId": "340300"},
    {"label": "淮南市", "value": "340400", "parentId": "340000"},
    {"label": "市辖区", "value": "340401", "parentId": "340400"},
    {"label": "大通区", "value": "340402", "parentId": "340400"},
    {"label": "田家庵区", "value": "340403", "parentId": "340400"},
    {"label": "谢家集区", "value": "340404", "parentId": "340400"},
    {"label": "八公山区", "value": "340405", "parentId": "340400"},
    {"label": "潘集区", "value": "340406", "parentId": "340400"},
    {"label": "凤台县", "value": "340421", "parentId": "340400"},
    {"label": "马鞍山市", "value": "340500", "parentId": "340000"},
    {"label": "市辖区", "value": "340501", "parentId": "340500"},
    {"label": "金家庄区", "value": "340502", "parentId": "340500"},
    {"label": "花山区", "value": "340503", "parentId": "340500"},
    {"label": "雨山区", "value": "340504", "parentId": "340500"},
    {"label": "当涂县", "value": "340521", "parentId": "340500"},
    {"label": "淮北市", "value": "340600", "parentId": "340000"},
    {"label": "市辖区", "value": "340601", "parentId": "340600"},
    {"label": "杜集区", "value": "340602", "parentId": "340600"},
    {"label": "相山区", "value": "340603", "parentId": "340600"},
    {"label": "烈山区", "value": "340604", "parentId": "340600"},
    {"label": "濉溪县", "value": "340621", "parentId": "340600"},
    {"label": "铜陵市", "value": "340700", "parentId": "340000"},
    {"label": "市辖区", "value": "340701", "parentId": "340700"},
    {"label": "铜官山区", "value": "340702", "parentId": "340700"},
    {"label": "狮子山区", "value": "340703", "parentId": "340700"},
    {"label": "郊区", "value": "340711", "parentId": "340700"},
    {"label": "铜陵县", "value": "340721", "parentId": "340700"},
    {"label": "安庆市", "value": "340800", "parentId": "340000"},
    {"label": "市辖区", "value": "340801", "parentId": "340800"},
    {"label": "迎江区", "value": "340802", "parentId": "340800"},
    {"label": "大观区", "value": "340803", "parentId": "340800"},
    {"label": "郊区", "value": "340811", "parentId": "340800"},
    {"label": "怀宁县", "value": "340822", "parentId": "340800"},
    {"label": "枞阳县", "value": "340823", "parentId": "340800"},
    {"label": "潜山县", "value": "340824", "parentId": "340800"},
    {"label": "太湖县", "value": "340825", "parentId": "340800"},
    {"label": "宿松县", "value": "340826", "parentId": "340800"},
    {"label": "望江县", "value": "340827", "parentId": "340800"},
    {"label": "岳西县", "value": "340828", "parentId": "340800"},
    {"label": "桐城市", "value": "340881", "parentId": "340800"},
    {"label": "黄山市", "value": "341000", "parentId": "340000"},
    {"label": "市辖区", "value": "341001", "parentId": "341000"},
    {"label": "屯溪区", "value": "341002", "parentId": "341000"},
    {"label": "黄山区", "value": "341003", "parentId": "341000"},
    {"label": "徽州区", "value": "341004", "parentId": "341000"},
    {"label": "歙县", "value": "341021", "parentId": "341000"},
    {"label": "休宁县", "value": "341022", "parentId": "341000"},
    {"label": "黟县", "value": "341023", "parentId": "341000"},
    {"label": "祁门县", "value": "341024", "parentId": "341000"},
    {"label": "滁州市", "value": "341100", "parentId": "340000"},
    {"label": "市辖区", "value": "341101", "parentId": "341100"},
    {"label": "琅琊区", "value": "341102", "parentId": "341100"},
    {"label": "南谯区", "value": "341103", "parentId": "341100"},
    {"label": "来安县", "value": "341122", "parentId": "341100"},
    {"label": "全椒县", "value": "341124", "parentId": "341100"},
    {"label": "定远县", "value": "341125", "parentId": "341100"},
    {"label": "凤阳县", "value": "341126", "parentId": "341100"},
    {"label": "天长市", "value": "341181", "parentId": "341100"},
    {"label": "明光市", "value": "341182", "parentId": "341100"},
    {"label": "阜阳市", "value": "341200", "parentId": "340000"},
    {"label": "市辖区", "value": "341201", "parentId": "341200"},
    {"label": "颍州区", "value": "341202", "parentId": "341200"},
    {"label": "颍东区", "value": "341203", "parentId": "341200"},
    {"label": "颍泉区", "value": "341204", "parentId": "341200"},
    {"label": "临泉县", "value": "341221", "parentId": "341200"},
    {"label": "太和县", "value": "341222", "parentId": "341200"},
    {"label": "阜南县", "value": "341225", "parentId": "341200"},
    {"label": "颍上县", "value": "341226", "parentId": "341200"},
    {"label": "界首市", "value": "341282", "parentId": "341200"},
    {"label": "宿州市", "value": "341300", "parentId": "340000"},
    {"label": "市辖区", "value": "341301", "parentId": "341300"},
    {"label": "墉桥区", "value": "341302", "parentId": "341300"},
    {"label": "砀山县", "value": "341321", "parentId": "341300"},
    {"label": "萧县", "value": "341322", "parentId": "341300"},
    {"label": "灵璧县", "value": "341323", "parentId": "341300"},
    {"label": "泗县", "value": "341324", "parentId": "341300"},
    {"label": "巢湖市", "value": "341400", "parentId": "340000"},
    {"label": "市辖区", "value": "341401", "parentId": "341400"},
    {"label": "居巢区", "value": "341402", "parentId": "341400"},
    {"label": "庐江县", "value": "341421", "parentId": "341400"},
    {"label": "无为县", "value": "341422", "parentId": "341400"},
    {"label": "含山县", "value": "341423", "parentId": "341400"},
    {"label": "和县", "value": "341424", "parentId": "341400"},
    {"label": "六安市", "value": "341500", "parentId": "340000"},
    {"label": "市辖区", "value": "341501", "parentId": "341500"},
    {"label": "金安区", "value": "341502", "parentId": "341500"},
    {"label": "裕安区", "value": "341503", "parentId": "341500"},
    {"label": "寿县", "value": "341521", "parentId": "341500"},
    {"label": "霍邱县", "value": "341522", "parentId": "341500"},
    {"label": "舒城县", "value": "341523", "parentId": "341500"},
    {"label": "金寨县", "value": "341524", "parentId": "341500"},
    {"label": "霍山县", "value": "341525", "parentId": "341500"},
    {"label": "亳州市", "value": "341600", "parentId": "340000"},
    {"label": "市辖区", "value": "341601", "parentId": "341600"},
    {"label": "谯城区", "value": "341602", "parentId": "341600"},
    {"label": "涡阳县", "value": "341621", "parentId": "341600"},
    {"label": "蒙城县", "value": "341622", "parentId": "341600"},
    {"label": "利辛县", "value": "341623", "parentId": "341600"},
    {"label": "池州市", "value": "341700", "parentId": "340000"},
    {"label": "市辖区", "value": "341701", "parentId": "341700"},
    {"label": "贵池区", "value": "341702", "parentId": "341700"},
    {"label": "东至县", "value": "341721", "parentId": "341700"},
    {"label": "石台县", "value": "341722", "parentId": "341700"},
    {"label": "青阳县", "value": "341723", "parentId": "341700"},
    {"label": "宣城市", "value": "341800", "parentId": "340000"},
    {"label": "市辖区", "value": "341801", "parentId": "341800"},
    {"label": "宣州区", "value": "341802", "parentId": "341800"},
    {"label": "郎溪县", "value": "341821", "parentId": "341800"},
    {"label": "广德县", "value": "341822", "parentId": "341800"},
    {"label": "泾县", "value": "341823", "parentId": "341800"},
    {"label": "绩溪县", "value": "341824", "parentId": "341800"},
    {"label": "旌德县", "value": "341825", "parentId": "341800"},
    {"label": "宁国市", "value": "341881", "parentId": "341800"},
    {"label": "福建省", "value": "350000", "parentId": "root"},
    {"label": "福州市", "value": "350100", "parentId": "350000"},
    {"label": "市辖区", "value": "350101", "parentId": "350100"},
    {"label": "鼓楼区", "value": "350102", "parentId": "350100"},
    {"label": "台江区", "value": "350103", "parentId": "350100"},
    {"label": "仓山区", "value": "350104", "parentId": "350100"},
    {"label": "马尾区", "value": "350105", "parentId": "350100"},
    {"label": "晋安区", "value": "350111", "parentId": "350100"},
    {"label": "闽侯县", "value": "350121", "parentId": "350100"},
    {"label": "连江县", "value": "350122", "parentId": "350100"},
    {"label": "罗源县", "value": "350123", "parentId": "350100"},
    {"label": "闽清县", "value": "350124", "parentId": "350100"},
    {"label": "永泰县", "value": "350125", "parentId": "350100"},
    {"label": "平潭县", "value": "350128", "parentId": "350100"},
    {"label": "福清市", "value": "350181", "parentId": "350100"},
    {"label": "长乐市", "value": "350182", "parentId": "350100"},
    {"label": "厦门市", "value": "350200", "parentId": "350000"},
    {"label": "市辖区", "value": "350201", "parentId": "350200"},
    {"label": "思明区", "value": "350203", "parentId": "350200"},
    {"label": "海沧区", "value": "350205", "parentId": "350200"},
    {"label": "湖里区", "value": "350206", "parentId": "350200"},
    {"label": "集美区", "value": "350211", "parentId": "350200"},
    {"label": "同安区", "value": "350212", "parentId": "350200"},
    {"label": "翔安区", "value": "350213", "parentId": "350200"},
    {"label": "莆田市", "value": "350300", "parentId": "350000"},
    {"label": "市辖区", "value": "350301", "parentId": "350300"},
    {"label": "城厢区", "value": "350302", "parentId": "350300"},
    {"label": "涵江区", "value": "350303", "parentId": "350300"},
    {"label": "荔城区", "value": "350304", "parentId": "350300"},
    {"label": "秀屿区", "value": "350305", "parentId": "350300"},
    {"label": "仙游县", "value": "350322", "parentId": "350300"},
    {"label": "三明市", "value": "350400", "parentId": "350000"},
    {"label": "市辖区", "value": "350401", "parentId": "350400"},
    {"label": "梅列区", "value": "350402", "parentId": "350400"},
    {"label": "三元区", "value": "350403", "parentId": "350400"},
    {"label": "明溪县", "value": "350421", "parentId": "350400"},
    {"label": "清流县", "value": "350423", "parentId": "350400"},
    {"label": "宁化县", "value": "350424", "parentId": "350400"},
    {"label": "大田县", "value": "350425", "parentId": "350400"},
    {"label": "尤溪县", "value": "350426", "parentId": "350400"},
    {"label": "沙县", "value": "350427", "parentId": "350400"},
    {"label": "将乐县", "value": "350428", "parentId": "350400"},
    {"label": "泰宁县", "value": "350429", "parentId": "350400"},
    {"label": "建宁县", "value": "350430", "parentId": "350400"},
    {"label": "永安市", "value": "350481", "parentId": "350400"},
    {"label": "泉州市", "value": "350500", "parentId": "350000"},
    {"label": "市辖区", "value": "350501", "parentId": "350500"},
    {"label": "鲤城区", "value": "350502", "parentId": "350500"},
    {"label": "丰泽区", "value": "350503", "parentId": "350500"},
    {"label": "洛江区", "value": "350504", "parentId": "350500"},
    {"label": "泉港区", "value": "350505", "parentId": "350500"},
    {"label": "惠安县", "value": "350521", "parentId": "350500"},
    {"label": "安溪县", "value": "350524", "parentId": "350500"},
    {"label": "永春县", "value": "350525", "parentId": "350500"},
    {"label": "德化县", "value": "350526", "parentId": "350500"},
    {"label": "金门县", "value": "350527", "parentId": "350500"},
    {"label": "石狮市", "value": "350581", "parentId": "350500"},
    {"label": "晋江市", "value": "350582", "parentId": "350500"},
    {"label": "南安市", "value": "350583", "parentId": "350500"},
    {"label": "漳州市", "value": "350600", "parentId": "350000"},
    {"label": "市辖区", "value": "350601", "parentId": "350600"},
    {"label": "芗城区", "value": "350602", "parentId": "350600"},
    {"label": "龙文区", "value": "350603", "parentId": "350600"},
    {"label": "云霄县", "value": "350622", "parentId": "350600"},
    {"label": "漳浦县", "value": "350623", "parentId": "350600"},
    {"label": "诏安县", "value": "350624", "parentId": "350600"},
    {"label": "长泰县", "value": "350625", "parentId": "350600"},
    {"label": "东山县", "value": "350626", "parentId": "350600"},
    {"label": "南靖县", "value": "350627", "parentId": "350600"},
    {"label": "平和县", "value": "350628", "parentId": "350600"},
    {"label": "华安县", "value": "350629", "parentId": "350600"},
    {"label": "龙海市", "value": "350681", "parentId": "350600"},
    {"label": "南平市", "value": "350700", "parentId": "350000"},
    {"label": "市辖区", "value": "350701", "parentId": "350700"},
    {"label": "延平区", "value": "350702", "parentId": "350700"},
    {"label": "顺昌县", "value": "350721", "parentId": "350700"},
    {"label": "浦城县", "value": "350722", "parentId": "350700"},
    {"label": "光泽县", "value": "350723", "parentId": "350700"},
    {"label": "松溪县", "value": "350724", "parentId": "350700"},
    {"label": "政和县", "value": "350725", "parentId": "350700"},
    {"label": "邵武市", "value": "350781", "parentId": "350700"},
    {"label": "武夷山市", "value": "350782", "parentId": "350700"},
    {"label": "建瓯市", "value": "350783", "parentId": "350700"},
    {"label": "建阳市", "value": "350784", "parentId": "350700"},
    {"label": "龙岩市", "value": "350800", "parentId": "350000"},
    {"label": "市辖区", "value": "350801", "parentId": "350800"},
    {"label": "新罗区", "value": "350802", "parentId": "350800"},
    {"label": "长汀县", "value": "350821", "parentId": "350800"},
    {"label": "永定县", "value": "350822", "parentId": "350800"},
    {"label": "上杭县", "value": "350823", "parentId": "350800"},
    {"label": "武平县", "value": "350824", "parentId": "350800"},
    {"label": "连城县", "value": "350825", "parentId": "350800"},
    {"label": "漳平市", "value": "350881", "parentId": "350800"},
    {"label": "宁德市", "value": "350900", "parentId": "350000"},
    {"label": "市辖区", "value": "350901", "parentId": "350900"},
    {"label": "蕉城区", "value": "350902", "parentId": "350900"},
    {"label": "霞浦县", "value": "350921", "parentId": "350900"},
    {"label": "古田县", "value": "350922", "parentId": "350900"},
    {"label": "屏南县", "value": "350923", "parentId": "350900"},
    {"label": "寿宁县", "value": "350924", "parentId": "350900"},
    {"label": "周宁县", "value": "350925", "parentId": "350900"},
    {"label": "柘荣县", "value": "350926", "parentId": "350900"},
    {"label": "福安市", "value": "350981", "parentId": "350900"},
    {"label": "福鼎市", "value": "350982", "parentId": "350900"},
    {"label": "江西省", "value": "360000", "parentId": "root"},
    {"label": "南昌市", "value": "360100", "parentId": "360000"},
    {"label": "市辖区", "value": "360101", "parentId": "360100"},
    {"label": "东湖区", "value": "360102", "parentId": "360100"},
    {"label": "西湖区", "value": "360103", "parentId": "360100"},
    {"label": "青云谱区", "value": "360104", "parentId": "360100"},
    {"label": "湾里区", "value": "360105", "parentId": "360100"},
    {"label": "青山湖区", "value": "360111", "parentId": "360100"},
    {"label": "南昌县", "value": "360121", "parentId": "360100"},
    {"label": "新建县", "value": "360122", "parentId": "360100"},
    {"label": "安义县", "value": "360123", "parentId": "360100"},
    {"label": "进贤县", "value": "360124", "parentId": "360100"},
    {"label": "景德镇市", "value": "360200", "parentId": "360000"},
    {"label": "市辖区", "value": "360201", "parentId": "360200"},
    {"label": "昌江区", "value": "360202", "parentId": "360200"},
    {"label": "珠山区", "value": "360203", "parentId": "360200"},
    {"label": "浮梁县", "value": "360222", "parentId": "360200"},
    {"label": "乐平市", "value": "360281", "parentId": "360200"},
    {"label": "萍乡市", "value": "360300", "parentId": "360000"},
    {"label": "市辖区", "value": "360301", "parentId": "360300"},
    {"label": "安源区", "value": "360302", "parentId": "360300"},
    {"label": "湘东区", "value": "360313", "parentId": "360300"},
    {"label": "莲花县", "value": "360321", "parentId": "360300"},
    {"label": "上栗县", "value": "360322", "parentId": "360300"},
    {"label": "芦溪县", "value": "360323", "parentId": "360300"},
    {"label": "九江市", "value": "360400", "parentId": "360000"},
    {"label": "市辖区", "value": "360401", "parentId": "360400"},
    {"label": "庐山区", "value": "360402", "parentId": "360400"},
    {"label": "浔阳区", "value": "360403", "parentId": "360400"},
    {"label": "九江县", "value": "360421", "parentId": "360400"},
    {"label": "武宁县", "value": "360423", "parentId": "360400"},
    {"label": "修水县", "value": "360424", "parentId": "360400"},
    {"label": "永修县", "value": "360425", "parentId": "360400"},
    {"label": "德安县", "value": "360426", "parentId": "360400"},
    {"label": "星子县", "value": "360427", "parentId": "360400"},
    {"label": "都昌县", "value": "360428", "parentId": "360400"},
    {"label": "湖口县", "value": "360429", "parentId": "360400"},
    {"label": "彭泽县", "value": "360430", "parentId": "360400"},
    {"label": "瑞昌市", "value": "360481", "parentId": "360400"},
    {"label": "新余市", "value": "360500", "parentId": "360000"},
    {"label": "市辖区", "value": "360501", "parentId": "360500"},
    {"label": "渝水区", "value": "360502", "parentId": "360500"},
    {"label": "分宜县", "value": "360521", "parentId": "360500"},
    {"label": "鹰潭市", "value": "360600", "parentId": "360000"},
    {"label": "市辖区", "value": "360601", "parentId": "360600"},
    {"label": "月湖区", "value": "360602", "parentId": "360600"},
    {"label": "余江县", "value": "360622", "parentId": "360600"},
    {"label": "贵溪市", "value": "360681", "parentId": "360600"},
    {"label": "赣州市", "value": "360700", "parentId": "360000"},
    {"label": "市辖区", "value": "360701", "parentId": "360700"},
    {"label": "章贡区", "value": "360702", "parentId": "360700"},
    {"label": "赣县", "value": "360721", "parentId": "360700"},
    {"label": "信丰县", "value": "360722", "parentId": "360700"},
    {"label": "大余县", "value": "360723", "parentId": "360700"},
    {"label": "上犹县", "value": "360724", "parentId": "360700"},
    {"label": "崇义县", "value": "360725", "parentId": "360700"},
    {"label": "安远县", "value": "360726", "parentId": "360700"},
    {"label": "龙南县", "value": "360727", "parentId": "360700"},
    {"label": "定南县", "value": "360728", "parentId": "360700"},
    {"label": "全南县", "value": "360729", "parentId": "360700"},
    {"label": "宁都县", "value": "360730", "parentId": "360700"},
    {"label": "于都县", "value": "360731", "parentId": "360700"},
    {"label": "兴国县", "value": "360732", "parentId": "360700"},
    {"label": "会昌县", "value": "360733", "parentId": "360700"},
    {"label": "寻乌县", "value": "360734", "parentId": "360700"},
    {"label": "石城县", "value": "360735", "parentId": "360700"},
    {"label": "瑞金市", "value": "360781", "parentId": "360700"},
    {"label": "南康市", "value": "360782", "parentId": "360700"},
    {"label": "吉安市", "value": "360800", "parentId": "360000"},
    {"label": "市辖区", "value": "360801", "parentId": "360800"},
    {"label": "吉州区", "value": "360802", "parentId": "360800"},
    {"label": "青原区", "value": "360803", "parentId": "360800"},
    {"label": "吉安县", "value": "360821", "parentId": "360800"},
    {"label": "吉水县", "value": "360822", "parentId": "360800"},
    {"label": "峡江县", "value": "360823", "parentId": "360800"},
    {"label": "新干县", "value": "360824", "parentId": "360800"},
    {"label": "永丰县", "value": "360825", "parentId": "360800"},
    {"label": "泰和县", "value": "360826", "parentId": "360800"},
    {"label": "遂川县", "value": "360827", "parentId": "360800"},
    {"label": "万安县", "value": "360828", "parentId": "360800"},
    {"label": "安福县", "value": "360829", "parentId": "360800"},
    {"label": "永新县", "value": "360830", "parentId": "360800"},
    {"label": "井冈山市", "value": "360881", "parentId": "360800"},
    {"label": "宜春市", "value": "360900", "parentId": "360000"},
    {"label": "市辖区", "value": "360901", "parentId": "360900"},
    {"label": "袁州区", "value": "360902", "parentId": "360900"},
    {"label": "奉新县", "value": "360921", "parentId": "360900"},
    {"label": "万载县", "value": "360922", "parentId": "360900"},
    {"label": "上高县", "value": "360923", "parentId": "360900"},
    {"label": "宜丰县", "value": "360924", "parentId": "360900"},
    {"label": "靖安县", "value": "360925", "parentId": "360900"},
    {"label": "铜鼓县", "value": "360926", "parentId": "360900"},
    {"label": "丰城市", "value": "360981", "parentId": "360900"},
    {"label": "樟树市", "value": "360982", "parentId": "360900"},
    {"label": "高安市", "value": "360983", "parentId": "360900"},
    {"label": "抚州市", "value": "361000", "parentId": "360000"},
    {"label": "市辖区", "value": "361001", "parentId": "361000"},
    {"label": "临川区", "value": "361002", "parentId": "361000"},
    {"label": "南城县", "value": "361021", "parentId": "361000"},
    {"label": "黎川县", "value": "361022", "parentId": "361000"},
    {"label": "南丰县", "value": "361023", "parentId": "361000"},
    {"label": "崇仁县", "value": "361024", "parentId": "361000"},
    {"label": "乐安县", "value": "361025", "parentId": "361000"},
    {"label": "宜黄县", "value": "361026", "parentId": "361000"},
    {"label": "金溪县", "value": "361027", "parentId": "361000"},
    {"label": "资溪县", "value": "361028", "parentId": "361000"},
    {"label": "东乡县", "value": "361029", "parentId": "361000"},
    {"label": "广昌县", "value": "361030", "parentId": "361000"},
    {"label": "上饶市", "value": "361100", "parentId": "360000"},
    {"label": "市辖区", "value": "361101", "parentId": "361100"},
    {"label": "信州区", "value": "361102", "parentId": "361100"},
    {"label": "上饶县", "value": "361121", "parentId": "361100"},
    {"label": "广丰县", "value": "361122", "parentId": "361100"},
    {"label": "玉山县", "value": "361123", "parentId": "361100"},
    {"label": "铅山县", "value": "361124", "parentId": "361100"},
    {"label": "横峰县", "value": "361125", "parentId": "361100"},
    {"label": "弋阳县", "value": "361126", "parentId": "361100"},
    {"label": "余干县", "value": "361127", "parentId": "361100"},
    {"label": "鄱阳县", "value": "361128", "parentId": "361100"},
    {"label": "万年县", "value": "361129", "parentId": "361100"},
    {"label": "婺源县", "value": "361130", "parentId": "361100"},
    {"label": "德兴市", "value": "361181", "parentId": "361100"},
    {"label": "山东省", "value": "370000", "parentId": "root"},
    {"label": "济南市", "value": "370100", "parentId": "370000"},
    {"label": "市辖区", "value": "370101", "parentId": "370100"},
    {"label": "历下区", "value": "370102", "parentId": "370100"},
    {"label": "市中区", "value": "370103", "parentId": "370100"},
    {"label": "槐荫区", "value": "370104", "parentId": "370100"},
    {"label": "天桥区", "value": "370105", "parentId": "370100"},
    {"label": "历城区", "value": "370112", "parentId": "370100"},
    {"label": "长清区", "value": "370113", "parentId": "370100"},
    {"label": "平阴县", "value": "370124", "parentId": "370100"},
    {"label": "济阳县", "value": "370125", "parentId": "370100"},
    {"label": "商河县", "value": "370126", "parentId": "370100"},
    {"label": "章丘市", "value": "370181", "parentId": "370100"},
    {"label": "青岛市", "value": "370200", "parentId": "370000"},
    {"label": "市辖区", "value": "370201", "parentId": "370200"},
    {"label": "市南区", "value": "370202", "parentId": "370200"},
    {"label": "市北区", "value": "370203", "parentId": "370200"},
    {"label": "四方区", "value": "370205", "parentId": "370200"},
    {"label": "黄岛区", "value": "370211", "parentId": "370200"},
    {"label": "崂山区", "value": "370212", "parentId": "370200"},
    {"label": "李沧区", "value": "370213", "parentId": "370200"},
    {"label": "城阳区", "value": "370214", "parentId": "370200"},
    {"label": "胶州市", "value": "370281", "parentId": "370200"},
    {"label": "即墨市", "value": "370282", "parentId": "370200"},
    {"label": "平度市", "value": "370283", "parentId": "370200"},
    {"label": "胶南市", "value": "370284", "parentId": "370200"},
    {"label": "莱西市", "value": "370285", "parentId": "370200"},
    {"label": "淄博市", "value": "370300", "parentId": "370000"},
    {"label": "市辖区", "value": "370301", "parentId": "370300"},
    {"label": "淄川区", "value": "370302", "parentId": "370300"},
    {"label": "张店区", "value": "370303", "parentId": "370300"},
    {"label": "博山区", "value": "370304", "parentId": "370300"},
    {"label": "临淄区", "value": "370305", "parentId": "370300"},
    {"label": "周村区", "value": "370306", "parentId": "370300"},
    {"label": "桓台县", "value": "370321", "parentId": "370300"},
    {"label": "高青县", "value": "370322", "parentId": "370300"},
    {"label": "沂源县", "value": "370323", "parentId": "370300"},
    {"label": "枣庄市", "value": "370400", "parentId": "370000"},
    {"label": "市辖区", "value": "370401", "parentId": "370400"},
    {"label": "市中区", "value": "370402", "parentId": "370400"},
    {"label": "薛城区", "value": "370403", "parentId": "370400"},
    {"label": "峄城区", "value": "370404", "parentId": "370400"},
    {"label": "台儿庄区", "value": "370405", "parentId": "370400"},
    {"label": "山亭区", "value": "370406", "parentId": "370400"},
    {"label": "滕州市", "value": "370481", "parentId": "370400"},
    {"label": "东营市", "value": "370500", "parentId": "370000"},
    {"label": "市辖区", "value": "370501", "parentId": "370500"},
    {"label": "东营区", "value": "370502", "parentId": "370500"},
    {"label": "河口区", "value": "370503", "parentId": "370500"},
    {"label": "垦利县", "value": "370521", "parentId": "370500"},
    {"label": "利津县", "value": "370522", "parentId": "370500"},
    {"label": "广饶县", "value": "370523", "parentId": "370500"},
    {"label": "烟台市", "value": "370600", "parentId": "370000"},
    {"label": "市辖区", "value": "370601", "parentId": "370600"},
    {"label": "芝罘区", "value": "370602", "parentId": "370600"},
    {"label": "福山区", "value": "370611", "parentId": "370600"},
    {"label": "牟平区", "value": "370612", "parentId": "370600"},
    {"label": "莱山区", "value": "370613", "parentId": "370600"},
    {"label": "长岛县", "value": "370634", "parentId": "370600"},
    {"label": "龙口市", "value": "370681", "parentId": "370600"},
    {"label": "莱阳市", "value": "370682", "parentId": "370600"},
    {"label": "莱州市", "value": "370683", "parentId": "370600"},
    {"label": "蓬莱市", "value": "370684", "parentId": "370600"},
    {"label": "招远市", "value": "370685", "parentId": "370600"},
    {"label": "栖霞市", "value": "370686", "parentId": "370600"},
    {"label": "海阳市", "value": "370687", "parentId": "370600"},
    {"label": "潍坊市", "value": "370700", "parentId": "370000"},
    {"label": "市辖区", "value": "370701", "parentId": "370700"},
    {"label": "潍城区", "value": "370702", "parentId": "370700"},
    {"label": "寒亭区", "value": "370703", "parentId": "370700"},
    {"label": "坊子区", "value": "370704", "parentId": "370700"},
    {"label": "奎文区", "value": "370705", "parentId": "370700"},
    {"label": "临朐县", "value": "370724", "parentId": "370700"},
    {"label": "昌乐县", "value": "370725", "parentId": "370700"},
    {"label": "青州市", "value": "370781", "parentId": "370700"},
    {"label": "诸城市", "value": "370782", "parentId": "370700"},
    {"label": "寿光市", "value": "370783", "parentId": "370700"},
    {"label": "安丘市", "value": "370784", "parentId": "370700"},
    {"label": "高密市", "value": "370785", "parentId": "370700"},
    {"label": "昌邑市", "value": "370786", "parentId": "370700"},
    {"label": "济宁市", "value": "370800", "parentId": "370000"},
    {"label": "市辖区", "value": "370801", "parentId": "370800"},
    {"label": "市中区", "value": "370802", "parentId": "370800"},
    {"label": "任城区", "value": "370811", "parentId": "370800"},
    {"label": "微山县", "value": "370826", "parentId": "370800"},
    {"label": "鱼台县", "value": "370827", "parentId": "370800"},
    {"label": "金乡县", "value": "370828", "parentId": "370800"},
    {"label": "嘉祥县", "value": "370829", "parentId": "370800"},
    {"label": "汶上县", "value": "370830", "parentId": "370800"},
    {"label": "泗水县", "value": "370831", "parentId": "370800"},
    {"label": "梁山县", "value": "370832", "parentId": "370800"},
    {"label": "曲阜市", "value": "370881", "parentId": "370800"},
    {"label": "兖州市", "value": "370882", "parentId": "370800"},
    {"label": "邹城市", "value": "370883", "parentId": "370800"},
    {"label": "泰安市", "value": "370900", "parentId": "370000"},
    {"label": "市辖区", "value": "370901", "parentId": "370900"},
    {"label": "泰山区", "value": "370902", "parentId": "370900"},
    {"label": "岱岳区", "value": "370903", "parentId": "370900"},
    {"label": "宁阳县", "value": "370921", "parentId": "370900"},
    {"label": "东平县", "value": "370923", "parentId": "370900"},
    {"label": "新泰市", "value": "370982", "parentId": "370900"},
    {"label": "肥城市", "value": "370983", "parentId": "370900"},
    {"label": "威海市", "value": "371000", "parentId": "370000"},
    {"label": "市辖区", "value": "371001", "parentId": "371000"},
    {"label": "环翠区", "value": "371002", "parentId": "371000"},
    {"label": "文登市", "value": "371081", "parentId": "371000"},
    {"label": "荣成市", "value": "371082", "parentId": "371000"},
    {"label": "乳山市", "value": "371083", "parentId": "371000"},
    {"label": "日照市", "value": "371100", "parentId": "370000"},
    {"label": "市辖区", "value": "371101", "parentId": "371100"},
    {"label": "东港区", "value": "371102", "parentId": "371100"},
    {"label": "岚山区", "value": "371103", "parentId": "371100"},
    {"label": "五莲县", "value": "371121", "parentId": "371100"},
    {"label": "莒县", "value": "371122", "parentId": "371100"},
    {"label": "莱芜市", "value": "371200", "parentId": "370000"},
    {"label": "市辖区", "value": "371201", "parentId": "371200"},
    {"label": "莱城区", "value": "371202", "parentId": "371200"},
    {"label": "钢城区", "value": "371203", "parentId": "371200"},
    {"label": "临沂市", "value": "371300", "parentId": "370000"},
    {"label": "市辖区", "value": "371301", "parentId": "371300"},
    {"label": "兰山区", "value": "371302", "parentId": "371300"},
    {"label": "罗庄区", "value": "371311", "parentId": "371300"},
    {"label": "河东区", "value": "371312", "parentId": "371300"},
    {"label": "沂南县", "value": "371321", "parentId": "371300"},
    {"label": "郯城县", "value": "371322", "parentId": "371300"},
    {"label": "沂水县", "value": "371323", "parentId": "371300"},
    {"label": "苍山县", "value": "371324", "parentId": "371300"},
    {"label": "费县", "value": "371325", "parentId": "371300"},
    {"label": "平邑县", "value": "371326", "parentId": "371300"},
    {"label": "莒南县", "value": "371327", "parentId": "371300"},
    {"label": "蒙阴县", "value": "371328", "parentId": "371300"},
    {"label": "临沭县", "value": "371329", "parentId": "371300"},
    {"label": "德州市", "value": "371400", "parentId": "370000"},
    {"label": "市辖区", "value": "371401", "parentId": "371400"},
    {"label": "德城区", "value": "371402", "parentId": "371400"},
    {"label": "陵县", "value": "371421", "parentId": "371400"},
    {"label": "宁津县", "value": "371422", "parentId": "371400"},
    {"label": "庆云县", "value": "371423", "parentId": "371400"},
    {"label": "临邑县", "value": "371424", "parentId": "371400"},
    {"label": "齐河县", "value": "371425", "parentId": "371400"},
    {"label": "平原县", "value": "371426", "parentId": "371400"},
    {"label": "夏津县", "value": "371427", "parentId": "371400"},
    {"label": "武城县", "value": "371428", "parentId": "371400"},
    {"label": "乐陵市", "value": "371481", "parentId": "371400"},
    {"label": "禹城市", "value": "371482", "parentId": "371400"},
    {"label": "聊城市", "value": "371500", "parentId": "370000"},
    {"label": "市辖区", "value": "371501", "parentId": "371500"},
    {"label": "东昌府区", "value": "371502", "parentId": "371500"},
    {"label": "阳谷县", "value": "371521", "parentId": "371500"},
    {"label": "莘县", "value": "371522", "parentId": "371500"},
    {"label": "茌平县", "value": "371523", "parentId": "371500"},
    {"label": "东阿县", "value": "371524", "parentId": "371500"},
    {"label": "冠县", "value": "371525", "parentId": "371500"},
    {"label": "高唐县", "value": "371526", "parentId": "371500"},
    {"label": "临清市", "value": "371581", "parentId": "371500"},
    {"label": "滨州市", "value": "371600", "parentId": "370000"},
    {"label": "市辖区", "value": "371601", "parentId": "371600"},
    {"label": "滨城区", "value": "371602", "parentId": "371600"},
    {"label": "惠民县", "value": "371621", "parentId": "371600"},
    {"label": "阳信县", "value": "371622", "parentId": "371600"},
    {"label": "无棣县", "value": "371623", "parentId": "371600"},
    {"label": "沾化县", "value": "371624", "parentId": "371600"},
    {"label": "博兴县", "value": "371625", "parentId": "371600"},
    {"label": "邹平县", "value": "371626", "parentId": "371600"},
    {"label": "荷泽市", "value": "371700", "parentId": "370000"},
    {"label": "市辖区", "value": "371701", "parentId": "371700"},
    {"label": "牡丹区", "value": "371702", "parentId": "371700"},
    {"label": "曹县", "value": "371721", "parentId": "371700"},
    {"label": "单县", "value": "371722", "parentId": "371700"},
    {"label": "成武县", "value": "371723", "parentId": "371700"},
    {"label": "巨野县", "value": "371724", "parentId": "371700"},
    {"label": "郓城县", "value": "371725", "parentId": "371700"},
    {"label": "鄄城县", "value": "371726", "parentId": "371700"},
    {"label": "定陶县", "value": "371727", "parentId": "371700"},
    {"label": "东明县", "value": "371728", "parentId": "371700"},
    {"label": "河南省", "value": "410000", "parentId": "root"},
    {"label": "郑州市", "value": "410100", "parentId": "410000"},
    {"label": "市辖区", "value": "410101", "parentId": "410100"},
    {"label": "中原区", "value": "410102", "parentId": "410100"},
    {"label": "二七区", "value": "410103", "parentId": "410100"},
    {"label": "管城回族区", "value": "410104", "parentId": "410100"},
    {"label": "金水区", "value": "410105", "parentId": "410100"},
    {"label": "上街区", "value": "410106", "parentId": "410100"},
    {"label": "邙山区", "value": "410108", "parentId": "410100"},
    {"label": "中牟县", "value": "410122", "parentId": "410100"},
    {"label": "巩义市", "value": "410181", "parentId": "410100"},
    {"label": "荥阳市", "value": "410182", "parentId": "410100"},
    {"label": "新密市", "value": "410183", "parentId": "410100"},
    {"label": "新郑市", "value": "410184", "parentId": "410100"},
    {"label": "登封市", "value": "410185", "parentId": "410100"},
    {"label": "开封市", "value": "410200", "parentId": "410000"},
    {"label": "市辖区", "value": "410201", "parentId": "410200"},
    {"label": "龙亭区", "value": "410202", "parentId": "410200"},
    {"label": "顺河回族区", "value": "410203", "parentId": "410200"},
    {"label": "鼓楼区", "value": "410204", "parentId": "410200"},
    {"label": "南关区", "value": "410205", "parentId": "410200"},
    {"label": "郊区", "value": "410211", "parentId": "410200"},
    {"label": "杞县", "value": "410221", "parentId": "410200"},
    {"label": "通许县", "value": "410222", "parentId": "410200"},
    {"label": "尉氏县", "value": "410223", "parentId": "410200"},
    {"label": "开封县", "value": "410224", "parentId": "410200"},
    {"label": "兰考县", "value": "410225", "parentId": "410200"},
    {"label": "洛阳市", "value": "410300", "parentId": "410000"},
    {"label": "市辖区", "value": "410301", "parentId": "410300"},
    {"label": "老城区", "value": "410302", "parentId": "410300"},
    {"label": "西工区", "value": "410303", "parentId": "410300"},
    {"label": "廛河回族区", "value": "410304", "parentId": "410300"},
    {"label": "涧西区", "value": "410305", "parentId": "410300"},
    {"label": "吉利区", "value": "410306", "parentId": "410300"},
    {"label": "洛龙区", "value": "410307", "parentId": "410300"},
    {"label": "孟津县", "value": "410322", "parentId": "410300"},
    {"label": "新安县", "value": "410323", "parentId": "410300"},
    {"label": "栾川县", "value": "410324", "parentId": "410300"},
    {"label": "嵩县", "value": "410325", "parentId": "410300"},
    {"label": "汝阳县", "value": "410326", "parentId": "410300"},
    {"label": "宜阳县", "value": "410327", "parentId": "410300"},
    {"label": "洛宁县", "value": "410328", "parentId": "410300"},
    {"label": "伊川县", "value": "410329", "parentId": "410300"},
    {"label": "偃师市", "value": "410381", "parentId": "410300"},
    {"label": "平顶山市", "value": "410400", "parentId": "410000"},
    {"label": "市辖区", "value": "410401", "parentId": "410400"},
    {"label": "新华区", "value": "410402", "parentId": "410400"},
    {"label": "卫东区", "value": "410403", "parentId": "410400"},
    {"label": "石龙区", "value": "410404", "parentId": "410400"},
    {"label": "湛河区", "value": "410411", "parentId": "410400"},
    {"label": "宝丰县", "value": "410421", "parentId": "410400"},
    {"label": "叶县", "value": "410422", "parentId": "410400"},
    {"label": "鲁山县", "value": "410423", "parentId": "410400"},
    {"label": "郏县", "value": "410425", "parentId": "410400"},
    {"label": "舞钢市", "value": "410481", "parentId": "410400"},
    {"label": "汝州市", "value": "410482", "parentId": "410400"},
    {"label": "安阳市", "value": "410500", "parentId": "410000"},
    {"label": "市辖区", "value": "410501", "parentId": "410500"},
    {"label": "文峰区", "value": "410502", "parentId": "410500"},
    {"label": "北关区", "value": "410503", "parentId": "410500"},
    {"label": "殷都区", "value": "410505", "parentId": "410500"},
    {"label": "龙安区", "value": "410506", "parentId": "410500"},
    {"label": "安阳县", "value": "410522", "parentId": "410500"},
    {"label": "汤阴县", "value": "410523", "parentId": "410500"},
    {"label": "滑县", "value": "410526", "parentId": "410500"},
    {"label": "内黄县", "value": "410527", "parentId": "410500"},
    {"label": "林州市", "value": "410581", "parentId": "410500"},
    {"label": "鹤壁市", "value": "410600", "parentId": "410000"},
    {"label": "市辖区", "value": "410601", "parentId": "410600"},
    {"label": "鹤山区", "value": "410602", "parentId": "410600"},
    {"label": "山城区", "value": "410603", "parentId": "410600"},
    {"label": "淇滨区", "value": "410611", "parentId": "410600"},
    {"label": "浚县", "value": "410621", "parentId": "410600"},
    {"label": "淇县", "value": "410622", "parentId": "410600"},
    {"label": "新乡市", "value": "410700", "parentId": "410000"},
    {"label": "市辖区", "value": "410701", "parentId": "410700"},
    {"label": "红旗区", "value": "410702", "parentId": "410700"},
    {"label": "卫滨区", "value": "410703", "parentId": "410700"},
    {"label": "凤泉区", "value": "410704", "parentId": "410700"},
    {"label": "牧野区", "value": "410711", "parentId": "410700"},
    {"label": "新乡县", "value": "410721", "parentId": "410700"},
    {"label": "获嘉县", "value": "410724", "parentId": "410700"},
    {"label": "原阳县", "value": "410725", "parentId": "410700"},
    {"label": "延津县", "value": "410726", "parentId": "410700"},
    {"label": "封丘县", "value": "410727", "parentId": "410700"},
    {"label": "长垣县", "value": "410728", "parentId": "410700"},
    {"label": "卫辉市", "value": "410781", "parentId": "410700"},
    {"label": "辉县市", "value": "410782", "parentId": "410700"},
    {"label": "焦作市", "value": "410800", "parentId": "410000"},
    {"label": "市辖区", "value": "410801", "parentId": "410800"},
    {"label": "解放区", "value": "410802", "parentId": "410800"},
    {"label": "中站区", "value": "410803", "parentId": "410800"},
    {"label": "马村区", "value": "410804", "parentId": "410800"},
    {"label": "山阳区", "value": "410811", "parentId": "410800"},
    {"label": "修武县", "value": "410821", "parentId": "410800"},
    {"label": "博爱县", "value": "410822", "parentId": "410800"},
    {"label": "武陟县", "value": "410823", "parentId": "410800"},
    {"label": "温县", "value": "410825", "parentId": "410800"},
    {"label": "济源市", "value": "410881", "parentId": "410800"},
    {"label": "沁阳市", "value": "410882", "parentId": "410800"},
    {"label": "孟州市", "value": "410883", "parentId": "410800"},
    {"label": "濮阳市", "value": "410900", "parentId": "410000"},
    {"label": "市辖区", "value": "410901", "parentId": "410900"},
    {"label": "华龙区", "value": "410902", "parentId": "410900"},
    {"label": "清丰县", "value": "410922", "parentId": "410900"},
    {"label": "南乐县", "value": "410923", "parentId": "410900"},
    {"label": "范县", "value": "410926", "parentId": "410900"},
    {"label": "台前县", "value": "410927", "parentId": "410900"},
    {"label": "濮阳县", "value": "410928", "parentId": "410900"},
    {"label": "许昌市", "value": "411000", "parentId": "410000"},
    {"label": "市辖区", "value": "411001", "parentId": "411000"},
    {"label": "魏都区", "value": "411002", "parentId": "411000"},
    {"label": "许昌县", "value": "411023", "parentId": "411000"},
    {"label": "鄢陵县", "value": "411024", "parentId": "411000"},
    {"label": "襄城县", "value": "411025", "parentId": "411000"},
    {"label": "禹州市", "value": "411081", "parentId": "411000"},
    {"label": "长葛市", "value": "411082", "parentId": "411000"},
    {"label": "漯河市", "value": "411100", "parentId": "410000"},
    {"label": "市辖区", "value": "411101", "parentId": "411100"},
    {"label": "源汇区", "value": "411102", "parentId": "411100"},
    {"label": "郾城区", "value": "411103", "parentId": "411100"},
    {"label": "召陵区", "value": "411104", "parentId": "411100"},
    {"label": "舞阳县", "value": "411121", "parentId": "411100"},
    {"label": "临颍县", "value": "411122", "parentId": "411100"},
    {"label": "三门峡市", "value": "411200", "parentId": "410000"},
    {"label": "市辖区", "value": "411201", "parentId": "411200"},
    {"label": "湖滨区", "value": "411202", "parentId": "411200"},
    {"label": "渑池县", "value": "411221", "parentId": "411200"},
    {"label": "陕县", "value": "411222", "parentId": "411200"},
    {"label": "卢氏县", "value": "411224", "parentId": "411200"},
    {"label": "义马市", "value": "411281", "parentId": "411200"},
    {"label": "灵宝市", "value": "411282", "parentId": "411200"},
    {"label": "南阳市", "value": "411300", "parentId": "410000"},
    {"label": "市辖区", "value": "411301", "parentId": "411300"},
    {"label": "宛城区", "value": "411302", "parentId": "411300"},
    {"label": "卧龙区", "value": "411303", "parentId": "411300"},
    {"label": "南召县", "value": "411321", "parentId": "411300"},
    {"label": "方城县", "value": "411322", "parentId": "411300"},
    {"label": "西峡县", "value": "411323", "parentId": "411300"},
    {"label": "镇平县", "value": "411324", "parentId": "411300"},
    {"label": "内乡县", "value": "411325", "parentId": "411300"},
    {"label": "淅川县", "value": "411326", "parentId": "411300"},
    {"label": "社旗县", "value": "411327", "parentId": "411300"},
    {"label": "唐河县", "value": "411328", "parentId": "411300"},
    {"label": "新野县", "value": "411329", "parentId": "411300"},
    {"label": "桐柏县", "value": "411330", "parentId": "411300"},
    {"label": "邓州市", "value": "411381", "parentId": "411300"},
    {"label": "商丘市", "value": "411400", "parentId": "410000"},
    {"label": "市辖区", "value": "411401", "parentId": "411400"},
    {"label": "梁园区", "value": "411402", "parentId": "411400"},
    {"label": "睢阳区", "value": "411403", "parentId": "411400"},
    {"label": "民权县", "value": "411421", "parentId": "411400"},
    {"label": "睢县", "value": "411422", "parentId": "411400"},
    {"label": "宁陵县", "value": "411423", "parentId": "411400"},
    {"label": "柘城县", "value": "411424", "parentId": "411400"},
    {"label": "虞城县", "value": "411425", "parentId": "411400"},
    {"label": "夏邑县", "value": "411426", "parentId": "411400"},
    {"label": "永城市", "value": "411481", "parentId": "411400"},
    {"label": "信阳市", "value": "411500", "parentId": "410000"},
    {"label": "市辖区", "value": "411501", "parentId": "411500"},
    {"label": "师河区", "value": "411502", "parentId": "411500"},
    {"label": "平桥区", "value": "411503", "parentId": "411500"},
    {"label": "罗山县", "value": "411521", "parentId": "411500"},
    {"label": "光山县", "value": "411522", "parentId": "411500"},
    {"label": "新县", "value": "411523", "parentId": "411500"},
    {"label": "商城县", "value": "411524", "parentId": "411500"},
    {"label": "固始县", "value": "411525", "parentId": "411500"},
    {"label": "潢川县", "value": "411526", "parentId": "411500"},
    {"label": "淮滨县", "value": "411527", "parentId": "411500"},
    {"label": "息县", "value": "411528", "parentId": "411500"},
    {"label": "周口市", "value": "411600", "parentId": "410000"},
    {"label": "市辖区", "value": "411601", "parentId": "411600"},
    {"label": "川汇区", "value": "411602", "parentId": "411600"},
    {"label": "扶沟县", "value": "411621", "parentId": "411600"},
    {"label": "西华县", "value": "411622", "parentId": "411600"},
    {"label": "商水县", "value": "411623", "parentId": "411600"},
    {"label": "沈丘县", "value": "411624", "parentId": "411600"},
    {"label": "郸城县", "value": "411625", "parentId": "411600"},
    {"label": "淮阳县", "value": "411626", "parentId": "411600"},
    {"label": "太康县", "value": "411627", "parentId": "411600"},
    {"label": "鹿邑县", "value": "411628", "parentId": "411600"},
    {"label": "项城市", "value": "411681", "parentId": "411600"},
    {"label": "驻马店市", "value": "411700", "parentId": "410000"},
    {"label": "市辖区", "value": "411701", "parentId": "411700"},
    {"label": "驿城区", "value": "411702", "parentId": "411700"},
    {"label": "西平县", "value": "411721", "parentId": "411700"},
    {"label": "上蔡县", "value": "411722", "parentId": "411700"},
    {"label": "平舆县", "value": "411723", "parentId": "411700"},
    {"label": "正阳县", "value": "411724", "parentId": "411700"},
    {"label": "确山县", "value": "411725", "parentId": "411700"},
    {"label": "泌阳县", "value": "411726", "parentId": "411700"},
    {"label": "汝南县", "value": "411727", "parentId": "411700"},
    {"label": "遂平县", "value": "411728", "parentId": "411700"},
    {"label": "新蔡县", "value": "411729", "parentId": "411700"},
    {"label": "湖北省", "value": "420000", "parentId": "root"},
    {"label": "武汉市", "value": "420100", "parentId": "420000"},
    {"label": "市辖区", "value": "420101", "parentId": "420100"},
    {"label": "江岸区", "value": "420102", "parentId": "420100"},
    {"label": "江汉区", "value": "420103", "parentId": "420100"},
    {"label": "乔口区", "value": "420104", "parentId": "420100"},
    {"label": "汉阳区", "value": "420105", "parentId": "420100"},
    {"label": "武昌区", "value": "420106", "parentId": "420100"},
    {"label": "青山区", "value": "420107", "parentId": "420100"},
    {"label": "洪山区", "value": "420111", "parentId": "420100"},
    {"label": "东西湖区", "value": "420112", "parentId": "420100"},
    {"label": "汉南区", "value": "420113", "parentId": "420100"},
    {"label": "蔡甸区", "value": "420114", "parentId": "420100"},
    {"label": "江夏区", "value": "420115", "parentId": "420100"},
    {"label": "黄陂区", "value": "420116", "parentId": "420100"},
    {"label": "新洲区", "value": "420117", "parentId": "420100"},
    {"label": "黄石市", "value": "420200", "parentId": "420000"},
    {"label": "市辖区", "value": "420201", "parentId": "420200"},
    {"label": "黄石港区", "value": "420202", "parentId": "420200"},
    {"label": "西塞山区", "value": "420203", "parentId": "420200"},
    {"label": "下陆区", "value": "420204", "parentId": "420200"},
    {"label": "铁山区", "value": "420205", "parentId": "420200"},
    {"label": "阳新县", "value": "420222", "parentId": "420200"},
    {"label": "大冶市", "value": "420281", "parentId": "420200"},
    {"label": "十堰市", "value": "420300", "parentId": "420000"},
    {"label": "市辖区", "value": "420301", "parentId": "420300"},
    {"label": "茅箭区", "value": "420302", "parentId": "420300"},
    {"label": "张湾区", "value": "420303", "parentId": "420300"},
    {"label": "郧县", "value": "420321", "parentId": "420300"},
    {"label": "郧西县", "value": "420322", "parentId": "420300"},
    {"label": "竹山县", "value": "420323", "parentId": "420300"},
    {"label": "竹溪县", "value": "420324", "parentId": "420300"},
    {"label": "房县", "value": "420325", "parentId": "420300"},
    {"label": "丹江口市", "value": "420381", "parentId": "420300"},
    {"label": "宜昌市", "value": "420500", "parentId": "420000"},
    {"label": "市辖区", "value": "420501", "parentId": "420500"},
    {"label": "西陵区", "value": "420502", "parentId": "420500"},
    {"label": "伍家岗区", "value": "420503", "parentId": "420500"},
    {"label": "点军区", "value": "420504", "parentId": "420500"},
    {"label": "猇亭区", "value": "420505", "parentId": "420500"},
    {"label": "夷陵区", "value": "420506", "parentId": "420500"},
    {"label": "远安县", "value": "420525", "parentId": "420500"},
    {"label": "兴山县", "value": "420526", "parentId": "420500"},
    {"label": "秭归县", "value": "420527", "parentId": "420500"},
    {"label": "长阳土家族自治县", "value": "420528", "parentId": "420500"},
    {"label": "五峰土家族自治县", "value": "420529", "parentId": "420500"},
    {"label": "宜都市", "value": "420581", "parentId": "420500"},
    {"label": "当阳市", "value": "420582", "parentId": "420500"},
    {"label": "枝江市", "value": "420583", "parentId": "420500"},
    {"label": "襄樊市", "value": "420600", "parentId": "420000"},
    {"label": "市辖区", "value": "420601", "parentId": "420600"},
    {"label": "襄城区", "value": "420602", "parentId": "420600"},
    {"label": "樊城区", "value": "420606", "parentId": "420600"},
    {"label": "襄阳区", "value": "420607", "parentId": "420600"},
    {"label": "南漳县", "value": "420624", "parentId": "420600"},
    {"label": "谷城县", "value": "420625", "parentId": "420600"},
    {"label": "保康县", "value": "420626", "parentId": "420600"},
    {"label": "老河口市", "value": "420682", "parentId": "420600"},
    {"label": "枣阳市", "value": "420683", "parentId": "420600"},
    {"label": "宜城市", "value": "420684", "parentId": "420600"},
    {"label": "鄂州市", "value": "420700", "parentId": "420000"},
    {"label": "市辖区", "value": "420701", "parentId": "420700"},
    {"label": "梁子湖区", "value": "420702", "parentId": "420700"},
    {"label": "华容区", "value": "420703", "parentId": "420700"},
    {"label": "鄂城区", "value": "420704", "parentId": "420700"},
    {"label": "荆门市", "value": "420800", "parentId": "420000"},
    {"label": "市辖区", "value": "420801", "parentId": "420800"},
    {"label": "东宝区", "value": "420802", "parentId": "420800"},
    {"label": "掇刀区", "value": "420804", "parentId": "420800"},
    {"label": "京山县", "value": "420821", "parentId": "420800"},
    {"label": "沙洋县", "value": "420822", "parentId": "420800"},
    {"label": "钟祥市", "value": "420881", "parentId": "420800"},
    {"label": "孝感市", "value": "420900", "parentId": "420000"},
    {"label": "市辖区", "value": "420901", "parentId": "420900"},
    {"label": "孝南区", "value": "420902", "parentId": "420900"},
    {"label": "孝昌县", "value": "420921", "parentId": "420900"},
    {"label": "大悟县", "value": "420922", "parentId": "420900"},
    {"label": "云梦县", "value": "420923", "parentId": "420900"},
    {"label": "应城市", "value": "420981", "parentId": "420900"},
    {"label": "安陆市", "value": "420982", "parentId": "420900"},
    {"label": "汉川市", "value": "420984", "parentId": "420900"},
    {"label": "荆州市", "value": "421000", "parentId": "420000"},
    {"label": "市辖区", "value": "421001", "parentId": "421000"},
    {"label": "沙市区", "value": "421002", "parentId": "421000"},
    {"label": "荆州区", "value": "421003", "parentId": "421000"},
    {"label": "公安县", "value": "421022", "parentId": "421000"},
    {"label": "监利县", "value": "421023", "parentId": "421000"},
    {"label": "江陵县", "value": "421024", "parentId": "421000"},
    {"label": "石首市", "value": "421081", "parentId": "421000"},
    {"label": "洪湖市", "value": "421083", "parentId": "421000"},
    {"label": "松滋市", "value": "421087", "parentId": "421000"},
    {"label": "黄冈市", "value": "421100", "parentId": "420000"},
    {"label": "市辖区", "value": "421101", "parentId": "421100"},
    {"label": "黄州区", "value": "421102", "parentId": "421100"},
    {"label": "团风县", "value": "421121", "parentId": "421100"},
    {"label": "红安县", "value": "421122", "parentId": "421100"},
    {"label": "罗田县", "value": "421123", "parentId": "421100"},
    {"label": "英山县", "value": "421124", "parentId": "421100"},
    {"label": "浠水县", "value": "421125", "parentId": "421100"},
    {"label": "蕲春县", "value": "421126", "parentId": "421100"},
    {"label": "黄梅县", "value": "421127", "parentId": "421100"},
    {"label": "麻城市", "value": "421181", "parentId": "421100"},
    {"label": "武穴市", "value": "421182", "parentId": "421100"},
    {"label": "咸宁市", "value": "421200", "parentId": "420000"},
    {"label": "市辖区", "value": "421201", "parentId": "421200"},
    {"label": "咸安区", "value": "421202", "parentId": "421200"},
    {"label": "嘉鱼县", "value": "421221", "parentId": "421200"},
    {"label": "通城县", "value": "421222", "parentId": "421200"},
    {"label": "崇阳县", "value": "421223", "parentId": "421200"},
    {"label": "通山县", "value": "421224", "parentId": "421200"},
    {"label": "赤壁市", "value": "421281", "parentId": "421200"},
    {"label": "随州市", "value": "421300", "parentId": "420000"},
    {"label": "市辖区", "value": "421301", "parentId": "421300"},
    {"label": "曾都区", "value": "421302", "parentId": "421300"},
    {"label": "广水市", "value": "421381", "parentId": "421300"},
    {"label": "恩施土家族苗族自治州", "value": "422800", "parentId": "420000"},
    {"label": "恩施市", "value": "422801", "parentId": "422800"},
    {"label": "利川市", "value": "422802", "parentId": "422800"},
    {"label": "建始县", "value": "422822", "parentId": "422800"},
    {"label": "巴东县", "value": "422823", "parentId": "422800"},
    {"label": "宣恩县", "value": "422825", "parentId": "422800"},
    {"label": "咸丰县", "value": "422826", "parentId": "422800"},
    {"label": "来凤县", "value": "422827", "parentId": "422800"},
    {"label": "鹤峰县", "value": "422828", "parentId": "422800"},
    {"label": "省直辖行政单位", "value": "429000", "parentId": "420000"},
    {"label": "仙桃市", "value": "429004", "parentId": "429000"},
    {"label": "潜江市", "value": "429005", "parentId": "429000"},
    {"label": "天门市", "value": "429006", "parentId": "429000"},
    {"label": "神农架林区", "value": "429021", "parentId": "429000"},
    {"label": "湖南省", "value": "430000", "parentId": "root"},
    {"label": "长沙市", "value": "430100", "parentId": "430000"},
    {"label": "市辖区", "value": "430101", "parentId": "430100"},
    {"label": "芙蓉区", "value": "430102", "parentId": "430100"},
    {"label": "天心区", "value": "430103", "parentId": "430100"},
    {"label": "岳麓区", "value": "430104", "parentId": "430100"},
    {"label": "开福区", "value": "430105", "parentId": "430100"},
    {"label": "雨花区", "value": "430111", "parentId": "430100"},
    {"label": "长沙县", "value": "430121", "parentId": "430100"},
    {"label": "望城县", "value": "430122", "parentId": "430100"},
    {"label": "宁乡县", "value": "430124", "parentId": "430100"},
    {"label": "浏阳市", "value": "430181", "parentId": "430100"},
    {"label": "株洲市", "value": "430200", "parentId": "430000"},
    {"label": "市辖区", "value": "430201", "parentId": "430200"},
    {"label": "荷塘区", "value": "430202", "parentId": "430200"},
    {"label": "芦淞区", "value": "430203", "parentId": "430200"},
    {"label": "石峰区", "value": "430204", "parentId": "430200"},
    {"label": "天元区", "value": "430211", "parentId": "430200"},
    {"label": "株洲县", "value": "430221", "parentId": "430200"},
    {"label": "攸县", "value": "430223", "parentId": "430200"},
    {"label": "茶陵县", "value": "430224", "parentId": "430200"},
    {"label": "炎陵县", "value": "430225", "parentId": "430200"},
    {"label": "醴陵市", "value": "430281", "parentId": "430200"},
    {"label": "湘潭市", "value": "430300", "parentId": "430000"},
    {"label": "市辖区", "value": "430301", "parentId": "430300"},
    {"label": "雨湖区", "value": "430302", "parentId": "430300"},
    {"label": "岳塘区", "value": "430304", "parentId": "430300"},
    {"label": "湘潭县", "value": "430321", "parentId": "430300"},
    {"label": "湘乡市", "value": "430381", "parentId": "430300"},
    {"label": "韶山市", "value": "430382", "parentId": "430300"},
    {"label": "衡阳市", "value": "430400", "parentId": "430000"},
    {"label": "市辖区", "value": "430401", "parentId": "430400"},
    {"label": "珠晖区", "value": "430405", "parentId": "430400"},
    {"label": "雁峰区", "value": "430406", "parentId": "430400"},
    {"label": "石鼓区", "value": "430407", "parentId": "430400"},
    {"label": "蒸湘区", "value": "430408", "parentId": "430400"},
    {"label": "南岳区", "value": "430412", "parentId": "430400"},
    {"label": "衡阳县", "value": "430421", "parentId": "430400"},
    {"label": "衡南县", "value": "430422", "parentId": "430400"},
    {"label": "衡山县", "value": "430423", "parentId": "430400"},
    {"label": "衡东县", "value": "430424", "parentId": "430400"},
    {"label": "祁东县", "value": "430426", "parentId": "430400"},
    {"label": "耒阳市", "value": "430481", "parentId": "430400"},
    {"label": "常宁市", "value": "430482", "parentId": "430400"},
    {"label": "邵阳市", "value": "430500", "parentId": "430000"},
    {"label": "市辖区", "value": "430501", "parentId": "430500"},
    {"label": "双清区", "value": "430502", "parentId": "430500"},
    {"label": "大祥区", "value": "430503", "parentId": "430500"},
    {"label": "北塔区", "value": "430511", "parentId": "430500"},
    {"label": "邵东县", "value": "430521", "parentId": "430500"},
    {"label": "新邵县", "value": "430522", "parentId": "430500"},
    {"label": "邵阳县", "value": "430523", "parentId": "430500"},
    {"label": "隆回县", "value": "430524", "parentId": "430500"},
    {"label": "洞口县", "value": "430525", "parentId": "430500"},
    {"label": "绥宁县", "value": "430527", "parentId": "430500"},
    {"label": "新宁县", "value": "430528", "parentId": "430500"},
    {"label": "城步苗族自治县", "value": "430529", "parentId": "430500"},
    {"label": "武冈市", "value": "430581", "parentId": "430500"},
    {"label": "岳阳市", "value": "430600", "parentId": "430000"},
    {"label": "市辖区", "value": "430601", "parentId": "430600"},
    {"label": "岳阳楼区", "value": "430602", "parentId": "430600"},
    {"label": "云溪区", "value": "430603", "parentId": "430600"},
    {"label": "君山区", "value": "430611", "parentId": "430600"},
    {"label": "岳阳县", "value": "430621", "parentId": "430600"},
    {"label": "华容县", "value": "430623", "parentId": "430600"},
    {"label": "湘阴县", "value": "430624", "parentId": "430600"},
    {"label": "平江县", "value": "430626", "parentId": "430600"},
    {"label": "汨罗市", "value": "430681", "parentId": "430600"},
    {"label": "临湘市", "value": "430682", "parentId": "430600"},
    {"label": "常德市", "value": "430700", "parentId": "430000"},
    {"label": "市辖区", "value": "430701", "parentId": "430700"},
    {"label": "武陵区", "value": "430702", "parentId": "430700"},
    {"label": "鼎城区", "value": "430703", "parentId": "430700"},
    {"label": "安乡县", "value": "430721", "parentId": "430700"},
    {"label": "汉寿县", "value": "430722", "parentId": "430700"},
    {"label": "澧县", "value": "430723", "parentId": "430700"},
    {"label": "临澧县", "value": "430724", "parentId": "430700"},
    {"label": "桃源县", "value": "430725", "parentId": "430700"},
    {"label": "石门县", "value": "430726", "parentId": "430700"},
    {"label": "津市市", "value": "430781", "parentId": "430700"},
    {"label": "张家界市", "value": "430800", "parentId": "430000"},
    {"label": "市辖区", "value": "430801", "parentId": "430800"},
    {"label": "永定区", "value": "430802", "parentId": "430800"},
    {"label": "武陵源区", "value": "430811", "parentId": "430800"},
    {"label": "慈利县", "value": "430821", "parentId": "430800"},
    {"label": "桑植县", "value": "430822", "parentId": "430800"},
    {"label": "益阳市", "value": "430900", "parentId": "430000"},
    {"label": "市辖区", "value": "430901", "parentId": "430900"},
    {"label": "资阳区", "value": "430902", "parentId": "430900"},
    {"label": "赫山区", "value": "430903", "parentId": "430900"},
    {"label": "南县", "value": "430921", "parentId": "430900"},
    {"label": "桃江县", "value": "430922", "parentId": "430900"},
    {"label": "安化县", "value": "430923", "parentId": "430900"},
    {"label": "沅江市", "value": "430981", "parentId": "430900"},
    {"label": "郴州市", "value": "431000", "parentId": "430000"},
    {"label": "市辖区", "value": "431001", "parentId": "431000"},
    {"label": "北湖区", "value": "431002", "parentId": "431000"},
    {"label": "苏仙区", "value": "431003", "parentId": "431000"},
    {"label": "桂阳县", "value": "431021", "parentId": "431000"},
    {"label": "宜章县", "value": "431022", "parentId": "431000"},
    {"label": "永兴县", "value": "431023", "parentId": "431000"},
    {"label": "嘉禾县", "value": "431024", "parentId": "431000"},
    {"label": "临武县", "value": "431025", "parentId": "431000"},
    {"label": "汝城县", "value": "431026", "parentId": "431000"},
    {"label": "桂东县", "value": "431027", "parentId": "431000"},
    {"label": "安仁县", "value": "431028", "parentId": "431000"},
    {"label": "资兴市", "value": "431081", "parentId": "431000"},
    {"label": "永州市", "value": "431100", "parentId": "430000"},
    {"label": "市辖区", "value": "431101", "parentId": "431100"},
    {"label": "芝山区", "value": "431102", "parentId": "431100"},
    {"label": "冷水滩区", "value": "431103", "parentId": "431100"},
    {"label": "祁阳县", "value": "431121", "parentId": "431100"},
    {"label": "东安县", "value": "431122", "parentId": "431100"},
    {"label": "双牌县", "value": "431123", "parentId": "431100"},
    {"label": "道县", "value": "431124", "parentId": "431100"},
    {"label": "江永县", "value": "431125", "parentId": "431100"},
    {"label": "宁远县", "value": "431126", "parentId": "431100"},
    {"label": "蓝山县", "value": "431127", "parentId": "431100"},
    {"label": "新田县", "value": "431128", "parentId": "431100"},
    {"label": "江华瑶族自治县", "value": "431129", "parentId": "431100"},
    {"label": "怀化市", "value": "431200", "parentId": "430000"},
    {"label": "市辖区", "value": "431201", "parentId": "431200"},
    {"label": "鹤城区", "value": "431202", "parentId": "431200"},
    {"label": "中方县", "value": "431221", "parentId": "431200"},
    {"label": "沅陵县", "value": "431222", "parentId": "431200"},
    {"label": "辰溪县", "value": "431223", "parentId": "431200"},
    {"label": "溆浦县", "value": "431224", "parentId": "431200"},
    {"label": "会同县", "value": "431225", "parentId": "431200"},
    {"label": "麻阳苗族自治县", "value": "431226", "parentId": "431200"},
    {"label": "新晃侗族自治县", "value": "431227", "parentId": "431200"},
    {"label": "芷江侗族自治县", "value": "431228", "parentId": "431200"},
    {"label": "靖州苗族侗族自治县", "value": "431229", "parentId": "431200"},
    {"label": "通道侗族自治县", "value": "431230", "parentId": "431200"},
    {"label": "洪江市", "value": "431281", "parentId": "431200"},
    {"label": "娄底市", "value": "431300", "parentId": "430000"},
    {"label": "市辖区", "value": "431301", "parentId": "431300"},
    {"label": "娄星区", "value": "431302", "parentId": "431300"},
    {"label": "双峰县", "value": "431321", "parentId": "431300"},
    {"label": "新化县", "value": "431322", "parentId": "431300"},
    {"label": "冷水江市", "value": "431381", "parentId": "431300"},
    {"label": "涟源市", "value": "431382", "parentId": "431300"},
    {"label": "湘西土家族苗族自治州", "value": "433100", "parentId": "430000"},
    {"label": "吉首市", "value": "433101", "parentId": "433100"},
    {"label": "泸溪县", "value": "433122", "parentId": "433100"},
    {"label": "凤凰县", "value": "433123", "parentId": "433100"},
    {"label": "花垣县", "value": "433124", "parentId": "433100"},
    {"label": "保靖县", "value": "433125", "parentId": "433100"},
    {"label": "古丈县", "value": "433126", "parentId": "433100"},
    {"label": "永顺县", "value": "433127", "parentId": "433100"},
    {"label": "龙山县", "value": "433130", "parentId": "433100"},
    {"label": "广东省", "value": "440000", "parentId": "root"},
    {"label": "广州市", "value": "440100", "parentId": "440000"},
    {"label": "市辖区", "value": "440101", "parentId": "440100"},
    {"label": "东山区", "value": "440102", "parentId": "440100"},
    {"label": "荔湾区", "value": "440103", "parentId": "440100"},
    {"label": "越秀区", "value": "440104", "parentId": "440100"},
    {"label": "海珠区", "value": "440105", "parentId": "440100"},
    {"label": "天河区", "value": "440106", "parentId": "440100"},
    {"label": "芳村区", "value": "440107", "parentId": "440100"},
    {"label": "白云区", "value": "440111", "parentId": "440100"},
    {"label": "黄埔区", "value": "440112", "parentId": "440100"},
    {"label": "番禺区", "value": "440113", "parentId": "440100"},
    {"label": "花都区", "value": "440114", "parentId": "440100"},
    {"label": "增城市", "value": "440183", "parentId": "440100"},
    {"label": "从化市", "value": "440184", "parentId": "440100"},
    {"label": "韶关市", "value": "440200", "parentId": "440000"},
    {"label": "市辖区", "value": "440201", "parentId": "440200"},
    {"label": "武江区", "value": "440203", "parentId": "440200"},
    {"label": "浈江区", "value": "440204", "parentId": "440200"},
    {"label": "曲江区", "value": "440205", "parentId": "440200"},
    {"label": "始兴县", "value": "440222", "parentId": "440200"},
    {"label": "仁化县", "value": "440224", "parentId": "440200"},
    {"label": "翁源县", "value": "440229", "parentId": "440200"},
    {"label": "乳源瑶族自治县", "value": "440232", "parentId": "440200"},
    {"label": "新丰县", "value": "440233", "parentId": "440200"},
    {"label": "乐昌市", "value": "440281", "parentId": "440200"},
    {"label": "南雄市", "value": "440282", "parentId": "440200"},
    {"label": "深圳市", "value": "440300", "parentId": "440000"},
    {"label": "市辖区", "value": "440301", "parentId": "440300"},
    {"label": "罗湖区", "value": "440303", "parentId": "440300"},
    {"label": "福田区", "value": "440304", "parentId": "440300"},
    {"label": "南山区", "value": "440305", "parentId": "440300"},
    {"label": "宝安区", "value": "440306", "parentId": "440300"},
    {"label": "龙岗区", "value": "440307", "parentId": "440300"},
    {"label": "盐田区", "value": "440308", "parentId": "440300"},
    {"label": "珠海市", "value": "440400", "parentId": "440000"},
    {"label": "市辖区", "value": "440401", "parentId": "440400"},
    {"label": "香洲区", "value": "440402", "parentId": "440400"},
    {"label": "斗门区", "value": "440403", "parentId": "440400"},
    {"label": "金湾区", "value": "440404", "parentId": "440400"},
    {"label": "汕头市", "value": "440500", "parentId": "440000"},
    {"label": "市辖区", "value": "440501", "parentId": "440500"},
    {"label": "龙湖区", "value": "440507", "parentId": "440500"},
    {"label": "金平区", "value": "440511", "parentId": "440500"},
    {"label": "濠江区", "value": "440512", "parentId": "440500"},
    {"label": "潮阳区", "value": "440513", "parentId": "440500"},
    {"label": "潮南区", "value": "440514", "parentId": "440500"},
    {"label": "澄海区", "value": "440515", "parentId": "440500"},
    {"label": "南澳县", "value": "440523", "parentId": "440500"},
    {"label": "佛山市", "value": "440600", "parentId": "440000"},
    {"label": "市辖区", "value": "440601", "parentId": "440600"},
    {"label": "禅城区", "value": "440604", "parentId": "440600"},
    {"label": "南海区", "value": "440605", "parentId": "440600"},
    {"label": "顺德区", "value": "440606", "parentId": "440600"},
    {"label": "三水区", "value": "440607", "parentId": "440600"},
    {"label": "高明区", "value": "440608", "parentId": "440600"},
    {"label": "江门市", "value": "440700", "parentId": "440000"},
    {"label": "市辖区", "value": "440701", "parentId": "440700"},
    {"label": "蓬江区", "value": "440703", "parentId": "440700"},
    {"label": "江海区", "value": "440704", "parentId": "440700"},
    {"label": "新会区", "value": "440705", "parentId": "440700"},
    {"label": "台山市", "value": "440781", "parentId": "440700"},
    {"label": "开平市", "value": "440783", "parentId": "440700"},
    {"label": "鹤山市", "value": "440784", "parentId": "440700"},
    {"label": "恩平市", "value": "440785", "parentId": "440700"},
    {"label": "湛江市", "value": "440800", "parentId": "440000"},
    {"label": "市辖区", "value": "440801", "parentId": "440800"},
    {"label": "赤坎区", "value": "440802", "parentId": "440800"},
    {"label": "霞山区", "value": "440803", "parentId": "440800"},
    {"label": "坡头区", "value": "440804", "parentId": "440800"},
    {"label": "麻章区", "value": "440811", "parentId": "440800"},
    {"label": "遂溪县", "value": "440823", "parentId": "440800"},
    {"label": "徐闻县", "value": "440825", "parentId": "440800"},
    {"label": "廉江市", "value": "440881", "parentId": "440800"},
    {"label": "雷州市", "value": "440882", "parentId": "440800"},
    {"label": "吴川市", "value": "440883", "parentId": "440800"},
    {"label": "茂名市", "value": "440900", "parentId": "440000"},
    {"label": "市辖区", "value": "440901", "parentId": "440900"},
    {"label": "茂南区", "value": "440902", "parentId": "440900"},
    {"label": "茂港区", "value": "440903", "parentId": "440900"},
    {"label": "电白县", "value": "440923", "parentId": "440900"},
    {"label": "高州市", "value": "440981", "parentId": "440900"},
    {"label": "化州市", "value": "440982", "parentId": "440900"},
    {"label": "信宜市", "value": "440983", "parentId": "440900"},
    {"label": "肇庆市", "value": "441200", "parentId": "440000"},
    {"label": "市辖区", "value": "441201", "parentId": "441200"},
    {"label": "端州区", "value": "441202", "parentId": "441200"},
    {"label": "鼎湖区", "value": "441203", "parentId": "441200"},
    {"label": "广宁县", "value": "441223", "parentId": "441200"},
    {"label": "怀集县", "value": "441224", "parentId": "441200"},
    {"label": "封开县", "value": "441225", "parentId": "441200"},
    {"label": "德庆县", "value": "441226", "parentId": "441200"},
    {"label": "高要市", "value": "441283", "parentId": "441200"},
    {"label": "四会市", "value": "441284", "parentId": "441200"},
    {"label": "惠州市", "value": "441300", "parentId": "440000"},
    {"label": "市辖区", "value": "441301", "parentId": "441300"},
    {"label": "惠城区", "value": "441302", "parentId": "441300"},
    {"label": "惠阳区", "value": "441303", "parentId": "441300"},
    {"label": "博罗县", "value": "441322", "parentId": "441300"},
    {"label": "惠东县", "value": "441323", "parentId": "441300"},
    {"label": "龙门县", "value": "441324", "parentId": "441300"},
    {"label": "梅州市", "value": "441400", "parentId": "440000"},
    {"label": "市辖区", "value": "441401", "parentId": "441400"},
    {"label": "梅江区", "value": "441402", "parentId": "441400"},
    {"label": "梅县", "value": "441421", "parentId": "441400"},
    {"label": "大埔县", "value": "441422", "parentId": "441400"},
    {"label": "丰顺县", "value": "441423", "parentId": "441400"},
    {"label": "五华县", "value": "441424", "parentId": "441400"},
    {"label": "平远县", "value": "441426", "parentId": "441400"},
    {"label": "蕉岭县", "value": "441427", "parentId": "441400"},
    {"label": "兴宁市", "value": "441481", "parentId": "441400"},
    {"label": "汕尾市", "value": "441500", "parentId": "440000"},
    {"label": "市辖区", "value": "441501", "parentId": "441500"},
    {"label": "城区", "value": "441502", "parentId": "441500"},
    {"label": "海丰县", "value": "441521", "parentId": "441500"},
    {"label": "陆河县", "value": "441523", "parentId": "441500"},
    {"label": "陆丰市", "value": "441581", "parentId": "441500"},
    {"label": "河源市", "value": "441600", "parentId": "440000"},
    {"label": "市辖区", "value": "441601", "parentId": "441600"},
    {"label": "源城区", "value": "441602", "parentId": "441600"},
    {"label": "紫金县", "value": "441621", "parentId": "441600"},
    {"label": "龙川县", "value": "441622", "parentId": "441600"},
    {"label": "连平县", "value": "441623", "parentId": "441600"},
    {"label": "和平县", "value": "441624", "parentId": "441600"},
    {"label": "东源县", "value": "441625", "parentId": "441600"},
    {"label": "阳江市", "value": "441700", "parentId": "440000"},
    {"label": "市辖区", "value": "441701", "parentId": "441700"},
    {"label": "江城区", "value": "441702", "parentId": "441700"},
    {"label": "阳西县", "value": "441721", "parentId": "441700"},
    {"label": "阳东县", "value": "441723", "parentId": "441700"},
    {"label": "阳春市", "value": "441781", "parentId": "441700"},
    {"label": "清远市", "value": "441800", "parentId": "440000"},
    {"label": "市辖区", "value": "441801", "parentId": "441800"},
    {"label": "清城区", "value": "441802", "parentId": "441800"},
    {"label": "佛冈县", "value": "441821", "parentId": "441800"},
    {"label": "阳山县", "value": "441823", "parentId": "441800"},
    {"label": "连山壮族瑶族自治县", "value": "441825", "parentId": "441800"},
    {"label": "连南瑶族自治县", "value": "441826", "parentId": "441800"},
    {"label": "清新县", "value": "441827", "parentId": "441800"},
    {"label": "英德市", "value": "441881", "parentId": "441800"},
    {"label": "连州市", "value": "441882", "parentId": "441800"},
    {"label": "东莞市", "value": "441900", "parentId": "440000"},
    {"label": "中山市", "value": "442000", "parentId": "440000"},
    {"label": "潮州市", "value": "445100", "parentId": "440000"},
    {"label": "市辖区", "value": "445101", "parentId": "445100"},
    {"label": "湘桥区", "value": "445102", "parentId": "445100"},
    {"label": "潮安县", "value": "445121", "parentId": "445100"},
    {"label": "饶平县", "value": "445122", "parentId": "445100"},
    {"label": "揭阳市", "value": "445200", "parentId": "440000"},
    {"label": "市辖区", "value": "445201", "parentId": "445200"},
    {"label": "榕城区", "value": "445202", "parentId": "445200"},
    {"label": "揭东县", "value": "445221", "parentId": "445200"},
    {"label": "揭西县", "value": "445222", "parentId": "445200"},
    {"label": "惠来县", "value": "445224", "parentId": "445200"},
    {"label": "普宁市", "value": "445281", "parentId": "445200"},
    {"label": "云浮市", "value": "445300", "parentId": "440000"},
    {"label": "市辖区", "value": "445301", "parentId": "445300"},
    {"label": "云城区", "value": "445302", "parentId": "445300"},
    {"label": "新兴县", "value": "445321", "parentId": "445300"},
    {"label": "郁南县", "value": "445322", "parentId": "445300"},
    {"label": "云安县", "value": "445323", "parentId": "445300"},
    {"label": "罗定市", "value": "445381", "parentId": "445300"},
    {"label": "广西壮族自治区", "value": "450000", "parentId": "root"},
    {"label": "南宁市", "value": "450100", "parentId": "450000"},
    {"label": "市辖区", "value": "450101", "parentId": "450100"},
    {"label": "兴宁区", "value": "450102", "parentId": "450100"},
    {"label": "青秀区", "value": "450103", "parentId": "450100"},
    {"label": "江南区", "value": "450105", "parentId": "450100"},
    {"label": "西乡塘区", "value": "450107", "parentId": "450100"},
    {"label": "良庆区", "value": "450108", "parentId": "450100"},
    {"label": "邕宁区", "value": "450109", "parentId": "450100"},
    {"label": "武鸣县", "value": "450122", "parentId": "450100"},
    {"label": "隆安县", "value": "450123", "parentId": "450100"},
    {"label": "马山县", "value": "450124", "parentId": "450100"},
    {"label": "上林县", "value": "450125", "parentId": "450100"},
    {"label": "宾阳县", "value": "450126", "parentId": "450100"},
    {"label": "横县", "value": "450127", "parentId": "450100"},
    {"label": "柳州市", "value": "450200", "parentId": "450000"},
    {"label": "市辖区", "value": "450201", "parentId": "450200"},
    {"label": "城中区", "value": "450202", "parentId": "450200"},
    {"label": "鱼峰区", "value": "450203", "parentId": "450200"},
    {"label": "柳南区", "value": "450204", "parentId": "450200"},
    {"label": "柳北区", "value": "450205", "parentId": "450200"},
    {"label": "柳江县", "value": "450221", "parentId": "450200"},
    {"label": "柳城县", "value": "450222", "parentId": "450200"},
    {"label": "鹿寨县", "value": "450223", "parentId": "450200"},
    {"label": "融安县", "value": "450224", "parentId": "450200"},
    {"label": "融水苗族自治县", "value": "450225", "parentId": "450200"},
    {"label": "三江侗族自治县", "value": "450226", "parentId": "450200"},
    {"label": "桂林市", "value": "450300", "parentId": "450000"},
    {"label": "市辖区", "value": "450301", "parentId": "450300"},
    {"label": "秀峰区", "value": "450302", "parentId": "450300"},
    {"label": "叠彩区", "value": "450303", "parentId": "450300"},
    {"label": "象山区", "value": "450304", "parentId": "450300"},
    {"label": "七星区", "value": "450305", "parentId": "450300"},
    {"label": "雁山区", "value": "450311", "parentId": "450300"},
    {"label": "阳朔县", "value": "450321", "parentId": "450300"},
    {"label": "临桂县", "value": "450322", "parentId": "450300"},
    {"label": "灵川县", "value": "450323", "parentId": "450300"},
    {"label": "全州县", "value": "450324", "parentId": "450300"},
    {"label": "兴安县", "value": "450325", "parentId": "450300"},
    {"label": "永福县", "value": "450326", "parentId": "450300"},
    {"label": "灌阳县", "value": "450327", "parentId": "450300"},
    {"label": "龙胜各族自治县", "value": "450328", "parentId": "450300"},
    {"label": "资源县", "value": "450329", "parentId": "450300"},
    {"label": "平乐县", "value": "450330", "parentId": "450300"},
    {"label": "荔蒲县", "value": "450331", "parentId": "450300"},
    {"label": "恭城瑶族自治县", "value": "450332", "parentId": "450300"},
    {"label": "梧州市", "value": "450400", "parentId": "450000"},
    {"label": "市辖区", "value": "450401", "parentId": "450400"},
    {"label": "万秀区", "value": "450403", "parentId": "450400"},
    {"label": "蝶山区", "value": "450404", "parentId": "450400"},
    {"label": "长洲区", "value": "450405", "parentId": "450400"},
    {"label": "苍梧县", "value": "450421", "parentId": "450400"},
    {"label": "藤县", "value": "450422", "parentId": "450400"},
    {"label": "蒙山县", "value": "450423", "parentId": "450400"},
    {"label": "岑溪市", "value": "450481", "parentId": "450400"},
    {"label": "北海市", "value": "450500", "parentId": "450000"},
    {"label": "市辖区", "value": "450501", "parentId": "450500"},
    {"label": "海城区", "value": "450502", "parentId": "450500"},
    {"label": "银海区", "value": "450503", "parentId": "450500"},
    {"label": "铁山港区", "value": "450512", "parentId": "450500"},
    {"label": "合浦县", "value": "450521", "parentId": "450500"},
    {"label": "防城港市", "value": "450600", "parentId": "450000"},
    {"label": "市辖区", "value": "450601", "parentId": "450600"},
    {"label": "港口区", "value": "450602", "parentId": "450600"},
    {"label": "防城区", "value": "450603", "parentId": "450600"},
    {"label": "上思县", "value": "450621", "parentId": "450600"},
    {"label": "东兴市", "value": "450681", "parentId": "450600"},
    {"label": "钦州市", "value": "450700", "parentId": "450000"},
    {"label": "市辖区", "value": "450701", "parentId": "450700"},
    {"label": "钦南区", "value": "450702", "parentId": "450700"},
    {"label": "钦北区", "value": "450703", "parentId": "450700"},
    {"label": "灵山县", "value": "450721", "parentId": "450700"},
    {"label": "浦北县", "value": "450722", "parentId": "450700"},
    {"label": "贵港市", "value": "450800", "parentId": "450000"},
    {"label": "市辖区", "value": "450801", "parentId": "450800"},
    {"label": "港北区", "value": "450802", "parentId": "450800"},
    {"label": "港南区", "value": "450803", "parentId": "450800"},
    {"label": "覃塘区", "value": "450804", "parentId": "450800"},
    {"label": "平南县", "value": "450821", "parentId": "450800"},
    {"label": "桂平市", "value": "450881", "parentId": "450800"},
    {"label": "玉林市", "value": "450900", "parentId": "450000"},
    {"label": "市辖区", "value": "450901", "parentId": "450900"},
    {"label": "玉州区", "value": "450902", "parentId": "450900"},
    {"label": "容县", "value": "450921", "parentId": "450900"},
    {"label": "陆川县", "value": "450922", "parentId": "450900"},
    {"label": "博白县", "value": "450923", "parentId": "450900"},
    {"label": "兴业县", "value": "450924", "parentId": "450900"},
    {"label": "北流市", "value": "450981", "parentId": "450900"},
    {"label": "百色市", "value": "451000", "parentId": "450000"},
    {"label": "市辖区", "value": "451001", "parentId": "451000"},
    {"label": "右江区", "value": "451002", "parentId": "451000"},
    {"label": "田阳县", "value": "451021", "parentId": "451000"},
    {"label": "田东县", "value": "451022", "parentId": "451000"},
    {"label": "平果县", "value": "451023", "parentId": "451000"},
    {"label": "德保县", "value": "451024", "parentId": "451000"},
    {"label": "靖西县", "value": "451025", "parentId": "451000"},
    {"label": "那坡县", "value": "451026", "parentId": "451000"},
    {"label": "凌云县", "value": "451027", "parentId": "451000"},
    {"label": "乐业县", "value": "451028", "parentId": "451000"},
    {"label": "田林县", "value": "451029", "parentId": "451000"},
    {"label": "西林县", "value": "451030", "parentId": "451000"},
    {"label": "隆林各族自治县", "value": "451031", "parentId": "451000"},
    {"label": "贺州市", "value": "451100", "parentId": "450000"},
    {"label": "市辖区", "value": "451101", "parentId": "451100"},
    {"label": "八步区", "value": "451102", "parentId": "451100"},
    {"label": "昭平县", "value": "451121", "parentId": "451100"},
    {"label": "钟山县", "value": "451122", "parentId": "451100"},
    {"label": "富川瑶族自治县", "value": "451123", "parentId": "451100"},
    {"label": "河池市", "value": "451200", "parentId": "450000"},
    {"label": "市辖区", "value": "451201", "parentId": "451200"},
    {"label": "金城江区", "value": "451202", "parentId": "451200"},
    {"label": "南丹县", "value": "451221", "parentId": "451200"},
    {"label": "天峨县", "value": "451222", "parentId": "451200"},
    {"label": "凤山县", "value": "451223", "parentId": "451200"},
    {"label": "东兰县", "value": "451224", "parentId": "451200"},
    {"label": "罗城仫佬族自治县", "value": "451225", "parentId": "451200"},
    {"label": "环江毛南族自治县", "value": "451226", "parentId": "451200"},
    {"label": "巴马瑶族自治县", "value": "451227", "parentId": "451200"},
    {"label": "都安瑶族自治县", "value": "451228", "parentId": "451200"},
    {"label": "大化瑶族自治县", "value": "451229", "parentId": "451200"},
    {"label": "宜州市", "value": "451281", "parentId": "451200"},
    {"label": "来宾市", "value": "451300", "parentId": "450000"},
    {"label": "市辖区", "value": "451301", "parentId": "451300"},
    {"label": "兴宾区", "value": "451302", "parentId": "451300"},
    {"label": "忻城县", "value": "451321", "parentId": "451300"},
    {"label": "象州县", "value": "451322", "parentId": "451300"},
    {"label": "武宣县", "value": "451323", "parentId": "451300"},
    {"label": "金秀瑶族自治县", "value": "451324", "parentId": "451300"},
    {"label": "合山市", "value": "451381", "parentId": "451300"},
    {"label": "崇左市", "value": "451400", "parentId": "450000"},
    {"label": "市辖区", "value": "451401", "parentId": "451400"},
    {"label": "江洲区", "value": "451402", "parentId": "451400"},
    {"label": "扶绥县", "value": "451421", "parentId": "451400"},
    {"label": "宁明县", "value": "451422", "parentId": "451400"},
    {"label": "龙州县", "value": "451423", "parentId": "451400"},
    {"label": "大新县", "value": "451424", "parentId": "451400"},
    {"label": "天等县", "value": "451425", "parentId": "451400"},
    {"label": "凭祥市", "value": "451481", "parentId": "451400"},
    {"label": "海南省", "value": "460000", "parentId": "root"},
    {"label": "海口市", "value": "460100", "parentId": "460000"},
    {"label": "市辖区", "value": "460101", "parentId": "460100"},
    {"label": "秀英区", "value": "460105", "parentId": "460100"},
    {"label": "龙华区", "value": "460106", "parentId": "460100"},
    {"label": "琼山区", "value": "460107", "parentId": "460100"},
    {"label": "美兰区", "value": "460108", "parentId": "460100"},
    {"label": "三亚市", "value": "460200", "parentId": "460000"},
    {"label": "市辖区", "value": "460201", "parentId": "460200"},
    {"label": "省直辖县级行政单位", "value": "469000", "parentId": "460000"},
    {"label": "五指山市", "value": "469001", "parentId": "469000"},
    {"label": "琼海市", "value": "469002", "parentId": "469000"},
    {"label": "儋州市", "value": "469003", "parentId": "469000"},
    {"label": "文昌市", "value": "469005", "parentId": "469000"},
    {"label": "万宁市", "value": "469006", "parentId": "469000"},
    {"label": "东方市", "value": "469007", "parentId": "469000"},
    {"label": "定安县", "value": "469025", "parentId": "469000"},
    {"label": "屯昌县", "value": "469026", "parentId": "469000"},
    {"label": "澄迈县", "value": "469027", "parentId": "469000"},
    {"label": "临高县", "value": "469028", "parentId": "469000"},
    {"label": "白沙黎族自治县", "value": "469030", "parentId": "469000"},
    {"label": "昌江黎族自治县", "value": "469031", "parentId": "469000"},
    {"label": "乐东黎族自治县", "value": "469033", "parentId": "469000"},
    {"label": "陵水黎族自治县", "value": "469034", "parentId": "469000"},
    {"label": "保亭黎族苗族自治县", "value": "469035", "parentId": "469000"},
    {"label": "琼中黎族苗族自治县", "value": "469036", "parentId": "469000"},
    {"label": "西沙群岛", "value": "469037", "parentId": "469000"},
    {"label": "南沙群岛", "value": "469038", "parentId": "469000"},
    {"label": "中沙群岛的岛礁及其海域", "value": "469039", "parentId": "469000"},
    {"label": "重庆市", "value": "500000", "parentId": "root"},
    {"label": "市辖区", "value": "500100", "parentId": "500000"},
    {"label": "万州区", "value": "500101", "parentId": "500100"},
    {"label": "涪陵区", "value": "500102", "parentId": "500100"},
    {"label": "渝中区", "value": "500103", "parentId": "500100"},
    {"label": "大渡口区", "value": "500104", "parentId": "500100"},
    {"label": "江北区", "value": "500105", "parentId": "500100"},
    {"label": "沙坪坝区", "value": "500106", "parentId": "500100"},
    {"label": "九龙坡区", "value": "500107", "parentId": "500100"},
    {"label": "南岸区", "value": "500108", "parentId": "500100"},
    {"label": "北碚区", "value": "500109", "parentId": "500100"},
    {"label": "万盛区", "value": "500110", "parentId": "500100"},
    {"label": "双桥区", "value": "500111", "parentId": "500100"},
    {"label": "渝北区", "value": "500112", "parentId": "500100"},
    {"label": "巴南区", "value": "500113", "parentId": "500100"},
    {"label": "黔江区", "value": "500114", "parentId": "500100"},
    {"label": "长寿区", "value": "500115", "parentId": "500100"},
    {"label": "县", "value": "500200", "parentId": "500000"},
    {"label": "綦江县", "value": "500222", "parentId": "500200"},
    {"label": "潼南县", "value": "500223", "parentId": "500200"},
    {"label": "铜梁县", "value": "500224", "parentId": "500200"},
    {"label": "大足县", "value": "500225", "parentId": "500200"},
    {"label": "荣昌县", "value": "500226", "parentId": "500200"},
    {"label": "璧山县", "value": "500227", "parentId": "500200"},
    {"label": "梁平县", "value": "500228", "parentId": "500200"},
    {"label": "城口县", "value": "500229", "parentId": "500200"},
    {"label": "丰都县", "value": "500230", "parentId": "500200"},
    {"label": "垫江县", "value": "500231", "parentId": "500200"},
    {"label": "武隆县", "value": "500232", "parentId": "500200"},
    {"label": "忠县", "value": "500233", "parentId": "500200"},
    {"label": "开县", "value": "500234", "parentId": "500200"},
    {"label": "云阳县", "value": "500235", "parentId": "500200"},
    {"label": "奉节县", "value": "500236", "parentId": "500200"},
    {"label": "巫山县", "value": "500237", "parentId": "500200"},
    {"label": "巫溪县", "value": "500238", "parentId": "500200"},
    {"label": "石柱土家族自治县", "value": "500240", "parentId": "500200"},
    {"label": "秀山土家族苗族自治县", "value": "500241", "parentId": "500200"},
    {"label": "酉阳土家族苗族自治县", "value": "500242", "parentId": "500200"},
    {"label": "彭水苗族土家族自治县", "value": "500243", "parentId": "500200"},
    {"label": "市", "value": "500300", "parentId": "500000"},
    {"label": "江津市", "value": "500381", "parentId": "500300"},
    {"label": "合川市", "value": "500382", "parentId": "500300"},
    {"label": "永川市", "value": "500383", "parentId": "500300"},
    {"label": "南川市", "value": "500384", "parentId": "500300"},
    {"label": "四川省", "value": "510000", "parentId": "root"},
    {"label": "成都市", "value": "510100", "parentId": "510000"},
    {"label": "市辖区", "value": "510101", "parentId": "510100"},
    {"label": "锦江区", "value": "510104", "parentId": "510100"},
    {"label": "青羊区", "value": "510105", "parentId": "510100"},
    {"label": "金牛区", "value": "510106", "parentId": "510100"},
    {"label": "武侯区", "value": "510107", "parentId": "510100"},
    {"label": "成华区", "value": "510108", "parentId": "510100"},
    {"label": "龙泉驿区", "value": "510112", "parentId": "510100"},
    {"label": "青白江区", "value": "510113", "parentId": "510100"},
    {"label": "新都区", "value": "510114", "parentId": "510100"},
    {"label": "温江区", "value": "510115", "parentId": "510100"},
    {"label": "金堂县", "value": "510121", "parentId": "510100"},
    {"label": "双流县", "value": "510122", "parentId": "510100"},
    {"label": "郫县", "value": "510124", "parentId": "510100"},
    {"label": "大邑县", "value": "510129", "parentId": "510100"},
    {"label": "蒲江县", "value": "510131", "parentId": "510100"},
    {"label": "新津县", "value": "510132", "parentId": "510100"},
    {"label": "都江堰市", "value": "510181", "parentId": "510100"},
    {"label": "彭州市", "value": "510182", "parentId": "510100"},
    {"label": "邛崃市", "value": "510183", "parentId": "510100"},
    {"label": "崇州市", "value": "510184", "parentId": "510100"},
    {"label": "自贡市", "value": "510300", "parentId": "510000"},
    {"label": "市辖区", "value": "510301", "parentId": "510300"},
    {"label": "自流井区", "value": "510302", "parentId": "510300"},
    {"label": "贡井区", "value": "510303", "parentId": "510300"},
    {"label": "大安区", "value": "510304", "parentId": "510300"},
    {"label": "沿滩区", "value": "510311", "parentId": "510300"},
    {"label": "荣县", "value": "510321", "parentId": "510300"},
    {"label": "富顺县", "value": "510322", "parentId": "510300"},
    {"label": "攀枝花市", "value": "510400", "parentId": "510000"},
    {"label": "市辖区", "value": "510401", "parentId": "510400"},
    {"label": "东区", "value": "510402", "parentId": "510400"},
    {"label": "西区", "value": "510403", "parentId": "510400"},
    {"label": "仁和区", "value": "510411", "parentId": "510400"},
    {"label": "米易县", "value": "510421", "parentId": "510400"},
    {"label": "盐边县", "value": "510422", "parentId": "510400"},
    {"label": "泸州市", "value": "510500", "parentId": "510000"},
    {"label": "市辖区", "value": "510501", "parentId": "510500"},
    {"label": "江阳区", "value": "510502", "parentId": "510500"},
    {"label": "纳溪区", "value": "510503", "parentId": "510500"},
    {"label": "龙马潭区", "value": "510504", "parentId": "510500"},
    {"label": "泸县", "value": "510521", "parentId": "510500"},
    {"label": "合江县", "value": "510522", "parentId": "510500"},
    {"label": "叙永县", "value": "510524", "parentId": "510500"},
    {"label": "古蔺县", "value": "510525", "parentId": "510500"},
    {"label": "德阳市", "value": "510600", "parentId": "510000"},
    {"label": "市辖区", "value": "510601", "parentId": "510600"},
    {"label": "旌阳区", "value": "510603", "parentId": "510600"},
    {"label": "中江县", "value": "510623", "parentId": "510600"},
    {"label": "罗江县", "value": "510626", "parentId": "510600"},
    {"label": "广汉市", "value": "510681", "parentId": "510600"},
    {"label": "什邡市", "value": "510682", "parentId": "510600"},
    {"label": "绵竹市", "value": "510683", "parentId": "510600"},
    {"label": "绵阳市", "value": "510700", "parentId": "510000"},
    {"label": "市辖区", "value": "510701", "parentId": "510700"},
    {"label": "涪城区", "value": "510703", "parentId": "510700"},
    {"label": "游仙区", "value": "510704", "parentId": "510700"},
    {"label": "三台县", "value": "510722", "parentId": "510700"},
    {"label": "盐亭县", "value": "510723", "parentId": "510700"},
    {"label": "安县", "value": "510724", "parentId": "510700"},
    {"label": "梓潼县", "value": "510725", "parentId": "510700"},
    {"label": "北川羌族自治县", "value": "510726", "parentId": "510700"},
    {"label": "平武县", "value": "510727", "parentId": "510700"},
    {"label": "江油市", "value": "510781", "parentId": "510700"},
    {"label": "广元市", "value": "510800", "parentId": "510000"},
    {"label": "市辖区", "value": "510801", "parentId": "510800"},
    {"label": "市中区", "value": "510802", "parentId": "510800"},
    {"label": "元坝区", "value": "510811", "parentId": "510800"},
    {"label": "朝天区", "value": "510812", "parentId": "510800"},
    {"label": "旺苍县", "value": "510821", "parentId": "510800"},
    {"label": "青川县", "value": "510822", "parentId": "510800"},
    {"label": "剑阁县", "value": "510823", "parentId": "510800"},
    {"label": "苍溪县", "value": "510824", "parentId": "510800"},
    {"label": "遂宁市", "value": "510900", "parentId": "510000"},
    {"label": "市辖区", "value": "510901", "parentId": "510900"},
    {"label": "船山区", "value": "510903", "parentId": "510900"},
    {"label": "安居区", "value": "510904", "parentId": "510900"},
    {"label": "蓬溪县", "value": "510921", "parentId": "510900"},
    {"label": "射洪县", "value": "510922", "parentId": "510900"},
    {"label": "大英县", "value": "510923", "parentId": "510900"},
    {"label": "内江市", "value": "511000", "parentId": "510000"},
    {"label": "市辖区", "value": "511001", "parentId": "511000"},
    {"label": "市中区", "value": "511002", "parentId": "511000"},
    {"label": "东兴区", "value": "511011", "parentId": "511000"},
    {"label": "威远县", "value": "511024", "parentId": "511000"},
    {"label": "资中县", "value": "511025", "parentId": "511000"},
    {"label": "隆昌县", "value": "511028", "parentId": "511000"},
    {"label": "乐山市", "value": "511100", "parentId": "510000"},
    {"label": "市辖区", "value": "511101", "parentId": "511100"},
    {"label": "市中区", "value": "511102", "parentId": "511100"},
    {"label": "沙湾区", "value": "511111", "parentId": "511100"},
    {"label": "五通桥区", "value": "511112", "parentId": "511100"},
    {"label": "金口河区", "value": "511113", "parentId": "511100"},
    {"label": "犍为县", "value": "511123", "parentId": "511100"},
    {"label": "井研县", "value": "511124", "parentId": "511100"},
    {"label": "夹江县", "value": "511126", "parentId": "511100"},
    {"label": "沐川县", "value": "511129", "parentId": "511100"},
    {"label": "峨边彝族自治县", "value": "511132", "parentId": "511100"},
    {"label": "马边彝族自治县", "value": "511133", "parentId": "511100"},
    {"label": "峨眉山市", "value": "511181", "parentId": "511100"},
    {"label": "南充市", "value": "511300", "parentId": "510000"},
    {"label": "市辖区", "value": "511301", "parentId": "511300"},
    {"label": "顺庆区", "value": "511302", "parentId": "511300"},
    {"label": "高坪区", "value": "511303", "parentId": "511300"},
    {"label": "嘉陵区", "value": "511304", "parentId": "511300"},
    {"label": "南部县", "value": "511321", "parentId": "511300"},
    {"label": "营山县", "value": "511322", "parentId": "511300"},
    {"label": "蓬安县", "value": "511323", "parentId": "511300"},
    {"label": "仪陇县", "value": "511324", "parentId": "511300"},
    {"label": "西充县", "value": "511325", "parentId": "511300"},
    {"label": "阆中市", "value": "511381", "parentId": "511300"},
    {"label": "眉山市", "value": "511400", "parentId": "510000"},
    {"label": "市辖区", "value": "511401", "parentId": "511400"},
    {"label": "东坡区", "value": "511402", "parentId": "511400"},
    {"label": "仁寿县", "value": "511421", "parentId": "511400"},
    {"label": "彭山县", "value": "511422", "parentId": "511400"},
    {"label": "洪雅县", "value": "511423", "parentId": "511400"},
    {"label": "丹棱县", "value": "511424", "parentId": "511400"},
    {"label": "青神县", "value": "511425", "parentId": "511400"},
    {"label": "宜宾市", "value": "511500", "parentId": "510000"},
    {"label": "市辖区", "value": "511501", "parentId": "511500"},
    {"label": "翠屏区", "value": "511502", "parentId": "511500"},
    {"label": "宜宾县", "value": "511521", "parentId": "511500"},
    {"label": "南溪县", "value": "511522", "parentId": "511500"},
    {"label": "江安县", "value": "511523", "parentId": "511500"},
    {"label": "长宁县", "value": "511524", "parentId": "511500"},
    {"label": "高县", "value": "511525", "parentId": "511500"},
    {"label": "珙县", "value": "511526", "parentId": "511500"},
    {"label": "筠连县", "value": "511527", "parentId": "511500"},
    {"label": "兴文县", "value": "511528", "parentId": "511500"},
    {"label": "屏山县", "value": "511529", "parentId": "511500"},
    {"label": "广安市", "value": "511600", "parentId": "510000"},
    {"label": "市辖区", "value": "511601", "parentId": "511600"},
    {"label": "广安区", "value": "511602", "parentId": "511600"},
    {"label": "岳池县", "value": "511621", "parentId": "511600"},
    {"label": "武胜县", "value": "511622", "parentId": "511600"},
    {"label": "邻水县", "value": "511623", "parentId": "511600"},
    {"label": "华莹市", "value": "511681", "parentId": "511600"},
    {"label": "达州市", "value": "511700", "parentId": "510000"},
    {"label": "市辖区", "value": "511701", "parentId": "511700"},
    {"label": "通川区", "value": "511702", "parentId": "511700"},
    {"label": "达县", "value": "511721", "parentId": "511700"},
    {"label": "宣汉县", "value": "511722", "parentId": "511700"},
    {"label": "开江县", "value": "511723", "parentId": "511700"},
    {"label": "大竹县", "value": "511724", "parentId": "511700"},
    {"label": "渠县", "value": "511725", "parentId": "511700"},
    {"label": "万源市", "value": "511781", "parentId": "511700"},
    {"label": "雅安市", "value": "511800", "parentId": "510000"},
    {"label": "市辖区", "value": "511801", "parentId": "511800"},
    {"label": "雨城区", "value": "511802", "parentId": "511800"},
    {"label": "名山县", "value": "511821", "parentId": "511800"},
    {"label": "荥经县", "value": "511822", "parentId": "511800"},
    {"label": "汉源县", "value": "511823", "parentId": "511800"},
    {"label": "石棉县", "value": "511824", "parentId": "511800"},
    {"label": "天全县", "value": "511825", "parentId": "511800"},
    {"label": "芦山县", "value": "511826", "parentId": "511800"},
    {"label": "宝兴县", "value": "511827", "parentId": "511800"},
    {"label": "巴中市", "value": "511900", "parentId": "510000"},
    {"label": "市辖区", "value": "511901", "parentId": "511900"},
    {"label": "巴州区", "value": "511902", "parentId": "511900"},
    {"label": "通江县", "value": "511921", "parentId": "511900"},
    {"label": "南江县", "value": "511922", "parentId": "511900"},
    {"label": "平昌县", "value": "511923", "parentId": "511900"},
    {"label": "资阳市", "value": "512000", "parentId": "510000"},
    {"label": "市辖区", "value": "512001", "parentId": "512000"},
    {"label": "雁江区", "value": "512002", "parentId": "512000"},
    {"label": "安岳县", "value": "512021", "parentId": "512000"},
    {"label": "乐至县", "value": "512022", "parentId": "512000"},
    {"label": "简阳市", "value": "512081", "parentId": "512000"},
    {"label": "阿坝藏族羌族自治州", "value": "513200", "parentId": "510000"},
    {"label": "汶川县", "value": "513221", "parentId": "513200"},
    {"label": "理县", "value": "513222", "parentId": "513200"},
    {"label": "茂县", "value": "513223", "parentId": "513200"},
    {"label": "松潘县", "value": "513224", "parentId": "513200"},
    {"label": "九寨沟县", "value": "513225", "parentId": "513200"},
    {"label": "金川县", "value": "513226", "parentId": "513200"},
    {"label": "小金县", "value": "513227", "parentId": "513200"},
    {"label": "黑水县", "value": "513228", "parentId": "513200"},
    {"label": "马尔康县", "value": "513229", "parentId": "513200"},
    {"label": "壤塘县", "value": "513230", "parentId": "513200"},
    {"label": "阿坝县", "value": "513231", "parentId": "513200"},
    {"label": "若尔盖县", "value": "513232", "parentId": "513200"},
    {"label": "红原县", "value": "513233", "parentId": "513200"},
    {"label": "甘孜藏族自治州", "value": "513300", "parentId": "510000"},
    {"label": "康定县", "value": "513321", "parentId": "513300"},
    {"label": "泸定县", "value": "513322", "parentId": "513300"},
    {"label": "丹巴县", "value": "513323", "parentId": "513300"},
    {"label": "九龙县", "value": "513324", "parentId": "513300"},
    {"label": "雅江县", "value": "513325", "parentId": "513300"},
    {"label": "道孚县", "value": "513326", "parentId": "513300"},
    {"label": "炉霍县", "value": "513327", "parentId": "513300"},
    {"label": "甘孜县", "value": "513328", "parentId": "513300"},
    {"label": "新龙县", "value": "513329", "parentId": "513300"},
    {"label": "德格县", "value": "513330", "parentId": "513300"},
    {"label": "白玉县", "value": "513331", "parentId": "513300"},
    {"label": "石渠县", "value": "513332", "parentId": "513300"},
    {"label": "色达县", "value": "513333", "parentId": "513300"},
    {"label": "理塘县", "value": "513334", "parentId": "513300"},
    {"label": "巴塘县", "value": "513335", "parentId": "513300"},
    {"label": "乡城县", "value": "513336", "parentId": "513300"},
    {"label": "稻城县", "value": "513337", "parentId": "513300"},
    {"label": "得荣县", "value": "513338", "parentId": "513300"},
    {"label": "凉山彝族自治州", "value": "513400", "parentId": "510000"},
    {"label": "西昌市", "value": "513401", "parentId": "513400"},
    {"label": "木里藏族自治县", "value": "513422", "parentId": "513400"},
    {"label": "盐源县", "value": "513423", "parentId": "513400"},
    {"label": "德昌县", "value": "513424", "parentId": "513400"},
    {"label": "会理县", "value": "513425", "parentId": "513400"},
    {"label": "会东县", "value": "513426", "parentId": "513400"},
    {"label": "宁南县", "value": "513427", "parentId": "513400"},
    {"label": "普格县", "value": "513428", "parentId": "513400"},
    {"label": "布拖县", "value": "513429", "parentId": "513400"},
    {"label": "金阳县", "value": "513430", "parentId": "513400"},
    {"label": "昭觉县", "value": "513431", "parentId": "513400"},
    {"label": "喜德县", "value": "513432", "parentId": "513400"},
    {"label": "冕宁县", "value": "513433", "parentId": "513400"},
    {"label": "越西县", "value": "513434", "parentId": "513400"},
    {"label": "甘洛县", "value": "513435", "parentId": "513400"},
    {"label": "美姑县", "value": "513436", "parentId": "513400"},
    {"label": "雷波县", "value": "513437", "parentId": "513400"},
    {"label": "贵州省", "value": "520000", "parentId": "root"},
    {"label": "贵阳市", "value": "520100", "parentId": "520000"},
    {"label": "市辖区", "value": "520101", "parentId": "520100"},
    {"label": "南明区", "value": "520102", "parentId": "520100"},
    {"label": "云岩区", "value": "520103", "parentId": "520100"},
    {"label": "花溪区", "value": "520111", "parentId": "520100"},
    {"label": "乌当区", "value": "520112", "parentId": "520100"},
    {"label": "白云区", "value": "520113", "parentId": "520100"},
    {"label": "小河区", "value": "520114", "parentId": "520100"},
    {"label": "开阳县", "value": "520121", "parentId": "520100"},
    {"label": "息烽县", "value": "520122", "parentId": "520100"},
    {"label": "修文县", "value": "520123", "parentId": "520100"},
    {"label": "高新区", "value": "520131", "parentId": "520100"},
    {"label": "观山湖区", "value": "520132", "parentId": "520100"},
    {"label": "贵安新区", "value": "520133", "parentId": "520100"},
    {"label": "金阳新区", "value": "520134", "parentId": "520100"},
    {"label": "清镇市", "value": "520181", "parentId": "520100"},
    {"label": "六盘水市", "value": "520200", "parentId": "520000"},
    {"label": "钟山区", "value": "520201", "parentId": "520200"},
    {"label": "六枝特区", "value": "520203", "parentId": "520200"},
    {"label": "水城县", "value": "520221", "parentId": "520200"},
    {"label": "盘县", "value": "520222", "parentId": "520200"},
    {"label": "遵义市", "value": "520300", "parentId": "520000"},
    {"label": "市辖区", "value": "520301", "parentId": "520300"},
    {"label": "红花岗区", "value": "520302", "parentId": "520300"},
    {"label": "汇川区", "value": "520303", "parentId": "520300"},
    {"label": "遵义县", "value": "520321", "parentId": "520300"},
    {"label": "桐梓县", "value": "520322", "parentId": "520300"},
    {"label": "绥阳县", "value": "520323", "parentId": "520300"},
    {"label": "正安县", "value": "520324", "parentId": "520300"},
    {"label": "道真仡佬族苗族自治县", "value": "520325", "parentId": "520300"},
    {"label": "务川仡佬族苗族自治县", "value": "520326", "parentId": "520300"},
    {"label": "凤冈县", "value": "520327", "parentId": "520300"},
    {"label": "湄潭县", "value": "520328", "parentId": "520300"},
    {"label": "余庆县", "value": "520329", "parentId": "520300"},
    {"label": "习水县", "value": "520330", "parentId": "520300"},
    {"label": "赤水市", "value": "520381", "parentId": "520300"},
    {"label": "仁怀市", "value": "520382", "parentId": "520300"},
    {"label": "安顺市", "value": "520400", "parentId": "520000"},
    {"label": "市辖区", "value": "520401", "parentId": "520400"},
    {"label": "西秀区", "value": "520402", "parentId": "520400"},
    {"label": "平坝县", "value": "520421", "parentId": "520400"},
    {"label": "普定县", "value": "520422", "parentId": "520400"},
    {"label": "镇宁布依族苗族自治县", "value": "520423", "parentId": "520400"},
    {"label": "关岭布依族苗族自治县", "value": "520424", "parentId": "520400"},
    {"label": "紫云苗族布依族自治县", "value": "520425", "parentId": "520400"},
    {"label": "铜仁地区", "value": "522200", "parentId": "520000"},
    {"label": "铜仁市", "value": "522201", "parentId": "522200"},
    {"label": "江口县", "value": "522222", "parentId": "522200"},
    {"label": "玉屏侗族自治县", "value": "522223", "parentId": "522200"},
    {"label": "石阡县", "value": "522224", "parentId": "522200"},
    {"label": "思南县", "value": "522225", "parentId": "522200"},
    {"label": "印江土家族苗族自治县", "value": "522226", "parentId": "522200"},
    {"label": "德江县", "value": "522227", "parentId": "522200"},
    {"label": "沿河土家族自治县", "value": "522228", "parentId": "522200"},
    {"label": "松桃苗族自治县", "value": "522229", "parentId": "522200"},
    {"label": "万山特区", "value": "522230", "parentId": "522200"},
    {"label": "黔西南布依族苗族自治州", "value": "522300", "parentId": "520000"},
    {"label": "兴义市", "value": "522301", "parentId": "522300"},
    {"label": "兴仁县", "value": "522322", "parentId": "522300"},
    {"label": "普安县", "value": "522323", "parentId": "522300"},
    {"label": "晴隆县", "value": "522324", "parentId": "522300"},
    {"label": "贞丰县", "value": "522325", "parentId": "522300"},
    {"label": "望谟县", "value": "522326", "parentId": "522300"},
    {"label": "册亨县", "value": "522327", "parentId": "522300"},
    {"label": "安龙县", "value": "522328", "parentId": "522300"},
    {"label": "毕节地区", "value": "522400", "parentId": "520000"},
    {"label": "毕节市", "value": "522401", "parentId": "522400"},
    {"label": "大方县", "value": "522422", "parentId": "522400"},
    {"label": "黔西县", "value": "522423", "parentId": "522400"},
    {"label": "金沙县", "value": "522424", "parentId": "522400"},
    {"label": "织金县", "value": "522425", "parentId": "522400"},
    {"label": "纳雍县", "value": "522426", "parentId": "522400"},
    {"label": "威宁彝族回族苗族自治县", "value": "522427", "parentId": "522400"},
    {"label": "赫章县", "value": "522428", "parentId": "522400"},
    {"label": "黔东南苗族侗族自治州", "value": "522600", "parentId": "520000"},
    {"label": "凯里市", "value": "522601", "parentId": "522600"},
    {"label": "黄平县", "value": "522622", "parentId": "522600"},
    {"label": "施秉县", "value": "522623", "parentId": "522600"},
    {"label": "三穗县", "value": "522624", "parentId": "522600"},
    {"label": "镇远县", "value": "522625", "parentId": "522600"},
    {"label": "岑巩县", "value": "522626", "parentId": "522600"},
    {"label": "天柱县", "value": "522627", "parentId": "522600"},
    {"label": "锦屏县", "value": "522628", "parentId": "522600"},
    {"label": "剑河县", "value": "522629", "parentId": "522600"},
    {"label": "台江县", "value": "522630", "parentId": "522600"},
    {"label": "黎平县", "value": "522631", "parentId": "522600"},
    {"label": "榕江县", "value": "522632", "parentId": "522600"},
    {"label": "从江县", "value": "522633", "parentId": "522600"},
    {"label": "雷山县", "value": "522634", "parentId": "522600"},
    {"label": "麻江县", "value": "522635", "parentId": "522600"},
    {"label": "丹寨县", "value": "522636", "parentId": "522600"},
    {"label": "黔南布依族苗族自治州", "value": "522700", "parentId": "520000"},
    {"label": "都匀市", "value": "522701", "parentId": "522700"},
    {"label": "福泉市", "value": "522702", "parentId": "522700"},
    {"label": "荔波县", "value": "522722", "parentId": "522700"},
    {"label": "贵定县", "value": "522723", "parentId": "522700"},
    {"label": "瓮安县", "value": "522725", "parentId": "522700"},
    {"label": "独山县", "value": "522726", "parentId": "522700"},
    {"label": "平塘县", "value": "522727", "parentId": "522700"},
    {"label": "罗甸县", "value": "522728", "parentId": "522700"},
    {"label": "长顺县", "value": "522729", "parentId": "522700"},
    {"label": "龙里县", "value": "522730", "parentId": "522700"},
    {"label": "惠水县", "value": "522731", "parentId": "522700"},
    {"label": "三都水族自治县", "value": "522732", "parentId": "522700"},
    {"label": "云南省", "value": "530000", "parentId": "root"},
    {"label": "昆明市", "value": "530100", "parentId": "530000"},
    {"label": "市辖区", "value": "530101", "parentId": "530100"},
    {"label": "五华区", "value": "530102", "parentId": "530100"},
    {"label": "盘龙区", "value": "530103", "parentId": "530100"},
    {"label": "官渡区", "value": "530111", "parentId": "530100"},
    {"label": "西山区", "value": "530112", "parentId": "530100"},
    {"label": "东川区", "value": "530113", "parentId": "530100"},
    {"label": "呈贡县", "value": "530121", "parentId": "530100"},
    {"label": "晋宁县", "value": "530122", "parentId": "530100"},
    {"label": "富民县", "value": "530124", "parentId": "530100"},
    {"label": "宜良县", "value": "530125", "parentId": "530100"},
    {"label": "石林彝族自治县", "value": "530126", "parentId": "530100"},
    {"label": "嵩明县", "value": "530127", "parentId": "530100"},
    {"label": "禄劝彝族苗族自治县", "value": "530128", "parentId": "530100"},
    {"label": "寻甸回族彝族自治县", "value": "530129", "parentId": "530100"},
    {"label": "安宁市", "value": "530181", "parentId": "530100"},
    {"label": "曲靖市", "value": "530300", "parentId": "530000"},
    {"label": "市辖区", "value": "530301", "parentId": "530300"},
    {"label": "麒麟区", "value": "530302", "parentId": "530300"},
    {"label": "马龙县", "value": "530321", "parentId": "530300"},
    {"label": "陆良县", "value": "530322", "parentId": "530300"},
    {"label": "师宗县", "value": "530323", "parentId": "530300"},
    {"label": "罗平县", "value": "530324", "parentId": "530300"},
    {"label": "富源县", "value": "530325", "parentId": "530300"},
    {"label": "会泽县", "value": "530326", "parentId": "530300"},
    {"label": "沾益县", "value": "530328", "parentId": "530300"},
    {"label": "宣威市", "value": "530381", "parentId": "530300"},
    {"label": "玉溪市", "value": "530400", "parentId": "530000"},
    {"label": "市辖区", "value": "530401", "parentId": "530400"},
    {"label": "红塔区", "value": "530402", "parentId": "530400"},
    {"label": "江川县", "value": "530421", "parentId": "530400"},
    {"label": "澄江县", "value": "530422", "parentId": "530400"},
    {"label": "通海县", "value": "530423", "parentId": "530400"},
    {"label": "华宁县", "value": "530424", "parentId": "530400"},
    {"label": "易门县", "value": "530425", "parentId": "530400"},
    {"label": "峨山彝族自治县", "value": "530426", "parentId": "530400"},
    {"label": "新平彝族傣族自治县", "value": "530427", "parentId": "530400"},
    {"label": "元江哈尼族彝族傣族自治县", "value": "530428", "parentId": "530400"},
    {"label": "保山市", "value": "530500", "parentId": "530000"},
    {"label": "市辖区", "value": "530501", "parentId": "530500"},
    {"label": "隆阳区", "value": "530502", "parentId": "530500"},
    {"label": "施甸县", "value": "530521", "parentId": "530500"},
    {"label": "腾冲县", "value": "530522", "parentId": "530500"},
    {"label": "龙陵县", "value": "530523", "parentId": "530500"},
    {"label": "昌宁县", "value": "530524", "parentId": "530500"},
    {"label": "昭通市", "value": "530600", "parentId": "530000"},
    {"label": "市辖区", "value": "530601", "parentId": "530600"},
    {"label": "昭阳区", "value": "530602", "parentId": "530600"},
    {"label": "鲁甸县", "value": "530621", "parentId": "530600"},
    {"label": "巧家县", "value": "530622", "parentId": "530600"},
    {"label": "盐津县", "value": "530623", "parentId": "530600"},
    {"label": "大关县", "value": "530624", "parentId": "530600"},
    {"label": "永善县", "value": "530625", "parentId": "530600"},
    {"label": "绥江县", "value": "530626", "parentId": "530600"},
    {"label": "镇雄县", "value": "530627", "parentId": "530600"},
    {"label": "彝良县", "value": "530628", "parentId": "530600"},
    {"label": "威信县", "value": "530629", "parentId": "530600"},
    {"label": "水富县", "value": "530630", "parentId": "530600"},
    {"label": "丽江市", "value": "530700", "parentId": "530000"},
    {"label": "市辖区", "value": "530701", "parentId": "530700"},
    {"label": "古城区", "value": "530702", "parentId": "530700"},
    {"label": "玉龙纳西族自治县", "value": "530721", "parentId": "530700"},
    {"label": "永胜县", "value": "530722", "parentId": "530700"},
    {"label": "华坪县", "value": "530723", "parentId": "530700"},
    {"label": "宁蒗彝族自治县", "value": "530724", "parentId": "530700"},
    {"label": "思茅市", "value": "530800", "parentId": "530000"},
    {"label": "市辖区", "value": "530801", "parentId": "530800"},
    {"label": "翠云区", "value": "530802", "parentId": "530800"},
    {"label": "普洱哈尼族彝族自治县", "value": "530821", "parentId": "530800"},
    {"label": "墨江哈尼族自治县", "value": "530822", "parentId": "530800"},
    {"label": "景东彝族自治县", "value": "530823", "parentId": "530800"},
    {"label": "景谷傣族彝族自治县", "value": "530824", "parentId": "530800"},
    {"label": "镇沅彝族哈尼族拉祜族自治县", "value": "530825", "parentId": "530800"},
    {"label": "江城哈尼族彝族自治县", "value": "530826", "parentId": "530800"},
    {"label": "孟连傣族拉祜族佤族自治县", "value": "530827", "parentId": "530800"},
    {"label": "澜沧拉祜族自治县", "value": "530828", "parentId": "530800"},
    {"label": "西盟佤族自治县", "value": "530829", "parentId": "530800"},
    {"label": "临沧市", "value": "530900", "parentId": "530000"},
    {"label": "市辖区", "value": "530901", "parentId": "530900"},
    {"label": "临翔区", "value": "530902", "parentId": "530900"},
    {"label": "凤庆县", "value": "530921", "parentId": "530900"},
    {"label": "云县", "value": "530922", "parentId": "530900"},
    {"label": "永德县", "value": "530923", "parentId": "530900"},
    {"label": "镇康县", "value": "530924", "parentId": "530900"},
    {"label": "双江拉祜族佤族布朗族傣族自治县", "value": "530925", "parentId": "530900"},
    {"label": "耿马傣族佤族自治县", "value": "530926", "parentId": "530900"},
    {"label": "沧源佤族自治县", "value": "530927", "parentId": "530900"},
    {"label": "楚雄彝族自治州", "value": "532300", "parentId": "530000"},
    {"label": "楚雄市", "value": "532301", "parentId": "532300"},
    {"label": "双柏县", "value": "532322", "parentId": "532300"},
    {"label": "牟定县", "value": "532323", "parentId": "532300"},
    {"label": "南华县", "value": "532324", "parentId": "532300"},
    {"label": "姚安县", "value": "532325", "parentId": "532300"},
    {"label": "大姚县", "value": "532326", "parentId": "532300"},
    {"label": "永仁县", "value": "532327", "parentId": "532300"},
    {"label": "元谋县", "value": "532328", "parentId": "532300"},
    {"label": "武定县", "value": "532329", "parentId": "532300"},
    {"label": "禄丰县", "value": "532331", "parentId": "532300"},
    {"label": "红河哈尼族彝族自治州", "value": "532500", "parentId": "530000"},
    {"label": "个旧市", "value": "532501", "parentId": "532500"},
    {"label": "开远市", "value": "532502", "parentId": "532500"},
    {"label": "蒙自县", "value": "532522", "parentId": "532500"},
    {"label": "屏边苗族自治县", "value": "532523", "parentId": "532500"},
    {"label": "建水县", "value": "532524", "parentId": "532500"},
    {"label": "石屏县", "value": "532525", "parentId": "532500"},
    {"label": "弥勒县", "value": "532526", "parentId": "532500"},
    {"label": "泸西县", "value": "532527", "parentId": "532500"},
    {"label": "元阳县", "value": "532528", "parentId": "532500"},
    {"label": "红河县", "value": "532529", "parentId": "532500"},
    {"label": "金平苗族瑶族傣族自治县", "value": "532530", "parentId": "532500"},
    {"label": "绿春县", "value": "532531", "parentId": "532500"},
    {"label": "河口瑶族自治县", "value": "532532", "parentId": "532500"},
    {"label": "文山壮族苗族自治州", "value": "532600", "parentId": "530000"},
    {"label": "文山县", "value": "532621", "parentId": "532600"},
    {"label": "砚山县", "value": "532622", "parentId": "532600"},
    {"label": "西畴县", "value": "532623", "parentId": "532600"},
    {"label": "麻栗坡县", "value": "532624", "parentId": "532600"},
    {"label": "马关县", "value": "532625", "parentId": "532600"},
    {"label": "丘北县", "value": "532626", "parentId": "532600"},
    {"label": "广南县", "value": "532627", "parentId": "532600"},
    {"label": "富宁县", "value": "532628", "parentId": "532600"},
    {"label": "西双版纳傣族自治州", "value": "532800", "parentId": "530000"},
    {"label": "景洪市", "value": "532801", "parentId": "532800"},
    {"label": "勐海县", "value": "532822", "parentId": "532800"},
    {"label": "勐腊县", "value": "532823", "parentId": "532800"},
    {"label": "大理白族自治州", "value": "532900", "parentId": "530000"},
    {"label": "大理市", "value": "532901", "parentId": "532900"},
    {"label": "漾濞彝族自治县", "value": "532922", "parentId": "532900"},
    {"label": "祥云县", "value": "532923", "parentId": "532900"},
    {"label": "宾川县", "value": "532924", "parentId": "532900"},
    {"label": "弥渡县", "value": "532925", "parentId": "532900"},
    {"label": "南涧彝族自治县", "value": "532926", "parentId": "532900"},
    {"label": "巍山彝族回族自治县", "value": "532927", "parentId": "532900"},
    {"label": "永平县", "value": "532928", "parentId": "532900"},
    {"label": "云龙县", "value": "532929", "parentId": "532900"},
    {"label": "洱源县", "value": "532930", "parentId": "532900"},
    {"label": "剑川县", "value": "532931", "parentId": "532900"},
    {"label": "鹤庆县", "value": "532932", "parentId": "532900"},
    {"label": "德宏傣族景颇族自治州", "value": "533100", "parentId": "530000"},
    {"label": "瑞丽市", "value": "533102", "parentId": "533100"},
    {"label": "潞西市", "value": "533103", "parentId": "533100"},
    {"label": "梁河县", "value": "533122", "parentId": "533100"},
    {"label": "盈江县", "value": "533123", "parentId": "533100"},
    {"label": "陇川县", "value": "533124", "parentId": "533100"},
    {"label": "怒江傈僳族自治州", "value": "533300", "parentId": "530000"},
    {"label": "泸水县", "value": "533321", "parentId": "533300"},
    {"label": "福贡县", "value": "533323", "parentId": "533300"},
    {"label": "贡山独龙族怒族自治县", "value": "533324", "parentId": "533300"},
    {"label": "兰坪白族普米族自治县", "value": "533325", "parentId": "533300"},
    {"label": "迪庆藏族自治州", "value": "533400", "parentId": "530000"},
    {"label": "香格里拉县", "value": "533421", "parentId": "533400"},
    {"label": "德钦县", "value": "533422", "parentId": "533400"},
    {"label": "维西傈僳族自治县", "value": "533423", "parentId": "533400"},
    {"label": "西藏自治区", "value": "540000", "parentId": "root"},
    {"label": "拉萨市", "value": "540100", "parentId": "540000"},
    {"label": "市辖区", "value": "540101", "parentId": "540100"},
    {"label": "城关区", "value": "540102", "parentId": "540100"},
    {"label": "林周县", "value": "540121", "parentId": "540100"},
    {"label": "当雄县", "value": "540122", "parentId": "540100"},
    {"label": "尼木县", "value": "540123", "parentId": "540100"},
    {"label": "曲水县", "value": "540124", "parentId": "540100"},
    {"label": "堆龙德庆县", "value": "540125", "parentId": "540100"},
    {"label": "达孜县", "value": "540126", "parentId": "540100"},
    {"label": "墨竹工卡县", "value": "540127", "parentId": "540100"},
    {"label": "昌都地区", "value": "542100", "parentId": "540000"},
    {"label": "昌都县", "value": "542121", "parentId": "542100"},
    {"label": "江达县", "value": "542122", "parentId": "542100"},
    {"label": "贡觉县", "value": "542123", "parentId": "542100"},
    {"label": "类乌齐县", "value": "542124", "parentId": "542100"},
    {"label": "丁青县", "value": "542125", "parentId": "542100"},
    {"label": "察雅县", "value": "542126", "parentId": "542100"},
    {"label": "八宿县", "value": "542127", "parentId": "542100"},
    {"label": "左贡县", "value": "542128", "parentId": "542100"},
    {"label": "芒康县", "value": "542129", "parentId": "542100"},
    {"label": "洛隆县", "value": "542132", "parentId": "542100"},
    {"label": "边坝县", "value": "542133", "parentId": "542100"},
    {"label": "山南地区", "value": "542200", "parentId": "540000"},
    {"label": "乃东县", "value": "542221", "parentId": "542200"},
    {"label": "扎囊县", "value": "542222", "parentId": "542200"},
    {"label": "贡嘎县", "value": "542223", "parentId": "542200"},
    {"label": "桑日县", "value": "542224", "parentId": "542200"},
    {"label": "琼结县", "value": "542225", "parentId": "542200"},
    {"label": "曲松县", "value": "542226", "parentId": "542200"},
    {"label": "措美县", "value": "542227", "parentId": "542200"},
    {"label": "洛扎县", "value": "542228", "parentId": "542200"},
    {"label": "加查县", "value": "542229", "parentId": "542200"},
    {"label": "隆子县", "value": "542231", "parentId": "542200"},
    {"label": "错那县", "value": "542232", "parentId": "542200"},
    {"label": "浪卡子县", "value": "542233", "parentId": "542200"},
    {"label": "日喀则地区", "value": "542300", "parentId": "540000"},
    {"label": "日喀则市", "value": "542301", "parentId": "542300"},
    {"label": "南木林县", "value": "542322", "parentId": "542300"},
    {"label": "江孜县", "value": "542323", "parentId": "542300"},
    {"label": "定日县", "value": "542324", "parentId": "542300"},
    {"label": "萨迦县", "value": "542325", "parentId": "542300"},
    {"label": "拉孜县", "value": "542326", "parentId": "542300"},
    {"label": "昂仁县", "value": "542327", "parentId": "542300"},
    {"label": "谢通门县", "value": "542328", "parentId": "542300"},
    {"label": "白朗县", "value": "542329", "parentId": "542300"},
    {"label": "仁布县", "value": "542330", "parentId": "542300"},
    {"label": "康马县", "value": "542331", "parentId": "542300"},
    {"label": "定结县", "value": "542332", "parentId": "542300"},
    {"label": "仲巴县", "value": "542333", "parentId": "542300"},
    {"label": "亚东县", "value": "542334", "parentId": "542300"},
    {"label": "吉隆县", "value": "542335", "parentId": "542300"},
    {"label": "聂拉木县", "value": "542336", "parentId": "542300"},
    {"label": "萨嘎县", "value": "542337", "parentId": "542300"},
    {"label": "岗巴县", "value": "542338", "parentId": "542300"},
    {"label": "那曲地区", "value": "542400", "parentId": "540000"},
    {"label": "那曲县", "value": "542421", "parentId": "542400"},
    {"label": "嘉黎县", "value": "542422", "parentId": "542400"},
    {"label": "比如县", "value": "542423", "parentId": "542400"},
    {"label": "聂荣县", "value": "542424", "parentId": "542400"},
    {"label": "安多县", "value": "542425", "parentId": "542400"},
    {"label": "申扎县", "value": "542426", "parentId": "542400"},
    {"label": "索县", "value": "542427", "parentId": "542400"},
    {"label": "班戈县", "value": "542428", "parentId": "542400"},
    {"label": "巴青县", "value": "542429", "parentId": "542400"},
    {"label": "尼玛县", "value": "542430", "parentId": "542400"},
    {"label": "阿里地区", "value": "542500", "parentId": "540000"},
    {"label": "普兰县", "value": "542521", "parentId": "542500"},
    {"label": "札达县", "value": "542522", "parentId": "542500"},
    {"label": "噶尔县", "value": "542523", "parentId": "542500"},
    {"label": "日土县", "value": "542524", "parentId": "542500"},
    {"label": "革吉县", "value": "542525", "parentId": "542500"},
    {"label": "改则县", "value": "542526", "parentId": "542500"},
    {"label": "措勤县", "value": "542527", "parentId": "542500"},
    {"label": "林芝地区", "value": "542600", "parentId": "540000"},
    {"label": "林芝县", "value": "542621", "parentId": "542600"},
    {"label": "工布江达县", "value": "542622", "parentId": "542600"},
    {"label": "米林县", "value": "542623", "parentId": "542600"},
    {"label": "墨脱县", "value": "542624", "parentId": "542600"},
    {"label": "波密县", "value": "542625", "parentId": "542600"},
    {"label": "察隅县", "value": "542626", "parentId": "542600"},
    {"label": "朗县", "value": "542627", "parentId": "542600"},
    {"label": "陕西省", "value": "610000", "parentId": "root"},
    {"label": "西安市", "value": "610100", "parentId": "610000"},
    {"label": "市辖区", "value": "610101", "parentId": "610100"},
    {"label": "新城区", "value": "610102", "parentId": "610100"},
    {"label": "碑林区", "value": "610103", "parentId": "610100"},
    {"label": "莲湖区", "value": "610104", "parentId": "610100"},
    {"label": "灞桥区", "value": "610111", "parentId": "610100"},
    {"label": "未央区", "value": "610112", "parentId": "610100"},
    {"label": "雁塔区", "value": "610113", "parentId": "610100"},
    {"label": "阎良区", "value": "610114", "parentId": "610100"},
    {"label": "临潼区", "value": "610115", "parentId": "610100"},
    {"label": "长安区", "value": "610116", "parentId": "610100"},
    {"label": "蓝田县", "value": "610122", "parentId": "610100"},
    {"label": "周至县", "value": "610124", "parentId": "610100"},
    {"label": "户县", "value": "610125", "parentId": "610100"},
    {"label": "高陵县", "value": "610126", "parentId": "610100"},
    {"label": "铜川市", "value": "610200", "parentId": "610000"},
    {"label": "市辖区", "value": "610201", "parentId": "610200"},
    {"label": "王益区", "value": "610202", "parentId": "610200"},
    {"label": "印台区", "value": "610203", "parentId": "610200"},
    {"label": "耀州区", "value": "610204", "parentId": "610200"},
    {"label": "宜君县", "value": "610222", "parentId": "610200"},
    {"label": "宝鸡市", "value": "610300", "parentId": "610000"},
    {"label": "市辖区", "value": "610301", "parentId": "610300"},
    {"label": "渭滨区", "value": "610302", "parentId": "610300"},
    {"label": "金台区", "value": "610303", "parentId": "610300"},
    {"label": "陈仓区", "value": "610304", "parentId": "610300"},
    {"label": "凤翔县", "value": "610322", "parentId": "610300"},
    {"label": "岐山县", "value": "610323", "parentId": "610300"},
    {"label": "扶风县", "value": "610324", "parentId": "610300"},
    {"label": "眉县", "value": "610326", "parentId": "610300"},
    {"label": "陇县", "value": "610327", "parentId": "610300"},
    {"label": "千阳县", "value": "610328", "parentId": "610300"},
    {"label": "麟游县", "value": "610329", "parentId": "610300"},
    {"label": "凤县", "value": "610330", "parentId": "610300"},
    {"label": "太白县", "value": "610331", "parentId": "610300"},
    {"label": "咸阳市", "value": "610400", "parentId": "610000"},
    {"label": "市辖区", "value": "610401", "parentId": "610400"},
    {"label": "秦都区", "value": "610402", "parentId": "610400"},
    {"label": "杨凌区", "value": "610403", "parentId": "610400"},
    {"label": "渭城区", "value": "610404", "parentId": "610400"},
    {"label": "三原县", "value": "610422", "parentId": "610400"},
    {"label": "泾阳县", "value": "610423", "parentId": "610400"},
    {"label": "乾县", "value": "610424", "parentId": "610400"},
    {"label": "礼泉县", "value": "610425", "parentId": "610400"},
    {"label": "永寿县", "value": "610426", "parentId": "610400"},
    {"label": "彬县", "value": "610427", "parentId": "610400"},
    {"label": "长武县", "value": "610428", "parentId": "610400"},
    {"label": "旬邑县", "value": "610429", "parentId": "610400"},
    {"label": "淳化县", "value": "610430", "parentId": "610400"},
    {"label": "武功县", "value": "610431", "parentId": "610400"},
    {"label": "兴平市", "value": "610481", "parentId": "610400"},
    {"label": "渭南市", "value": "610500", "parentId": "610000"},
    {"label": "市辖区", "value": "610501", "parentId": "610500"},
    {"label": "临渭区", "value": "610502", "parentId": "610500"},
    {"label": "华县", "value": "610521", "parentId": "610500"},
    {"label": "潼关县", "value": "610522", "parentId": "610500"},
    {"label": "大荔县", "value": "610523", "parentId": "610500"},
    {"label": "合阳县", "value": "610524", "parentId": "610500"},
    {"label": "澄城县", "value": "610525", "parentId": "610500"},
    {"label": "蒲城县", "value": "610526", "parentId": "610500"},
    {"label": "白水县", "value": "610527", "parentId": "610500"},
    {"label": "富平县", "value": "610528", "parentId": "610500"},
    {"label": "韩城市", "value": "610581", "parentId": "610500"},
    {"label": "华阴市", "value": "610582", "parentId": "610500"},
    {"label": "延安市", "value": "610600", "parentId": "610000"},
    {"label": "市辖区", "value": "610601", "parentId": "610600"},
    {"label": "宝塔区", "value": "610602", "parentId": "610600"},
    {"label": "延长县", "value": "610621", "parentId": "610600"},
    {"label": "延川县", "value": "610622", "parentId": "610600"},
    {"label": "子长县", "value": "610623", "parentId": "610600"},
    {"label": "安塞县", "value": "610624", "parentId": "610600"},
    {"label": "志丹县", "value": "610625", "parentId": "610600"},
    {"label": "吴旗县", "value": "610626", "parentId": "610600"},
    {"label": "甘泉县", "value": "610627", "parentId": "610600"},
    {"label": "富县", "value": "610628", "parentId": "610600"},
    {"label": "洛川县", "value": "610629", "parentId": "610600"},
    {"label": "宜川县", "value": "610630", "parentId": "610600"},
    {"label": "黄龙县", "value": "610631", "parentId": "610600"},
    {"label": "黄陵县", "value": "610632", "parentId": "610600"},
    {"label": "汉中市", "value": "610700", "parentId": "610000"},
    {"label": "市辖区", "value": "610701", "parentId": "610700"},
    {"label": "汉台区", "value": "610702", "parentId": "610700"},
    {"label": "南郑县", "value": "610721", "parentId": "610700"},
    {"label": "城固县", "value": "610722", "parentId": "610700"},
    {"label": "洋县", "value": "610723", "parentId": "610700"},
    {"label": "西乡县", "value": "610724", "parentId": "610700"},
    {"label": "勉县", "value": "610725", "parentId": "610700"},
    {"label": "宁强县", "value": "610726", "parentId": "610700"},
    {"label": "略阳县", "value": "610727", "parentId": "610700"},
    {"label": "镇巴县", "value": "610728", "parentId": "610700"},
    {"label": "留坝县", "value": "610729", "parentId": "610700"},
    {"label": "佛坪县", "value": "610730", "parentId": "610700"},
    {"label": "榆林市", "value": "610800", "parentId": "610000"},
    {"label": "市辖区", "value": "610801", "parentId": "610800"},
    {"label": "榆阳区", "value": "610802", "parentId": "610800"},
    {"label": "神木县", "value": "610821", "parentId": "610800"},
    {"label": "府谷县", "value": "610822", "parentId": "610800"},
    {"label": "横山县", "value": "610823", "parentId": "610800"},
    {"label": "靖边县", "value": "610824", "parentId": "610800"},
    {"label": "定边县", "value": "610825", "parentId": "610800"},
    {"label": "绥德县", "value": "610826", "parentId": "610800"},
    {"label": "米脂县", "value": "610827", "parentId": "610800"},
    {"label": "佳县", "value": "610828", "parentId": "610800"},
    {"label": "吴堡县", "value": "610829", "parentId": "610800"},
    {"label": "清涧县", "value": "610830", "parentId": "610800"},
    {"label": "子洲县", "value": "610831", "parentId": "610800"},
    {"label": "安康市", "value": "610900", "parentId": "610000"},
    {"label": "市辖区", "value": "610901", "parentId": "610900"},
    {"label": "汉滨区", "value": "610902", "parentId": "610900"},
    {"label": "汉阴县", "value": "610921", "parentId": "610900"},
    {"label": "石泉县", "value": "610922", "parentId": "610900"},
    {"label": "宁陕县", "value": "610923", "parentId": "610900"},
    {"label": "紫阳县", "value": "610924", "parentId": "610900"},
    {"label": "岚皋县", "value": "610925", "parentId": "610900"},
    {"label": "平利县", "value": "610926", "parentId": "610900"},
    {"label": "镇坪县", "value": "610927", "parentId": "610900"},
    {"label": "旬阳县", "value": "610928", "parentId": "610900"},
    {"label": "白河县", "value": "610929", "parentId": "610900"},
    {"label": "商洛市", "value": "611000", "parentId": "610000"},
    {"label": "市辖区", "value": "611001", "parentId": "611000"},
    {"label": "商州区", "value": "611002", "parentId": "611000"},
    {"label": "洛南县", "value": "611021", "parentId": "611000"},
    {"label": "丹凤县", "value": "611022", "parentId": "611000"},
    {"label": "商南县", "value": "611023", "parentId": "611000"},
    {"label": "山阳县", "value": "611024", "parentId": "611000"},
    {"label": "镇安县", "value": "611025", "parentId": "611000"},
    {"label": "柞水县", "value": "611026", "parentId": "611000"},
    {"label": "甘肃省", "value": "620000", "parentId": "root"},
    {"label": "兰州市", "value": "620100", "parentId": "620000"},
    {"label": "市辖区", "value": "620101", "parentId": "620100"},
    {"label": "城关区", "value": "620102", "parentId": "620100"},
    {"label": "七里河区", "value": "620103", "parentId": "620100"},
    {"label": "西固区", "value": "620104", "parentId": "620100"},
    {"label": "安宁区", "value": "620105", "parentId": "620100"},
    {"label": "红古区", "value": "620111", "parentId": "620100"},
    {"label": "永登县", "value": "620121", "parentId": "620100"},
    {"label": "皋兰县", "value": "620122", "parentId": "620100"},
    {"label": "榆中县", "value": "620123", "parentId": "620100"},
    {"label": "嘉峪关市", "value": "620200", "parentId": "620000"},
    {"label": "市辖区", "value": "620201", "parentId": "620200"},
    {"label": "金昌市", "value": "620300", "parentId": "620000"},
    {"label": "市辖区", "value": "620301", "parentId": "620300"},
    {"label": "金川区", "value": "620302", "parentId": "620300"},
    {"label": "永昌县", "value": "620321", "parentId": "620300"},
    {"label": "白银市", "value": "620400", "parentId": "620000"},
    {"label": "市辖区", "value": "620401", "parentId": "620400"},
    {"label": "白银区", "value": "620402", "parentId": "620400"},
    {"label": "平川区", "value": "620403", "parentId": "620400"},
    {"label": "靖远县", "value": "620421", "parentId": "620400"},
    {"label": "会宁县", "value": "620422", "parentId": "620400"},
    {"label": "景泰县", "value": "620423", "parentId": "620400"},
    {"label": "天水市", "value": "620500", "parentId": "620000"},
    {"label": "市辖区", "value": "620501", "parentId": "620500"},
    {"label": "秦城区", "value": "620502", "parentId": "620500"},
    {"label": "北道区", "value": "620503", "parentId": "620500"},
    {"label": "清水县", "value": "620521", "parentId": "620500"},
    {"label": "秦安县", "value": "620522", "parentId": "620500"},
    {"label": "甘谷县", "value": "620523", "parentId": "620500"},
    {"label": "武山县", "value": "620524", "parentId": "620500"},
    {"label": "张家川回族自治县", "value": "620525", "parentId": "620500"},
    {"label": "武威市", "value": "620600", "parentId": "620000"},
    {"label": "市辖区", "value": "620601", "parentId": "620600"},
    {"label": "凉州区", "value": "620602", "parentId": "620600"},
    {"label": "民勤县", "value": "620621", "parentId": "620600"},
    {"label": "古浪县", "value": "620622", "parentId": "620600"},
    {"label": "天祝藏族自治县", "value": "620623", "parentId": "620600"},
    {"label": "张掖市", "value": "620700", "parentId": "620000"},
    {"label": "市辖区", "value": "620701", "parentId": "620700"},
    {"label": "甘州区", "value": "620702", "parentId": "620700"},
    {"label": "肃南裕固族自治县", "value": "620721", "parentId": "620700"},
    {"label": "民乐县", "value": "620722", "parentId": "620700"},
    {"label": "临泽县", "value": "620723", "parentId": "620700"},
    {"label": "高台县", "value": "620724", "parentId": "620700"},
    {"label": "山丹县", "value": "620725", "parentId": "620700"},
    {"label": "平凉市", "value": "620800", "parentId": "620000"},
    {"label": "市辖区", "value": "620801", "parentId": "620800"},
    {"label": "崆峒区", "value": "620802", "parentId": "620800"},
    {"label": "泾川县", "value": "620821", "parentId": "620800"},
    {"label": "灵台县", "value": "620822", "parentId": "620800"},
    {"label": "崇信县", "value": "620823", "parentId": "620800"},
    {"label": "华亭县", "value": "620824", "parentId": "620800"},
    {"label": "庄浪县", "value": "620825", "parentId": "620800"},
    {"label": "静宁县", "value": "620826", "parentId": "620800"},
    {"label": "酒泉市", "value": "620900", "parentId": "620000"},
    {"label": "市辖区", "value": "620901", "parentId": "620900"},
    {"label": "肃州区", "value": "620902", "parentId": "620900"},
    {"label": "金塔县", "value": "620921", "parentId": "620900"},
    {"label": "安西县", "value": "620922", "parentId": "620900"},
    {"label": "肃北蒙古族自治县", "value": "620923", "parentId": "620900"},
    {"label": "阿克塞哈萨克族自治县", "value": "620924", "parentId": "620900"},
    {"label": "玉门市", "value": "620981", "parentId": "620900"},
    {"label": "敦煌市", "value": "620982", "parentId": "620900"},
    {"label": "庆阳市", "value": "621000", "parentId": "620000"},
    {"label": "市辖区", "value": "621001", "parentId": "621000"},
    {"label": "西峰区", "value": "621002", "parentId": "621000"},
    {"label": "庆城县", "value": "621021", "parentId": "621000"},
    {"label": "环县", "value": "621022", "parentId": "621000"},
    {"label": "华池县", "value": "621023", "parentId": "621000"},
    {"label": "合水县", "value": "621024", "parentId": "621000"},
    {"label": "正宁县", "value": "621025", "parentId": "621000"},
    {"label": "宁县", "value": "621026", "parentId": "621000"},
    {"label": "镇原县", "value": "621027", "parentId": "621000"},
    {"label": "定西市", "value": "621100", "parentId": "620000"},
    {"label": "市辖区", "value": "621101", "parentId": "621100"},
    {"label": "安定区", "value": "621102", "parentId": "621100"},
    {"label": "通渭县", "value": "621121", "parentId": "621100"},
    {"label": "陇西县", "value": "621122", "parentId": "621100"},
    {"label": "渭源县", "value": "621123", "parentId": "621100"},
    {"label": "临洮县", "value": "621124", "parentId": "621100"},
    {"label": "漳县", "value": "621125", "parentId": "621100"},
    {"label": "岷县", "value": "621126", "parentId": "621100"},
    {"label": "陇南市", "value": "621200", "parentId": "620000"},
    {"label": "市辖区", "value": "621201", "parentId": "621200"},
    {"label": "武都区", "value": "621202", "parentId": "621200"},
    {"label": "成县", "value": "621221", "parentId": "621200"},
    {"label": "文县", "value": "621222", "parentId": "621200"},
    {"label": "宕昌县", "value": "621223", "parentId": "621200"},
    {"label": "康县", "value": "621224", "parentId": "621200"},
    {"label": "西和县", "value": "621225", "parentId": "621200"},
    {"label": "礼县", "value": "621226", "parentId": "621200"},
    {"label": "徽县", "value": "621227", "parentId": "621200"},
    {"label": "两当县", "value": "621228", "parentId": "621200"},
    {"label": "临夏回族自治州", "value": "622900", "parentId": "620000"},
    {"label": "临夏市", "value": "622901", "parentId": "622900"},
    {"label": "临夏县", "value": "622921", "parentId": "622900"},
    {"label": "康乐县", "value": "622922", "parentId": "622900"},
    {"label": "永靖县", "value": "622923", "parentId": "622900"},
    {"label": "广河县", "value": "622924", "parentId": "622900"},
    {"label": "和政县", "value": "622925", "parentId": "622900"},
    {"label": "东乡族自治县", "value": "622926", "parentId": "622900"},
    {"label": "积石山保安族东乡族撒拉族自治县", "value": "622927", "parentId": "622900"},
    {"label": "甘南藏族自治州", "value": "623000", "parentId": "620000"},
    {"label": "合作市", "value": "623001", "parentId": "623000"},
    {"label": "临潭县", "value": "623021", "parentId": "623000"},
    {"label": "卓尼县", "value": "623022", "parentId": "623000"},
    {"label": "舟曲县", "value": "623023", "parentId": "623000"},
    {"label": "迭部县", "value": "623024", "parentId": "623000"},
    {"label": "玛曲县", "value": "623025", "parentId": "623000"},
    {"label": "碌曲县", "value": "623026", "parentId": "623000"},
    {"label": "夏河县", "value": "623027", "parentId": "623000"},
    {"label": "青海省", "value": "630000", "parentId": "root"},
    {"label": "西宁市", "value": "630100", "parentId": "630000"},
    {"label": "市辖区", "value": "630101", "parentId": "630100"},
    {"label": "城东区", "value": "630102", "parentId": "630100"},
    {"label": "城中区", "value": "630103", "parentId": "630100"},
    {"label": "城西区", "value": "630104", "parentId": "630100"},
    {"label": "城北区", "value": "630105", "parentId": "630100"},
    {"label": "大通回族土族自治县", "value": "630121", "parentId": "630100"},
    {"label": "湟中县", "value": "630122", "parentId": "630100"},
    {"label": "湟源县", "value": "630123", "parentId": "630100"},
    {"label": "海东地区", "value": "632100", "parentId": "630000"},
    {"label": "平安县", "value": "632121", "parentId": "632100"},
    {"label": "民和回族土族自治县", "value": "632122", "parentId": "632100"},
    {"label": "乐都县", "value": "632123", "parentId": "632100"},
    {"label": "互助土族自治县", "value": "632126", "parentId": "632100"},
    {"label": "化隆回族自治县", "value": "632127", "parentId": "632100"},
    {"label": "循化撒拉族自治县", "value": "632128", "parentId": "632100"},
    {"label": "海北藏族自治州", "value": "632200", "parentId": "630000"},
    {"label": "门源回族自治县", "value": "632221", "parentId": "632200"},
    {"label": "祁连县", "value": "632222", "parentId": "632200"},
    {"label": "海晏县", "value": "632223", "parentId": "632200"},
    {"label": "刚察县", "value": "632224", "parentId": "632200"},
    {"label": "黄南藏族自治州", "value": "632300", "parentId": "630000"},
    {"label": "同仁县", "value": "632321", "parentId": "632300"},
    {"label": "尖扎县", "value": "632322", "parentId": "632300"},
    {"label": "泽库县", "value": "632323", "parentId": "632300"},
    {"label": "河南蒙古族自治县", "value": "632324", "parentId": "632300"},
    {"label": "海南藏族自治州", "value": "632500", "parentId": "630000"},
    {"label": "共和县", "value": "632521", "parentId": "632500"},
    {"label": "同德县", "value": "632522", "parentId": "632500"},
    {"label": "贵德县", "value": "632523", "parentId": "632500"},
    {"label": "兴海县", "value": "632524", "parentId": "632500"},
    {"label": "贵南县", "value": "632525", "parentId": "632500"},
    {"label": "果洛藏族自治州", "value": "632600", "parentId": "630000"},
    {"label": "玛沁县", "value": "632621", "parentId": "632600"},
    {"label": "班玛县", "value": "632622", "parentId": "632600"},
    {"label": "甘德县", "value": "632623", "parentId": "632600"},
    {"label": "达日县", "value": "632624", "parentId": "632600"},
    {"label": "久治县", "value": "632625", "parentId": "632600"},
    {"label": "玛多县", "value": "632626", "parentId": "632600"},
    {"label": "玉树藏族自治州", "value": "632700", "parentId": "630000"},
    {"label": "玉树县", "value": "632721", "parentId": "632700"},
    {"label": "杂多县", "value": "632722", "parentId": "632700"},
    {"label": "称多县", "value": "632723", "parentId": "632700"},
    {"label": "治多县", "value": "632724", "parentId": "632700"},
    {"label": "囊谦县", "value": "632725", "parentId": "632700"},
    {"label": "曲麻莱县", "value": "632726", "parentId": "632700"},
    {"label": "海西蒙古族藏族自治州", "value": "632800", "parentId": "630000"},
    {"label": "格尔木市", "value": "632801", "parentId": "632800"},
    {"label": "德令哈市", "value": "632802", "parentId": "632800"},
    {"label": "乌兰县", "value": "632821", "parentId": "632800"},
    {"label": "都兰县", "value": "632822", "parentId": "632800"},
    {"label": "天峻县", "value": "632823", "parentId": "632800"},
    {"label": "宁夏回族自治区", "value": "640000", "parentId": "root"},
    {"label": "银川市", "value": "640100", "parentId": "640000"},
    {"label": "市辖区", "value": "640101", "parentId": "640100"},
    {"label": "兴庆区", "value": "640104", "parentId": "640100"},
    {"label": "西夏区", "value": "640105", "parentId": "640100"},
    {"label": "金凤区", "value": "640106", "parentId": "640100"},
    {"label": "永宁县", "value": "640121", "parentId": "640100"},
    {"label": "贺兰县", "value": "640122", "parentId": "640100"},
    {"label": "灵武市", "value": "640181", "parentId": "640100"},
    {"label": "石嘴山市", "value": "640200", "parentId": "640000"},
    {"label": "市辖区", "value": "640201", "parentId": "640200"},
    {"label": "大武口区", "value": "640202", "parentId": "640200"},
    {"label": "惠农区", "value": "640205", "parentId": "640200"},
    {"label": "平罗县", "value": "640221", "parentId": "640200"},
    {"label": "吴忠市", "value": "640300", "parentId": "640000"},
    {"label": "市辖区", "value": "640301", "parentId": "640300"},
    {"label": "利通区", "value": "640302", "parentId": "640300"},
    {"label": "盐池县", "value": "640323", "parentId": "640300"},
    {"label": "同心县", "value": "640324", "parentId": "640300"},
    {"label": "青铜峡市", "value": "640381", "parentId": "640300"},
    {"label": "固原市", "value": "640400", "parentId": "640000"},
    {"label": "市辖区", "value": "640401", "parentId": "640400"},
    {"label": "原州区", "value": "640402", "parentId": "640400"},
    {"label": "西吉县", "value": "640422", "parentId": "640400"},
    {"label": "隆德县", "value": "640423", "parentId": "640400"},
    {"label": "泾源县", "value": "640424", "parentId": "640400"},
    {"label": "彭阳县", "value": "640425", "parentId": "640400"},
    {"label": "中卫市", "value": "640500", "parentId": "640000"},
    {"label": "市辖区", "value": "640501", "parentId": "640500"},
    {"label": "沙坡头区", "value": "640502", "parentId": "640500"},
    {"label": "中宁县", "value": "640521", "parentId": "640500"},
    {"label": "海原县", "value": "640522", "parentId": "640500"},
    {"label": "新疆维吾尔自治区", "value": "650000", "parentId": "root"},
    {"label": "乌鲁木齐市", "value": "650100", "parentId": "650000"},
    {"label": "市辖区", "value": "650101", "parentId": "650100"},
    {"label": "天山区", "value": "650102", "parentId": "650100"},
    {"label": "沙依巴克区", "value": "650103", "parentId": "650100"},
    {"label": "新市区", "value": "650104", "parentId": "650100"},
    {"label": "水磨沟区", "value": "650105", "parentId": "650100"},
    {"label": "头屯河区", "value": "650106", "parentId": "650100"},
    {"label": "达坂城区", "value": "650107", "parentId": "650100"},
    {"label": "东山区", "value": "650108", "parentId": "650100"},
    {"label": "乌鲁木齐县", "value": "650121", "parentId": "650100"},
    {"label": "克拉玛依市", "value": "650200", "parentId": "650000"},
    {"label": "市辖区", "value": "650201", "parentId": "650200"},
    {"label": "独山子区", "value": "650202", "parentId": "650200"},
    {"label": "克拉玛依区", "value": "650203", "parentId": "650200"},
    {"label": "白碱滩区", "value": "650204", "parentId": "650200"},
    {"label": "乌尔禾区", "value": "650205", "parentId": "650200"},
    {"label": "吐鲁番地区", "value": "652100", "parentId": "650000"},
    {"label": "吐鲁番市", "value": "652101", "parentId": "652100"},
    {"label": "鄯善县", "value": "652122", "parentId": "652100"},
    {"label": "托克逊县", "value": "652123", "parentId": "652100"},
    {"label": "哈密地区", "value": "652200", "parentId": "650000"},
    {"label": "哈密市", "value": "652201", "parentId": "652200"},
    {"label": "巴里坤哈萨克自治县", "value": "652222", "parentId": "652200"},
    {"label": "伊吾县", "value": "652223", "parentId": "652200"},
    {"label": "昌吉回族自治州", "value": "652300", "parentId": "650000"},
    {"label": "昌吉市", "value": "652301", "parentId": "652300"},
    {"label": "阜康市", "value": "652302", "parentId": "652300"},
    {"label": "米泉市", "value": "652303", "parentId": "652300"},
    {"label": "呼图壁县", "value": "652323", "parentId": "652300"},
    {"label": "玛纳斯县", "value": "652324", "parentId": "652300"},
    {"label": "奇台县", "value": "652325", "parentId": "652300"},
    {"label": "吉木萨尔县", "value": "652327", "parentId": "652300"},
    {"label": "木垒哈萨克自治县", "value": "652328", "parentId": "652300"},
    {"label": "博尔塔拉蒙古自治州", "value": "652700", "parentId": "650000"},
    {"label": "博乐市", "value": "652701", "parentId": "652700"},
    {"label": "精河县", "value": "652722", "parentId": "652700"},
    {"label": "温泉县", "value": "652723", "parentId": "652700"},
    {"label": "巴音郭楞蒙古自治州", "value": "652800", "parentId": "650000"},
    {"label": "库尔勒市", "value": "652801", "parentId": "652800"},
    {"label": "轮台县", "value": "652822", "parentId": "652800"},
    {"label": "尉犁县", "value": "652823", "parentId": "652800"},
    {"label": "若羌县", "value": "652824", "parentId": "652800"},
    {"label": "且末县", "value": "652825", "parentId": "652800"},
    {"label": "焉耆回族自治县", "value": "652826", "parentId": "652800"},
    {"label": "和静县", "value": "652827", "parentId": "652800"},
    {"label": "和硕县", "value": "652828", "parentId": "652800"},
    {"label": "博湖县", "value": "652829", "parentId": "652800"},
    {"label": "阿克苏地区", "value": "652900", "parentId": "650000"},
    {"label": "阿克苏市", "value": "652901", "parentId": "652900"},
    {"label": "温宿县", "value": "652922", "parentId": "652900"},
    {"label": "库车县", "value": "652923", "parentId": "652900"},
    {"label": "沙雅县", "value": "652924", "parentId": "652900"},
    {"label": "新和县", "value": "652925", "parentId": "652900"},
    {"label": "拜城县", "value": "652926", "parentId": "652900"},
    {"label": "乌什县", "value": "652927", "parentId": "652900"},
    {"label": "阿瓦提县", "value": "652928", "parentId": "652900"},
    {"label": "柯坪县", "value": "652929", "parentId": "652900"},
    {"label": "克孜勒苏柯尔克孜自治州", "value": "653000", "parentId": "650000"},
    {"label": "阿图什市", "value": "653001", "parentId": "653000"},
    {"label": "阿克陶县", "value": "653022", "parentId": "653000"},
    {"label": "阿合奇县", "value": "653023", "parentId": "653000"},
    {"label": "乌恰县", "value": "653024", "parentId": "653000"},
    {"label": "喀什地区", "value": "653100", "parentId": "650000"},
    {"label": "喀什市", "value": "653101", "parentId": "653100"},
    {"label": "疏附县", "value": "653121", "parentId": "653100"},
    {"label": "疏勒县", "value": "653122", "parentId": "653100"},
    {"label": "英吉沙县", "value": "653123", "parentId": "653100"},
    {"label": "泽普县", "value": "653124", "parentId": "653100"},
    {"label": "莎车县", "value": "653125", "parentId": "653100"},
    {"label": "叶城县", "value": "653126", "parentId": "653100"},
    {"label": "麦盖提县", "value": "653127", "parentId": "653100"},
    {"label": "岳普湖县", "value": "653128", "parentId": "653100"},
    {"label": "伽师县", "value": "653129", "parentId": "653100"},
    {"label": "巴楚县", "value": "653130", "parentId": "653100"},
    {"label": "塔什库尔干塔吉克自治县", "value": "653131", "parentId": "653100"},
    {"label": "和田地区", "value": "653200", "parentId": "650000"},
    {"label": "和田市", "value": "653201", "parentId": "653200"},
    {"label": "和田县", "value": "653221", "parentId": "653200"},
    {"label": "墨玉县", "value": "653222", "parentId": "653200"},
    {"label": "皮山县", "value": "653223", "parentId": "653200"},
    {"label": "洛浦县", "value": "653224", "parentId": "653200"},
    {"label": "策勒县", "value": "653225", "parentId": "653200"},
    {"label": "于田县", "value": "653226", "parentId": "653200"},
    {"label": "民丰县", "value": "653227", "parentId": "653200"},
    {"label": "伊犁哈萨克自治州", "value": "654000", "parentId": "650000"},
    {"label": "伊宁市", "value": "654002", "parentId": "654000"},
    {"label": "奎屯市", "value": "654003", "parentId": "654000"},
    {"label": "伊宁县", "value": "654021", "parentId": "654000"},
    {"label": "察布查尔锡伯自治县", "value": "654022", "parentId": "654000"},
    {"label": "霍城县", "value": "654023", "parentId": "654000"},
    {"label": "巩留县", "value": "654024", "parentId": "654000"},
    {"label": "新源县", "value": "654025", "parentId": "654000"},
    {"label": "昭苏县", "value": "654026", "parentId": "654000"},
    {"label": "特克斯县", "value": "654027", "parentId": "654000"},
    {"label": "尼勒克县", "value": "654028", "parentId": "654000"},
    {"label": "塔城地区", "value": "654200", "parentId": "650000"},
    {"label": "塔城市", "value": "654201", "parentId": "654200"},
    {"label": "乌苏市", "value": "654202", "parentId": "654200"},
    {"label": "额敏县", "value": "654221", "parentId": "654200"},
    {"label": "沙湾县", "value": "654223", "parentId": "654200"},
    {"label": "托里县", "value": "654224", "parentId": "654200"},
    {"label": "裕民县", "value": "654225", "parentId": "654200"},
    {"label": "和布克赛尔蒙古自治县", "value": "654226", "parentId": "654200"},
    {"label": "阿勒泰地区", "value": "654300", "parentId": "650000"},
    {"label": "阿勒泰市", "value": "654301", "parentId": "654300"},
    {"label": "布尔津县", "value": "654321", "parentId": "654300"},
    {"label": "富蕴县", "value": "654322", "parentId": "654300"},
    {"label": "福海县", "value": "654323", "parentId": "654300"},
    {"label": "哈巴河县", "value": "654324", "parentId": "654300"},
    {"label": "青河县", "value": "654325", "parentId": "654300"},
    {"label": "吉木乃县", "value": "654326", "parentId": "654300"},
    {"label": "省直辖行政单位", "value": "659000", "parentId": "650000"},
    {"label": "石河子市", "value": "659001", "parentId": "659000"},
    {"label": "阿拉尔市", "value": "659002", "parentId": "659000"},
    {"label": "图木舒克市", "value": "659003", "parentId": "659000"},
    {"label": "五家渠市", "value": "659004", "parentId": "659000"},
    {"label": "台湾省", "value": "710000", "parentId": "root"},
    {"label": "台北", "value": "710100", "parentId": "710000"},
    {"label": "高雄", "value": "710200", "parentId": "710000"},
    {"label": "台中", "value": "710300", "parentId": "710000"},
    {"label": "花莲", "value": "710400", "parentId": "710000"},
    {"label": "基隆", "value": "710500", "parentId": "710000"},
    {"label": "嘉义", "value": "710600", "parentId": "710000"},
    {"label": "金门", "value": "710700", "parentId": "710000"},
    {"label": "连江", "value": "710800", "parentId": "710000"},
    {"label": "苗粟", "value": "710900", "parentId": "710000"},
    {"label": "南投", "value": "711000", "parentId": "710000"},
    {"label": "澎湖", "value": "711100", "parentId": "710000"},
    {"label": "屏东", "value": "711200", "parentId": "710000"},
    {"label": "台东", "value": "711300", "parentId": "710000"},
    {"label": "台南", "value": "711400", "parentId": "710000"},
    {"label": "桃园", "value": "711500", "parentId": "710000"},
    {"label": "新竹", "value": "711600", "parentId": "710000"},
    {"label": "宜兰", "value": "711700", "parentId": "710000"},
    {"label": "云林", "value": "711800", "parentId": "710000"},
    {"label": "彰化", "value": "711900", "parentId": "710000"},
    {"label": "香港", "value": "810000", "parentId": "root"},
    {"label": "香港特别行政区", "value": "810100", "parentId": "810000"},
    {"label": "澳门", "value": "820000", "parentId": "root"},
    {"label": "澳门特别行政区", "value": "820100", "parentId": "820000"},
];
const convertTreeData = (data, key) => {
    if (data) {
        let list = [];
        data.filter((val) => {
            return val.parentId === key
        }).forEach(v => {
            let item = {
                label: v.label,
                value: v.value
            }
            let children = convertTreeData(data, v.value);
            if (children.length) {
                item.children = children;
            }
            list.push(item);
        });
        return list
    } else {
        return []
    }
}
const getAreaObj = (list) => {
    let areaObj = {};
    list.forEach(v => {
        areaObj[v.value] = v.label
    })
    return areaObj;
}

export const areaTreeList = convertTreeData(areaList, 'root');
export const areaObject = getAreaObj(areaList);
